import React, { MouseEvent } from "react";
import { Link } from "react-router-dom";
import { withTranslation, WithTranslation } from "react-i18next";
import { AxiosResponse } from "axios";
import {
    SelectBox,
    NumberBox,
    TextBox,
    DateBox,
    TextArea,
    LoadIndicator,
    LoadPanel,
    Popup,
    ScrollView,
} from "devextreme-react";
import LookupService, { LookupTypeIndexes, LookupTypeItem, UnitOfMeasureTypes } from "../../services/LookupService";
import {
    SelectBoxOnValueChangedEvent,
    TextBoxOnValueChangedEvent,
    DateBoxOnValueChangedEvent,
    LookUpOnValueChangedEvent,
    NumberBoxOnValueChangedEvent,
} from "../../types/DevExtremeTypes";
import DropDownFromLookupTable from "../select/SelectBoxFromLookupTable";
import DropDownFromLookupTableDynamic from "../select/SelectBoxFromLookupTableDynamic";
import AddEditPopUpService, {
    CalculationResponse,
    Status,
    RaiseQueryFormData,
    IdentificationType,
    RoleTypes,
    BillableItemSubmitRequest,
} from "../../services/AddEditPopUpService";
import addEditPopupUtils, {
    AddEditFormData,
    itemTypes,
    BusinessEntityTaxApplicableStatus,
    BusinessEntityTypes,
    virtualBillableItemFormData,
} from "./AddEditPopUpUtilities";
import UserService, { RoleGroupNames } from "../../services/UserService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faQuestion } from "@fortawesome/pro-regular-svg-icons";
import { currencyTypeToSymbolMatrix } from "../grid/GridUtilities";
import outstandingActionsUtilities, {
    minuteLookup,
} from "../../components/Outstanding-Actions/OutstandingActionsUtilities";
import sharedUtils from "./sharedUtilities";
import LightModePageTemplate from "../page/Templates/LightModeTemplate";
import { SubServiceType, ServiceType, ChargingType } from "../../common/ServiceUtilities";
import LookupTypeListDynamic from "../select/LookupTypeListDynamic";
import billableItemUtils from "../Utility/billableItemUtils";
import { Types } from "../../services/ArtistService";
import FindAnArtistUtils from "../FindAnArtist/FindAnArtistUtils";
import notify from "devextreme/ui/notify";
import moment from "moment";
import GlobalService from "../../services/GlobalService";
import FinanceAdjustmentForm from "../../../src/components/grid/FinanceAdjustmentPopUp";
import ServiceFeeService from "../../services/ServiceFeesService";
import { resolveGuardedDependentId } from "../../common/featureFlags";
//#region props
interface AddEditFormV2Props extends WithTranslation {
    hidePopup: (isPopupVisible: boolean) => void;
    location: any;
    history: any;
    billableItemId: string;
}
//#endregion
type NullableDate = Date | null | undefined;
//#region State

// State
interface AddEditFormV2State {
    isPopupVisible: boolean;
    headerId: string;
    businessEntityTaxApplicableStatuses: BusinessEntityTaxApplicableStatus[];
    loadIndicatorVisible: boolean;
    loadPanelVisible: boolean;
    IsShowSuccess: boolean;
    IsShowError: boolean;
    IsLockBillableFields: boolean;
    IsLockTimeFields: boolean;
    IsLockQuantityFields: boolean;
    amendStatus: string;
    createAdjustment: boolean;
    configuarationValue: [];
    isProviderTaxFieldVisible: boolean;
    configurationIdIndex: string[];
    configuarationValueIndex: string[];
    isFeeTaxFieldVisible: boolean;
    isBillClientTaxFieldVisible: boolean;
    errorMessage: [];
    unitOfMeasureList: LookupTypeItem[];
    editViewDataItem: AddEditFormData;
    editViewVirtualDataItem: virtualBillableItemFormData;
    itemTypeLookUp: LookupTypeItem[];
    isTypeChanged: boolean;
    errorsAdjustment: [];
    billableStart: NullableDate;
    billableFinish: NullableDate;
    rate: number;
    quantity: number;
    billableMinutes: number;
    isLockItemTypeLU: boolean;
    itemTypeBeforeAdjustment: string;
    currenyTypeLookUp: LookupTypeItem[];
    isDisableApplyButton: boolean;
    onlyViewMessage: string[];
    acceptDate: NullableDate;
    payDate: NullableDate;
    approvalDate: NullableDate;
    billDate: NullableDate;
    isChangeLabelName: boolean;
    isCalculationMessageShown: boolean;
    calculationMessage: string[];
    isDisableStatusDropDown: boolean;
    isChangeBillableStart: boolean;
    isChangeBillableFinish: boolean;
    isChangeRate: boolean;
    isChangeQuantity: boolean;
    queryItem: RaiseQueryFormData;
    validationMessage: string;
    isHideForContract: boolean;
    isOther: boolean;
    isWeeklyCleaning: boolean;
    typeLUDisablement: boolean;
    isAdditionalCleaning: boolean;
    isLableChange: boolean;
    hours: number;
    minutes: string;
    virtualHours: number;
    virtualMinutes: string;
    prevHours: number;
    prevminutes: string;
    isChangeHour: boolean;
    isChangeMinute: boolean;
    isChangePendingToApprove: boolean;
    isShowForEntertainment: boolean;
    serviceMatrixDataSource: string[];
    loadIndicatorOnPercentageChange: boolean;
    percentageFieldChange: boolean;
    CleaningMinutesToDisplay: string;
    rateChangeTimer: any;
    multiplierChangeTimer: any;
    providerNetChangeTimer: any;
    hourChangeTimer: any;
    isSubTypeChange: boolean;
    clientLookUp: LookupTypeItem[];
    workerLookUp: LookupTypeItem[];
    venueNameLookUp: LookupTypeItem[];
    venueNoLookUp: LookupTypeItem[];
    isClientSelected: boolean;
    venueList: LookupTypeItem[];
    expectedFee: number;
    isClickedOnEdit: boolean;
    calculationMessageClassName: string;
    isLoadFinancialPanel: boolean;
    readOnlyView: boolean;
    providerOriginalAmount: number;
    clientOriginalAmount: number;
    clientOriginalAmountForFinancialAdj: number;
    isServiceTypeChange: boolean;
    isProviderAcceptance: boolean;
    isDisableRoleType: boolean;
    isShowOtherDescription: boolean;
    offeringsTypeLookup: LookupTypeItem[];
    typeLookUp: LookupTypeItem[];
    loadPopupVisible: boolean;
    isProviderNetOverride: boolean;
    isMultiplierOverride: boolean;
    providerOverrideValue: number | null | undefined;
    multiplierOverrideValue: number | undefined;
    approvalStartChangeTimer: any;
    approvalEndChangeTimer: any;
    calculationRequestSeq: number;
    isFasterPayChange: boolean;
    isArtistPayChange: boolean;
    isFasterPayProp: boolean;
    showWarningPopup: boolean;
    disabledApplybutton: boolean;
    createClientCreditPopUp: boolean;
    showReversalPopupTab1: boolean;
    showReversalPopupTab2: boolean;
    showPromotionPopUp:boolean;
    profileLookup: LookupTypeItem[];
    parentRelatedId:string;
    getGigPromotionByBillableItemId:any[]
    //isCopy:boolean;
    previouslySourced:boolean
    existingAct:boolean
}
//#endregion

// Component
class AddEditFormV2 extends React.Component<AddEditFormV2Props> {
    sharedUtils: sharedUtils;
    billableItemUtils: billableItemUtils;
    lookupService: LookupService;
    utils: addEditPopupUtils;
    findAnArtistUtils: FindAnArtistUtils;
    state: AddEditFormV2State;
    editViewService: AddEditPopUpService;
    serviceFeeService: ServiceFeeService;
    decisionTypesDataSource: LookupTypeItem[];
    nonStandardTypesDataSource: LookupTypeItem[];
    chargeTypesDataSource: LookupTypeItem[];
    absentTypeDataSource: LookupTypeItem[];
    doNotPayDataSource: LookupTypeItem[];
    doNotGroupPyDataSource:LookupTypeItem[];
    fasterPaymentDataSource: LookupTypeItem[];
    advancedPaymentDataSource: LookupTypeItem[];
    earlyPayDataSource: LookupTypeItem[];
    outStandingActionUtils: outstandingActionsUtilities;
    updateCorrectionDataSource: LookupTypeItem[];
    activityTypeDataSource: LookupTypeItem[];
    editAllowed: boolean;
    constructor(props: AddEditFormV2Props) {
        super(props);
        //#region Service Initialization
        this.outStandingActionUtils = new outstandingActionsUtilities();
        this.lookupService = new LookupService();
        this.editViewService = new AddEditPopUpService();
        this.utils = new addEditPopupUtils();
        this.findAnArtistUtils = new FindAnArtistUtils();
        this.sharedUtils = new sharedUtils();
        this.billableItemUtils = new billableItemUtils();
        this.serviceFeeService = new ServiceFeeService();
        this.decisionTypesDataSource = this.lookupService.getDecisionTypes();
        this.nonStandardTypesDataSource = this.lookupService.getNonStandardTypes();
        this.chargeTypesDataSource = this.lookupService.getChargeTypes();
        this.absentTypeDataSource = this.lookupService.getAbsentTypes();
        this.doNotPayDataSource = this.lookupService.getDoNotPayTypes();
        this.doNotGroupPyDataSource = this.lookupService.getDoNotGroupPayTypes();
        this.fasterPaymentDataSource = this.lookupService.getDecisionTypes();
        this.advancedPaymentDataSource = this.lookupService.getDecisionTypes();
        this.earlyPayDataSource = this.lookupService.getDecisionTypes();
        this.updateCorrectionDataSource = this.lookupService.getUpdateOrCorrection();
        this.activityTypeDataSource = this.lookupService.getActivityType();
        this.editAllowed = UserService.isUserInGroup(RoleGroupNames.EventUKSeniorManager) ? false:UserService.isUserInGroup(RoleGroupNames.EventUKRelationshipManager)?false : true;
        //#region Set default values to the state object
        // Initialize state
        let itemId: string = "";
        if (props.billableItemId) {
            itemId = props.billableItemId;
        } else if (props.location && props.location.state && props.location.state.id) {
            itemId = props.location.state.id.toString();
        }
        let convertedEditViewDataItem = this.utils.initializeBillableItem(itemId);
        let convertedEditViewVirtualDataItem = this.utils.initializeVirtualBillableItem(itemId);
        let convertedQueryFormData = this.utils.initializeQueryFormData(
            itemId,
            "",
            "",
            "Shift / Item Status Query",
            ""
        );
        this.state = {
            // fetching headerId from parameter
            isPopupVisible: false,
            loadIndicatorVisible: false,
            businessEntityTaxApplicableStatuses: [],
            loadPanelVisible: false,
            headerId: itemId,
            IsShowSuccess: false,
            IsShowError: false,
            IsLockBillableFields: false,
            IsLockTimeFields: false,
            IsLockQuantityFields: false,
            amendStatus: "",
            configuarationValue: [],
            configuarationValueIndex: [],
            errorMessage: [],
            configurationIdIndex: [],
            createAdjustment:
                props.location && props.location.state && props.location.state.adjustment
                    ? props.location.state.adjustment
                    : false,
            isProviderTaxFieldVisible:
                convertedEditViewDataItem.provider_Tax_Applicable &&
                convertedEditViewDataItem.provider_Tax_Applicable == "Yes"
                    ? true
                    : false,
            isFeeTaxFieldVisible:
                convertedEditViewDataItem.fee_Tax_Applicable && convertedEditViewDataItem.fee_Tax_Applicable == "Yes"
                    ? true
                    : false,
            isBillClientTaxFieldVisible:
                convertedEditViewDataItem.client_Tax_Applicable &&
                convertedEditViewDataItem.client_Tax_Applicable == "Yes"
                    ? true
                    : false,
            unitOfMeasureList: [],
            editViewDataItem: convertedEditViewDataItem,
            editViewVirtualDataItem: convertedEditViewVirtualDataItem,
            itemTypeLookUp: [],
            isTypeChanged: false,
            errorsAdjustment: [],
            billableStart: undefined,
            billableFinish: undefined,
            rate: 0,
            quantity: 0,
            billableMinutes: 0,
            isLockItemTypeLU: false,
            itemTypeBeforeAdjustment: "",
            currenyTypeLookUp: [],
            isDisableApplyButton: false,
            onlyViewMessage: [],
            acceptDate: undefined,
            payDate: undefined,
            approvalDate: undefined,
            billDate: undefined,
            isChangeLabelName: false,
            isCalculationMessageShown: false,
            calculationMessage: [],
            isDisableStatusDropDown: false,
            isChangeBillableStart: false,
            isChangeBillableFinish: false,
            isChangeRate: false,
            isChangeQuantity: false,
            validationMessage: "",
            queryItem: convertedQueryFormData,
            isHideForContract: false,
            isOther: false,
            isWeeklyCleaning: false,
            typeLUDisablement: true,
            isAdditionalCleaning: false,
            isLableChange: false,
            hours: 0,
            minutes: "00",
            virtualHours: 0,
            virtualMinutes: "00",
            prevHours: 0,
            prevminutes: "00",
            isChangeHour: false,
            isChangeMinute: false,
            isChangePendingToApprove: false,
            isShowForEntertainment: false,
            serviceMatrixDataSource: [],
            loadIndicatorOnPercentageChange: false,
            percentageFieldChange: false,
            CleaningMinutesToDisplay: "",
            rateChangeTimer: null,
            hourChangeTimer: null,
            multiplierChangeTimer: null,
            providerNetChangeTimer: null,
            isSubTypeChange: false,
            clientLookUp: [],
            venueNameLookUp: [],
            venueNoLookUp: [],
            isClientSelected: false,
            venueList: [],
            expectedFee: 0,
            isClickedOnEdit:
                this.props.location && this.props.location.state && this.props.location.state.id ? false : true,
            calculationMessageClassName: "",
            isLoadFinancialPanel: false,
            readOnlyView:
                this.props.location && this.props.location.state && this.props.location.state.isReadOnly
                    ? this.props.location.state.isReadOnly
                    : false,
            providerOriginalAmount: 0,
            clientOriginalAmount: 0,
            clientOriginalAmountForFinancialAdj: 0,
            isServiceTypeChange: false,
            isProviderAcceptance: false,
            workerLookUp: [],
            isDisableRoleType: true,
            isShowOtherDescription: false,
            offeringsTypeLookup: [],
            typeLookUp: [],
            loadPopupVisible: false,
            isProviderNetOverride: false,
            isMultiplierOverride: false,
            providerOverrideValue: null,
            multiplierOverrideValue: undefined,
            approvalStartChangeTimer: null,
            approvalEndChangeTimer: null,
            calculationRequestSeq: 0,
            isFasterPayChange: false,
            isArtistPayChange: false,
            isFasterPayProp: false,
            showWarningPopup: false,
            disabledApplybutton: false,
            createClientCreditPopUp: false,
            showReversalPopupTab1: false,
            showReversalPopupTab2: false,
            showPromotionPopUp:false,
            profileLookup: [],
            parentRelatedId:"",
            getGigPromotionByBillableItemId:[],
            //isCopy:false
            previouslySourced:false,
            existingAct:false
        };
        //#endregion
    }

    //#region 'componentDidMount and Service Call"
    componentDidMount() {
        if (this.props.billableItemId) {
            this.setState({
                loadPopupVisible: true,
            });
        }
        this.editViewDataSource();
    }

    componentDidUpdate(prevProps: Readonly<AddEditFormV2Props>, prevState: Readonly<AddEditFormV2State>): void {
        if (this.props.billableItemId != prevProps.billableItemId) {
            this.setState({ loadPopupVisible: true });
            this.editViewDataSource();
        }
        if (
            this.state.editViewDataItem.billableStatusLookupId == "" &&
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.id == 0
        ) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    billableStatusLookupId: "121",
                },
            }));
        }
        if (
            prevState.editViewDataItem.client_Billable_Amount_Local_Ccy !==
            this.state.editViewDataItem.client_Billable_Amount_Local_Ccy
        ) {
            this.setState({
                clientOriginalAmountForFinancialAdj: this.state.editViewDataItem.client_Billable_Amount_Local_Ccy,
            });
        }

        if (
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.pointOfNavigation == "MatchedPopUp" &&
            this.props.location.state.id == 0 &&
            this.props.location.state.chargingTypeId &&
            !this.state.editViewDataItem.chargingTypeId
        ) {
            const chargingTypeIdFromState = this.resolveChargingTypeIdFromPreviouslySourcedResponse({
                chargingTypeId: this.props.location.state.chargingTypeId,
            });
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    chargingTypeId: chargingTypeIdFromState,
                },
            }));
        }

        if (
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.pointOfNavigation == "MatchedPopUp" &&
            this.props.location.state.id == 0 &&
            !this.state.editViewDataItem.chargingTypeId &&
            this.state.editViewDataItem.providerId &&
            this.state.editViewDataItem.venueId &&
            (prevState.editViewDataItem.providerId !== this.state.editViewDataItem.providerId ||
                prevState.editViewDataItem.venueId !== this.state.editViewDataItem.venueId)
        ) {
            this.hasProviderBeenPreviouslySourceApiCall();
        }

    }

    retrieveFormData = () => {
        // Retrieve form data from server if an ID was provided
        let BillableId = localStorage.getItem("BillableIdFromPayment");
        if (this.state.headerId != "" || this.props.billableItemId) {
            let itemId: string = "";
            if (this.props.billableItemId) {
                itemId = this.props.billableItemId;
            } else if (this.props.location && this.props.location.state && this.props.location.state.id) {
                itemId = this.props.location.state.id;
            }
            this.editViewService
                .getEditViewData(parseInt(itemId))
                .then(this.handleSuccessViewDataSource)
                .catch(this.handleStandardError);
            this.lookupService
                .getLookupByLookupTypeIndexAll(LookupTypeIndexes.clientType)
                .then(this.handleClientLookupSuccess)
                .catch(this.handleStandardError);
            this.lookupService
                .getLookupByLookupTypeIndexAll(LookupTypeIndexes.venueType)
                .then(this.handleVenueLookupSuccess)
                .catch(this.handleStandardError);
        } else if (BillableId !== "" && BillableId !== null) {
            this.editViewService
                .getEditViewData(parseInt(BillableId))
                .then(this.handleSuccessViewDataSource)
                .catch(this.handleStandardError);
            this.lookupService
                .getLookupByLookupTypeIndexAll(LookupTypeIndexes.clientType)
                .then(this.handleClientLookupSuccess)
                .catch(this.handleStandardError);
            this.lookupService
                .getLookupByLookupTypeIndexAll(LookupTypeIndexes.venueType)
                .then(this.handleVenueLookupSuccess)
                .catch(this.handleStandardError);

            localStorage.setItem("BillableIdFromPayment", "");
        } else if (
            this.props.location.state?.pointOfNavigation == "copy_simpleshifts" &&
            this.props.location.state?.copiedBillableId
        ) {
            this.editViewService
                .getEditViewData(parseInt(this.props.location.state.copiedBillableId))
                .then(this.handleSuccessViewDataSource)
                .catch(this.handleStandardError);
            this.lookupService
                .getLookupByLookupTypeIndexAll(LookupTypeIndexes.clientType)
                .then(this.handleClientLookupSuccess)
                .catch(this.handleStandardError);
            this.lookupService
                .getLookupByLookupTypeIndexAll(LookupTypeIndexes.venueType)
                .then(this.handleVenueLookupSuccess)
                .catch(this.handleStandardError);
        } else {
            if (this.props.location && this.props.location.state && this.props.location.state.serviceTypeId) {
                this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        serviceTypeId: this.props.location.state.serviceTypeId,
                    },
                }));
            }
            if (this.props.location && this.props.location.state) {
                this.offeringsTypeDataSource(this.props.location.state.serviceTypeId);
            }
            this.setQuantityAutomaticallyBasedOnService(this.props.location?.state?.serviceTypeId);
            //as client id is mandatory for creating payment request so using that to differentiate between normal add and add from payment request
            //|| this.props.location.state.pointOfNavigation == "copy_simpleshifts"
            if (
                this.props.location &&
                this.props.location.state &&
                this.props.location.state.pointOfNavigation == "MatchedPopUp"
            ) {
                this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        billableStatusLookupId: Status.Pending,
                    },
                }));
                if (this.props.location.state.clientId) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            clientId: this.props.location.state.clientId,
                        },
                    }));
                }
                if (this.props.location && this.props.location.state && this.props.location.state.originatorId) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            originator: {
                                id: this.props.location.state.originatorId,
                                value: "",
                            },
                        },
                    }));
                }
                if (this.props.location && this.props.location.state && this.props.location.state.serviceSubTypeId) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            serviceSubTypeId: this.props.location.state.serviceSubTypeId,
                        },
                    }));
                }
                if (this.props.location && this.props.location.state && this.props.location.state.typeLookUpId) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            typeId: this.props.location.state.typeLookUpId,
                        },
                    }));
                    if (
                        this.props.location &&
                        this.props.location.state.typeLookUpValue &&
                        this.props.location.state.typeLookUpValue.toLowerCase() == "other"
                    ) {
                        if (this.props.location && this.props.location.state.otherDescription) {
                            this.setState((prevState: any) => ({
                                editViewDataItem: {
                                    ...prevState.editViewDataItem,
                                    otherDescription: this.props.location.state.otherDescription,
                                },
                            }));
                        }
                    } else {
                        if (this.props.location && this.props.location.state.internalComments) {
                            this.setState((prevState: any) => ({
                                editViewDataItem: {
                                    ...prevState.editViewDataItem,
                                    otherDescription: this.props.location.state.internalComments,
                                },
                            }));
                        }
                    }
                }
                if (this.props.location && this.props.location.state.providerId) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            providerId: this.props.location.state.providerId,
                        },
                    }));
                }
                if (this.props.location && this.props.location.state.venueId) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            venueId: this.props.location.state.venueId,
                        },
                    }));
                }
                if (this.props.location && this.props.location.state && this.props.location.state.chargingTypeId) {
                    const chargingTypeIdFromState = this.resolveChargingTypeIdFromPreviouslySourcedResponse({
                        chargingTypeId: this.props.location.state.chargingTypeId,
                    });
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            chargingTypeId: chargingTypeIdFromState,
                        },
                    }));
                }
                if (this.props.location && this.props.location.state.date) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            date: this.props.location.state.date,
                            //dateTo: this.props.location.state.date
                        },
                    }));
                }
                if (this.props.location && this.props.location.state.dateTo) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            dateTo: this.props.location.state.dateTo,
                        },
                    }));
                }
                if (
                    this.props.location &&
                    this.props.location.state.artistFee &&
                    this.props.location.state.serviceTypeId == ServiceType.Entertainment
                ) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            rate_Decimal: this.props.location.state.artistFee,
                            scheduleRate: this.props.location.state.artistFee,
                            equipmentScheduleQuantity: 1,
                        },
                    }));
                }
                if (
                    this.props.location &&
                    this.props.location.state.rate &&
                    this.props.location.state.serviceTypeId !== ServiceType.Entertainment
                ) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            rate_Decimal: this.props.location.state.rate,
                            scheduleRate: this.props.location.state.rate,
                        },
                    }));
                }
                if (this.props.location && this.props.location.state.providerPayAmountLocalExtras) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            providerPayAmountLocalExtras: this.props.location.state.providerPayAmountLocalExtras,
                        },
                    }));
                }
                if (this.props.location && this.props.location.state.providerPayAmountLocalExtrasDescription) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            providerPayAmountLocalExtrasDescription: this.props.location.state
                                .providerPayAmountLocalExtrasDescription,
                        },
                    }));
                }
                if (this.props.location && this.props.location.state.internalComments) {
                    //if(this.props.location.state.pointOfNavigation == "MatchedPopUp"){
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            shiftCompleteAcknowledgmentDescription: this.props.location.state.internalComments,
                        },
                    }));
                    // } else {
                    //     this.setState((prevState: any) => ({
                    //         editViewDataItem: {
                    //             ...prevState.editViewDataItem,
                    //             internalComments: this.props.location.state.internalComments
                    //         }
                    //     }));
                    // }
                }
                // if (this.props.location.state.pointOfNavigation == "copy_simpleshifts") {
                //     let extComments = this.props.location?.state?.externalComments || '';
                //     let otherDesc = this.props.location?.state?.otherDescription || '';
                //     //isCopy = true;
                //     this.setState((prevState: any) => ({

                //         editViewDataItem: {
                //             ...prevState.editViewDataItem,
                //             otherDescription: otherDesc,
                //             comments: extComments
                //         }
                //     }));
                // }
                if (
                    this.state.editViewDataItem.internalComments == "" &&
                    this.props.location.state?.requestType?.id == "10"
                ) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            internalComments: "Added from Payment Request",
                        },
                    }));
                }
                // if (this.props.location?.state && this.props.location?.state?.requestType?.id == "10") {
                //     this.setState((prevState: any) => ({
                //         editViewDataItem: {
                //             ...prevState.editViewDataItem,
                //             shiftCompleteAcknowledgment: this.props.location?.state?.shiftCompleteAcknowledgment,
                //             shiftCompleteAcknowledgmentDateTime: this.props.location?.state?.shiftCompleteAcknowledgmentDateTime?this.sharedUtils.convertStringToDate(
                //                 this.props.location?.state?.shiftCompleteAcknowledgmentDateTime):undefined,
                //             shiftCompleteAcknowledgmentTime: this.props.location?.state?.shiftCompleteAcknowledgmentTime ? this.sharedUtils.convertStringToTime(this.props.location?.state?.shiftCompleteAcknowledgmentTime):'',
                //         }
                //     }));
                // }
                if (
                    this.state.editViewDataItem.internalComments == "" &&
                    this.props.location.state.requestType?.id == "20"
                ) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            internalComments: "Added from Add Job",
                        },
                    }));
                }
                if (this.props.location && this.props.location.state.quantity !== 0) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            equipmentQuantity: this.props.location.state.quantity,
                        },
                    }));
                    if (this.props.location.state.serviceSubTypeId == SubServiceType.WeeklyCleaning) {
                        let quantitySubFields: string[] = this.outStandingActionUtils.splitQuantityIntoHoursMinutesFormat(
                            this.props.location.state.quantity.toString()
                        );
                        this.setState({
                            hours:
                                quantitySubFields.length > 0 && quantitySubFields[0]
                                    ? this.sharedUtils.convertStringToInt(quantitySubFields[0])
                                    : 0,
                            minutes: quantitySubFields.length > 0 && quantitySubFields[1] ? quantitySubFields[1] : "00",
                        });
                    }
                }
                if (this.props.location && this.props.location.state.fasterPayment) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            fasterPayment: this.props.location.state.fasterPayment,
                        },
                        isFasterPayProp:
                            this.props.location.state.fasterPayment == "true" ||
                            this.props.location.state.fasterPayment == "Yes"
                                ? true
                                : false,
                    }));
                }
                if (this.props.location && this.props.location.state.fasterPaymentWithdrawn) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            fasterPaymentWithdrawn: this.props.location.state.fasterPaymentWithdrawn,
                        },
                    }));
                }
                if (this.props.location && this.props.location.state.providerFasterPayFee) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            providerFasterPayFee: this.props.location.state.providerFasterPayFee,
                        },
                    }));
                }
                if (this.props.location && this.props.location.state.startTime) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            shift_Start: this.props.location.state.startTime,
                        },
                    }));
                }
                if (this.props.location && this.props.location.state.finishTime) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            shift_End: this.props.location.state.finishTime,
                        },
                    }));
                }
                // Run after the batch of editViewDataItem fields set above (clientId, serviceTypeId,
                // serviceSubTypeId, shift_Start/End, etc.) has actually committed to state — React
                // batches all the setState calls in this synchronous block into one update, so calling
                // these directly here would read the pre-load defaults instead of the loaded values.
                this.setState({}, () => {
                    this.handleMultiplierValueSelection();
                    this.selectHardApprovalHoldPaymentValue();
                    this.setFeeTaxApplicableOnInitialLoad();
                    if (this.props.location && this.props.location.state) {
                        this.setTaxApplicableStatus(this.props.location.state.clientId);
                        this.setTaxApplicableStatus(this.props.location.state.providerId);
                    }
                });
            }
            if (
                this.props.location &&
                this.props.location.state.id == 0 &&
                this.props.location.state.serviceTypeId == ServiceType.Entertainment &&
                !this.props.location.state.finishTime
            ) {
                this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        shift_End: undefined,
                    },
                }));
            }
            this.setState({
                isLoadFinancialPanel: true,
                //isCopy:isCopy
            });
            this.lookupService
                .getLookupByLookupTypeIndex(LookupTypeIndexes.clientType)
                .then(this.handleClientLookupSuccess)
                .catch(this.handleStandardError);
            this.lookupService
                .getLookupByLookupTypeIndex(LookupTypeIndexes.venueType)
                .then(this.handleVenueLookupSuccess)
                .catch(this.handleStandardError);
            this.lookupService
                .getLookupByLookupTypeIndex(LookupTypeIndexes.workerstatus)
                .then(this.handleWorkerLookupSuccess)
                .catch(this.handleStandardError);
        }
    };
    editViewDataSource = () => {
        this.lookupService
            .getLookupByLookupTypeIndex(LookupTypeIndexes.configuration)
            .then(this.handleConfigurationLookupSuccess)
            .catch(this.handleStandardError);

        this.lookupService
            .getLookupByLookupTypeIndex(LookupTypeIndexes.itemType)
            .then(this.handleSuccessItemTypeLookUp)
            .catch(this.handleStandardError);

        // Retrieve data required for a new shift
        this.editViewService
            .getTaxApplicableStatus()
            .then(this.handleTaxApplicableSuccess)
            .catch(this.handleStandardError);

        //Retrieve the status list
        if (this.props.location && this.props.location.state && this.props.location.state.isAmend) {
            this.lookupService
                .getLookupByLookupTypeIndex(LookupTypeIndexes.statusType)
                .then(this.handleSuccesStatusLookUp)
                .catch(this.handleStandardError);
        }

        this.lookupService
            .getLookupByLookupTypeIndex(LookupTypeIndexes.unitOfMeasure)
            .then(this.handleUnitOfMeasureLookupSuccess)
            .catch(this.handleStandardError);

        this.lookupService
            .getLookupByLookupTypeIndex(LookupTypeIndexes.currencytype)
            .then(this.handleCurrencyTypeLookUpSuccess)
            .catch(this.handleStandardError);
    };
    GetGigPromotionByBillableItemId=(id:string)=>{
       this.editViewService
            .GetGigPromotionByBillableItemId(id)
            .then(this.handleSuccessGetGigPromotionByBillableItemId)
            .catch(this.handleStandardError); 
    }
    offeringsTypeDataSource = (serviceTypeId: string) => {
        //retrieve the role list
        if (
            serviceTypeId == ServiceType.Entertainment ||
            serviceTypeId == ServiceType.ContractCleaning ||
            serviceTypeId == ServiceType.Gardening ||
            serviceTypeId == ServiceType.WindowCleaning
        ) {
            this.lookupService
                .getLookupByLookupTypeIndex(LookupTypeIndexes.offeringsType)
                .then(this.handleSuccesOfferingsLookUp)
                .catch(this.handleStandardError);
        }
    };

    handleSuccesOfferingsLookUp = (response: AxiosResponse<any>) => {
        let typeDropDown = this.findAnArtistUtils.lookUpCreation(response);
        this.setState(
            {
                typeLookUp: typeDropDown,
            },
            () => {
                this.filterDataSourceForRole(typeDropDown, this.state.editViewDataItem.serviceSubTypeId);
            }
        );
        if (
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.pointOfNavigation == "MatchedPopUp"
        ) {
            this.filterDataSourceForRole(typeDropDown, this.props.location.state.serviceSubTypeId);
            this.setRoleTypeOrShowOtherDesc(this.props.location.state.serviceSubTypeId);
        }
    };

    handleClientLookupSuccess = (response: AxiosResponse<any>) => {
        this.setState({
            clientLookUp: response.data.data,
        });
    };

    handleWorkerLookupSuccess = (response: AxiosResponse<any>) => {
        this.setState({
            workerLookUp: response.data.data,
        });
    };

    handleVenueLookupSuccess = (response: AxiosResponse<any>) => {
        var venueNameList = this.utils.filteredVenueNameValues(response.data.data);
        var venueNoList = this.utils.filteredVenueNoValues(response.data.data);
        this.setState({
            venueNameLookUp: venueNameList,
            venueNoLookUp: venueNoList,
            venueList: response.data.data,
        });
    };

    handleConfigurationLookupSuccess = (response: AxiosResponse<any>) => {
        var configData = this.sharedUtils.getConfigurationDataFromLookupResponse(response.data.data);
        this.setState({
            configuarationValue: response.data.data,
            configurationIdIndex: configData.id,
            configuarationValueIndex: configData.value,
        });
    };

    handleStandardError = (error: any) => {
        var respMessage: string = "Add/Edit shift form load failed with response: " + JSON.stringify(error);

        if (!this.editViewService.traceAsErrorToAppInsights(respMessage)) {
            // AppInsights is not available
            console.error(respMessage);
        }
    };
    // Handles the selection of multiplier value based on service type, provider, venue, and charging type.
    handleMultiplierValueSelection = () => {
        // Accrual and provider acceptance come from the service fee matrix whatever the charging type,
        // so set them before the charging-type branches below return early. Without this, a shift
        // opened with its values pre-filled (e.g. the MatchedPopUp route) never derives Accrual.
        const serviceFeeMatrixDerivedValues = this.billableItemUtils.serviceFeeMatrixDerivation(
            this.state.editViewDataItem.clientId,
            this.state.editViewDataItem.serviceTypeId,
            this.state.editViewDataItem.serviceSubTypeId
        );
        this.setState((prevState: Readonly<AddEditFormV2State>) => ({
            editViewDataItem: {
                ...prevState.editViewDataItem,
                isAccrual: serviceFeeMatrixDerivedValues.valueOfAccrual,
            },
            isProviderAcceptance: serviceFeeMatrixDerivedValues.valueOfProviderAcceptance,
        }));
        if (
            this.state.editViewDataItem.serviceTypeId === ServiceType.Entertainment &&
            this.state.editViewDataItem.providerId &&
            this.state.editViewDataItem.venueId &&
            !this.state.editViewDataItem.chargingTypeId
        ) {
            this.hasProviderBeenPreviouslySourceApiCall();
            return;
        }
        if (
            this.state.editViewDataItem.chargingTypeId === ChargingType.NoFee ||
            this.state.editViewDataItem.chargingTypeId === ChargingType.SourceIntroFee ||
            this.state.editViewDataItem.chargingTypeId === ChargingType.ExistingActFee
        ) {
            this.deriveMultiplierForChargingType(this.state.editViewDataItem.chargingTypeId, () => {
                if (
                    (this.state.editViewDataItem.rate_Decimal && this.state.editViewDataItem.equipmentQuantity) ||
                    (this.state.editViewDataItem.billable_Start &&
                        this.state.editViewDataItem.billable_Finish &&
                        this.state.editViewDataItem.rate_Decimal)
                ) {
                    this.financialCalculations();
                } else {
                    this.setFinanceFieldsToNull();
                }
            });
            return;
        }
        let originator = serviceFeeMatrixDerivedValues.valueOfMultiplier;
        if (serviceFeeMatrixDerivedValues.originatorMultipliers.length > 0) {
            const originatorFiltered = serviceFeeMatrixDerivedValues.originatorMultipliers.filter(
                (item: { id: number; multiplier: string }) => item.id === this.state.editViewDataItem.originator?.id
            );
            // Ensure we access the first item if filtering returned any results
            if (originatorFiltered.length > 0) {
                originator = originatorFiltered[0].multiplier;
            }
        }
        this.setState(
            (prevState: Readonly<AddEditFormV2State>) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    fee_Percentage_Local_Ccy: this.sharedUtils.convertStringToFloat(originator),
                },
                isProviderNetOverride: false,
                isMultiplierOverride: false,
                providerOverrideValue: null,
                multiplierOverrideValue: null,
                percentageFieldChange: false,
            }),
            () => {
                // Run after fee_Percentage_Local_Ccy/isAccrual have actually committed to state —
                // financialCalculations reads this.state.editViewDataItem, which would otherwise still
                // hold the previous multiplier/accrual here (setState is batched, not applied
                // synchronously), causing a stale Calculate call followed by a second, correct one.
                if (
                    (this.state.editViewDataItem.rate_Decimal && this.state.editViewDataItem.equipmentQuantity) ||
                    (this.state.editViewDataItem.billable_Start &&
                        this.state.editViewDataItem.billable_Finish &&
                        this.state.editViewDataItem.rate_Decimal)
                ) {
                    this.financialCalculations();
                } else {
                    this.setFinanceFieldsToNull();
                }
            }
        );
    };

    itemTypeSelectionBasedOnProviderAmount = () => {
        const itemTypeLookUp = this.state.itemTypeLookUp;
        if (Math.sign(this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy) == -1) {
            if (
                this.state.editViewDataItem.billableStatusLookupId == Status.Pending ||
                this.state.editViewDataItem.billableStatusLookupId == Status.PendingAcceptance
            ) {
                this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        itemTypeId: itemTypeLookUp[4].id,
                        billableStatusLookupId: Status.PendingAcceptance,
                    },
                }));
            }
        }
        if (Math.sign(this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy) == 1) {
            if (
                this.state.editViewDataItem.billableStatusLookupId == Status.Pending ||
                this.state.editViewDataItem.billableStatusLookupId == Status.PendingAcceptance
            ) {
                this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        itemTypeId: itemTypeLookUp[3].id,
                        billableStatusLookupId: Status.Pending,
                    },
                }));
            }
        }
    };

    selectHardApprovalHoldPaymentValue = () => {
        // if (this.state.editViewDataItem.serviceTypeId == ServiceType.Entertainment) {
        //     this.setState((prevState: any) => ({
        //         editViewDataItem: {
        //             ...prevState.editViewDataItem,
        //             hardApproval: "No",
        //             holdPayment: "Yes"
        //         },
        //     }));
        // }
        // else
        if (
            this.state.editViewDataItem.serviceTypeId == ServiceType.ContractCleaning ||
            this.state.editViewDataItem.serviceTypeId == ServiceType.Entertainment ||
            this.state.editViewDataItem.serviceTypeId == ServiceType.Miscelleanous ||
            this.state.editViewDataItem.serviceTypeId == ServiceType.Maintenance ||
            this.state.editViewDataItem.serviceTypeId == ServiceType.WindowCleaning ||
            this.state.editViewDataItem.serviceTypeId == ServiceType.Gardening
        ) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    hardApproval: "No",
                    holdPayment: "Yes",
                },
            }));
        } else if (this.state.editViewDataItem.serviceTypeId == ServiceType.Security) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    hardApproval: "No",
                    holdPayment: "No",
                },
            }));
        }
    };

    handleItemTypeSelection = () => {
        if (this.props.location && this.props.location.state && this.props.location.state.id) {
            if (
                this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[1].id ||
                this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[3].id ||
                this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[4].id
            ) {
                this.itemTypeSelectionBasedOnProviderAmount();
            }
        }
    };

    setTaxApplicableStatus = (businessEntityId: string) => {
        var taxStatus = this.state.businessEntityTaxApplicableStatuses.find(
            (item) => item.businessEntityID === businessEntityId
        );
        var taxApplicable: string = "No";

        // A client/provider is tax applicable if they have a tax registration number
        if (taxStatus && taxStatus.taxApplicable) {
            taxApplicable = "Yes";
        }

        // Run after the tax-applicable flag below has actually committed to state — the calculations
        // read this.state.editViewDataItem, which would otherwise still hold the pre-update
        // client_Tax_Applicable/provider_Tax_Applicable here (setState is batched, not applied
        // synchronously), which is why toggling e.g. Provider VAT to "Yes" wouldn't recalculate it.
        const runTaxCalculations = () => {
            this.providerPayTaxCalculation();
            this.feeTaxCalculation();
            this.clientTaxCalculation();
        };

        if (taxStatus) {
            // Based on entity type, populate the tax applicable dropdown
            switch (taxStatus.businessEntityType) {
                case BusinessEntityTypes.Client:
                    this.setState(
                        (prevState: any) => ({
                            editViewDataItem: {
                                ...prevState.editViewDataItem,
                                client_Tax_Applicable: taxApplicable,
                            },
                        }),
                        runTaxCalculations
                    );
                    return;
                case BusinessEntityTypes.Provider:
                    this.setState(
                        (prevState: any) => ({
                            editViewDataItem: {
                                ...prevState.editViewDataItem,
                                provider_Tax_Applicable: taxApplicable,
                            },
                        }),
                        runTaxCalculations
                    );
                    return;
                // case BusinessEntityTypes.Company:
                //     this.setState((prevState: any) => ({
                //         editViewDataItem: {
                //             ...prevState.editViewDataItem,
                //             fee_Tax_Applicable: taxApplicable,
                //         },
                //     }));
                //     break;
            }
        }
        runTaxCalculations();
    };

    /**
     * Handle the success response for retrieving Tax Applicable statuses
     *
     * @param response {AxiosResponse<any>} - server response
     */
    handleTaxApplicableSuccess = (response: AxiosResponse<any>) => {
        this.setState(
            {
                businessEntityTaxApplicableStatuses: response.data.data,
            },
            () => {
                // Run after businessEntityTaxApplicableStatuses has actually committed to state —
                // setFeeTaxApplicableOnInitialLoad reads it off this.state, which would otherwise still
                // be the initial empty list here (setState is batched, not applied synchronously).
                this.setFeeTaxApplicableOnInitialLoad();
                this.retrieveFormData();
            }
        );
    };

    setFeeTaxApplicableOnInitialLoad = () => {
        var taxApplicable: string = "No";
        var statuses: BusinessEntityTaxApplicableStatus[] = this.state.businessEntityTaxApplicableStatuses;
        // Set the Fee tax applicable field immediately
        var businessEntityItem = statuses.find((item) => item.businessEntityType === BusinessEntityTypes.Company);
        if (businessEntityItem && businessEntityItem.taxApplicable) {
            taxApplicable = "Yes";
        }
        if (businessEntityItem) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    fee_Tax_Applicable: taxApplicable,
                },
            }));
        }
    };

    setBillableMinAndScheduleMin = () => {
        if (
            this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionEquipment ||
            this.state.editViewDataItem.serviceSubTypeId == SubServiceType.WeeklyCleaning ||
            this.state.editViewDataItem.serviceSubTypeId == SubServiceType.AdditionalCleaning ||
            this.state.editViewDataItem.serviceSubTypeId == SubServiceType.Laundry
        ) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    shift_Start: "",
                    shift_End: "",
                    billable_Start: "",
                    billable_Finish: "",
                    check_In: "",
                    check_Out: "",
                    billable_Minutes: 0,
                },
            }));
        } else if (this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionPersonnel) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    equipmentQuantity: 0,
                    equipmentBillableQuantity: null,
                    billable_Start: this.sharedUtils.convertStringToTime("00:00"),
                    billable_Finish: this.sharedUtils.convertStringToTime("00:00"),
                },
            }));
        }
    };
    handleCurrencyTypeLookUpSuccess = (response: AxiosResponse<any>) => {
        //currenyTypeLUItem
        var currenyLUItem: LookupTypeItem;
        var currenyLUItemArray: LookupTypeItem[];
        currenyLUItemArray = [];
        response.data.data.map((item: any, uniqueKey: number) => {
            currenyLUItem = {
                id: item.id,
                value: item.value,
                parentMappingId: "0",
            };
            currenyLUItemArray.push(currenyLUItem);
        });
        this.setState({
            currenyTypeLookUp: currenyLUItemArray,
        });
    };
    handleSuccessItemTypeLookUp = (response: AxiosResponse<any>) => {
        var itemLUItem: LookupTypeItem;
        var itemLUItemArray: LookupTypeItem[];
        itemLUItemArray = [];
        response.data.data.map((item: any, uniqueKey: number) => {
            itemLUItem = {
                id: item.id,
                value: item.value,
                parentMappingId: "0",
            };
            itemLUItemArray.push(itemLUItem);
        });
        this.setState({
            itemTypeLookUp: itemLUItemArray,
        });
    };

    handleSuccesStatusLookUp = (response: AxiosResponse<any>) => {
        var statusId = this.sharedUtils.getStatusLookupDataResponse(response.data.data);
        this.setState({
            amendStatus: statusId,
        });
    };

    handleUnitOfMeasureLookupSuccess = (response: AxiosResponse<any>) => {
        this.setState({
            unitOfMeasureList: response.data.data,
        });

        // Pass response.data.data directly rather than this.state.unitOfMeasureList — the setState
        // above hasn't committed yet at this point (setState is batched, not applied synchronously),
        // so reading it back from state here would still see the pre-update list.
        this.initializeFieldsBasedOnUnitOfMeasure(this.state.editViewDataItem.serviceSubTypeId, response.data.data);
    };

    // change for PBI-18255 start
    setUpdateOrCorrectionConditionally = (isAccrual: boolean, invoiceId: string, paymentId: string) => {
        if (isAccrual == true && invoiceId !== "" && paymentId == "") {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    updateOrCorrection: "true",
                },
            }));
        }
    };
    // change for PBI-18255 end
    handleSuccessGetGigPromotionByBillableItemId= (response: AxiosResponse<any>) => {
        this.setState({getGigPromotionByBillableItemId:response.data.data?response.data.data:[]})
    }
    // Manage successful data source response
    handleSuccessViewDataSource = (response: AxiosResponse<any>) => {
        let isPopup: boolean = false;
        if (this.props.billableItemId) {
            isPopup = true;
        }
        // Convert to proper data types
        var viewDataSource = this.utils.convertBillableItemResponeToFormData(response.data.data, isPopup);
        this.GetGigPromotionByBillableItemId(viewDataSource.billableItemId)
        var viewVirtualDataSource = this.utils.convertBillableItemResponeToVirtualFormData(response.data.data);
        let isCopy = this.props.location?.state?.pointOfNavigation == "copy_simpleshifts" ? true : false;
        if (isCopy) {
            viewDataSource = this.utils.copyBillableItem(response.data.data);
        }
        this.setState({
            queryItem: {
                ...this.state.queryItem,
                venueId: response.data.data.venueId ? response.data.data.venueId : "",
            },
        });
        if (viewDataSource.providerId) {
            this.editViewService
                .getBusinessEntityIds(viewDataSource.providerId)
                .then(this.handlePaymentCheckSuccessBusinessEntIds)
                .catch((err) => {
                    this.setState({
                        errorMessage:
                            err.response && err.response.data && err.response.data.error
                                ? JSON.parse(JSON.stringify(err.response.data.error))
                                : null,
                        IsShowSuccess: false,
                    });
                    this.failureMessageVisible();
                });
        }
        // In case of Amend status will be pre set to "Approve"
        if (this.props.location && this.props.location.state && this.props.location.state.isAmend) {
            this.setState(
                {
                    editViewDataItem: viewDataSource,
                },
                () => {
                    this.setUpdateOrCorrectionConditionally(
                        this.state.editViewDataItem.isAccrual,
                        this.state.editViewDataItem.invoiceId,
                        this.state.editViewDataItem.paymentId
                    );
                }
            );
            const amendStatus = this.state.amendStatus;
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    billableStatusLookupId: amendStatus,
                },
            }));
            if (viewDataSource.absent && viewDataSource.absent.toUpperCase() == "YES") {
                this.setState({
                    IsLockBillableFields: true,
                });
            }
        } else {
            // Set form data onto state
            this.setState(
                {
                    editViewDataItem: viewDataSource,
                    editViewVirtualDataItem: viewVirtualDataSource,
                    billableStart: viewDataSource.billable_Start,
                    billableFinish: viewDataSource.billable_Finish,
                    rate: viewDataSource.rate_Decimal,
                    quantity: viewDataSource.equipmentQuantity,
                    billableMinutes: viewDataSource.billable_Minutes,
                    acceptDate: viewDataSource.accept_Date,
                    approvalDate: viewDataSource.approval_Date,
                    billDate: viewDataSource.bill_Date,
                    payDate: viewDataSource.pay_Date,
                    CleaningMinutesToDisplay: response.data.data.equipmentQuantity,
                    //CleaningMinutesToDisplay: viewDataSource.equipmentQuantity,
                    expectedFee: viewDataSource.expectedFee,
                    providerOriginalAmount: viewDataSource.provider_Pay_Amount_Local_Ccy,
                    clientOriginalAmount: viewDataSource.client_Billable_Amount_Local_Ccy,
                },
                () => {
                    this.setUpdateOrCorrectionConditionally(
                        this.state.editViewDataItem.isAccrual,
                        this.state.editViewDataItem.invoiceId,
                        this.state.editViewDataItem.paymentId
                    );
                }
            );
            this.offeringsTypeDataSource(viewDataSource.serviceTypeId);
            this.setState({ isLoadFinancialPanel: true, loadPopupVisible: false });
            this.setState({
                itemTypeBeforeAdjustment: viewDataSource.itemTypeId,
            });
            if (viewDataSource.contractHours) {
                this.setState({
                    isWeeklyCleaning: true,
                });
            }
            if (viewDataSource.serviceSubTypeId == SubServiceType.WeeklyCleaning) {
                var quantitySubFields: string[] = this.outStandingActionUtils.splitQuantityIntoHoursMinutesFormat(
                    response.data.data.equipmentQuantity
                );
                var originalQuantitySubFields: string[] = this.outStandingActionUtils.splitQuantityIntoHoursMinutesFormat(
                    response.data.data.equipmentQuantity
                );

                this.setState({
                    isLableChange: true,
                    hours:
                        quantitySubFields.length > 0 && quantitySubFields[0]
                            ? this.sharedUtils.convertStringToInt(quantitySubFields[0])
                            : 0,
                    minutes: quantitySubFields.length > 0 && quantitySubFields[1] ? quantitySubFields[1] : "00",
                    prevHours:
                        originalQuantitySubFields.length > 0 && originalQuantitySubFields[0]
                            ? this.sharedUtils.convertStringToInt(originalQuantitySubFields[0])
                            : 0,
                    prevminutes:
                        originalQuantitySubFields.length > 0 && originalQuantitySubFields[1]
                            ? originalQuantitySubFields[1]
                            : "00",
                    virtualHours:
                        quantitySubFields.length > 0 && quantitySubFields[0]
                            ? this.sharedUtils.convertStringToInt(quantitySubFields[0])
                            : 0,
                    virtualMinutes: quantitySubFields.length > 0 && quantitySubFields[1] ? quantitySubFields[1] : "00",
                });
            }
            if (
                viewDataSource.serviceSubTypeId == SubServiceType.AdditionalCleaning ||
                viewDataSource.serviceSubTypeId == SubServiceType.Laundry
            ) {
                this.setState({
                    isOther: true,
                });
            }
            if (viewDataSource.serviceTypeId == ServiceType.ContractCleaning) {
                this.setState({
                    isHideForContract: true,
                });
            }
            if (viewDataSource.serviceTypeId == ServiceType.Entertainment) {
                this.setState({
                    isShowForEntertainment: true,
                });
            }
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    provider_Tax_Applicable:
                        ["TRUE", "YES"].includes(viewDataSource.provider_Tax_Applicable.toUpperCase()) ? "Yes" : "No",
                    fee_Tax_Applicable:
                        ["TRUE", "YES"].includes(viewDataSource.fee_Tax_Applicable.toUpperCase()) ? "Yes" : "No",
                    client_Tax_Applicable:
                        ["TRUE", "YES"].includes(viewDataSource.client_Tax_Applicable.toUpperCase()) ? "Yes" : "No",
                },
            }), () => {
                this.providerPayTaxCalculation();
                this.feeTaxCalculation();
                this.clientTaxCalculation();
            });
            if (this.props.location && this.props.location.state && this.props.location.state.isAdjust) {
                if (
                    UserService.isUserInGroup(RoleGroupNames.EventUKRelationshipManager) ||
                    UserService.isUserInGroup(RoleGroupNames.EventUKSeniorManager) ||
                    UserService.isUserInGroup(RoleGroupNames.ProviderScheduler) ||
                    UserService.isUserInGroup(RoleGroupNames.VenueManager)
                ) {
                    const providerOriginalAmount = viewDataSource.provider_Pay_Amount_Local_Ccy;
                    const clientOriginalAmount = viewDataSource.client_Billable_Amount_Local_Ccy;
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            provider_Pay_Original_Amount_Local_Ccy: providerOriginalAmount,
                            client_Billable_Original_Amount_Local_Ccy: clientOriginalAmount,
                        },
                    }));
                    if (
                        viewDataSource.itemTypeId == itemTypes.AdjustmentClientDebit ||
                        viewDataSource.itemTypeId == itemTypes.AdjustmentProviderDebit
                    ) {
                        this.setState((prevState: any) => ({
                            editViewDataItem: {
                                ...prevState.editViewDataItem,
                                itemTypeId: viewDataSource.itemTypeId,
                            },
                        }));
                    } else if (viewDataSource.isAccrual) {
                        this.setState((prevState: any) => ({
                            editViewDataItem: {
                                ...prevState.editViewDataItem,
                                itemTypeId: itemTypes.AdjustmentProviderDebit,
                            },
                        }));
                    } else {
                        this.setState((prevState: any) => ({
                            editViewDataItem: {
                                ...prevState.editViewDataItem,
                                itemTypeId: this.state.itemTypeLookUp[1].id,
                                billableStatusLookupId: Status.Pending,
                            },
                        }));
                    }
                    this.setState({
                        isChangeLabelName: true,
                    });
                    if (!UserService.isUserInGroup(RoleGroupNames.EventUKSeniorManager)) {
                        this.setState({
                            isDisableStatusDropDown: true,
                        });
                    }
                    // Run after editViewDataItem/itemTypeId/rate/quantity/billable* set above have actually
                    // committed to state — setOriginalFieldsOnPageLoadOnly reads them off this.state, which
                    // would otherwise still hold the pre-load defaults here (setState is batched).
                    this.setState({}, () => this.setOriginalFieldsOnPageLoadOnly());
                }
                this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        provider_Pay_Amount_Local_Ccy: 0.0,
                        provider_Pay_Tax_Local_Ccy: 0.0,
                        provider_Pay_Total_Local_Ccy: 0.0,
                        fee_Amount_Local_Ccy: 0.0,
                        fee_Tax_Local_Ccy: 0.0,
                        fee_Total_Local_Ccy: 0.0,
                        client_Billable_Amount_Local_Ccy: 0.0,
                        client_Billable_Tax_Local_Ccy: 0.0,
                        client_Billable_Total_Local_Ccy: 0.0,
                    },
                    expectedFee: 0.0,
                }));
                this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        accept_Date: undefined,
                        pay_Date: undefined,
                        bill_Date: undefined,
                        approval_Date: undefined,
                    },
                }));
            } else {
                if (
                    (this.props.location &&
                        this.props.location.state &&
                        this.props.location.state.isAmend == undefined) ||
                    (this.props.location &&
                        this.props.location.state.isAmend == this.props.location &&
                        this.props.location.state &&
                        this.props.location.state.isAmend == undefined) ||
                    (this.props.location && this.props.location.state && this.props.location.state.isAmend == false)
                ) {
                    if (
                        UserService.isUserInGroup(RoleGroupNames.EventUKRelationshipManager) ||
                        UserService.isUserInGroup(RoleGroupNames.ProviderScheduler) ||
                        UserService.isUserInGroup(RoleGroupNames.VenueManager)
                    ) {
                        if (
                            viewDataSource.childRecordId != null &&
                            viewDataSource.childRecordId != ""
                        ) {
                            this.setState({
                                isDisableApplyButton: true,
                            });
                            this.state.onlyViewMessage.push(
                                this.props.t("addEditShiftRow.Message.createAdjustment.editMessage")
                            );
                        }
                    }
                }
            }
        }
        if (viewDataSource.billableItemId == "") {
            this.initializeFieldsBasedOnUnitOfMeasure(viewDataSource.serviceSubTypeId, this.state.unitOfMeasureList);
            if (isCopy) {
                // Run after the editViewDataItem set above (in either the isAmend or non-isAmend branch)
                // has actually committed to state — financialCalculations reads this.state.editViewDataItem,
                // which would otherwise still hold the pre-load defaults here (setState is batched, not
                // applied synchronously). This no-op setState piggybacks on that same batch to get a
                // callback that fires once it commits.
                this.setState({}, () => {
                    //this.handleMultiplierValueSelection();
                    this.financialCalculations();
                    //this.selectHardApprovalHoldPaymentValue();
                    //this.setFeeTaxApplicableOnInitialLoad();
                    // this.setTaxApplicableStatus(viewDataSource.clientId);
                    // this.setTaxApplicableStatus(viewDataSource.providerId);
                });
            }
        }
    };

    filterDataSourceForRole = (data: LookupTypeItem[], filterId: string) => {
        let mappingId: number = this.sharedUtils.convertStringToInt(filterId);
        let roleTypeItems =
            mappingId > 0
                ? data.filter((item: LookupTypeItem) => {
                      return item.parentMappingId === filterId;
                  })
                : data;

        this.setState({
            offeringsTypeLookup: roleTypeItems,
        });
    };

    setOriginalFieldsOnPageLoadOnly = () => {
        if (
            this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[1].id ||
            this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[3].id ||
            this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[4].id
        ) {
            const originalBillableStartTime = this.state.billableStart
                ? this.state.billableStart
                : this.state.editViewDataItem.billable_Start;
            const originalBillableFinishTime = this.state.billableFinish
                ? this.state.billableFinish
                : this.state.editViewDataItem.billable_Finish;
            const originalBillableMinutes = this.state.billableMinutes
                ? this.state.billableMinutes
                : this.state.editViewDataItem.billable_Minutes;
            const originalRate = this.state.rate;
            const equipmentOriginalQuantity = this.state.quantity;
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    originalBillableStartTime,
                    originalBillableFinishTime,
                    originalBillableMinutes,
                    originalRate,
                    equipmentOriginalQuantity,
                },
            }));

            if (this.state.editViewDataItem.serviceSubTypeId == SubServiceType.WeeklyCleaning) {
                var prevQuantitySubFields: string[] = this.outStandingActionUtils.splitQuantityIntoHoursMinutesFormat(
                    equipmentOriginalQuantity.toString()
                );
                this.setState({
                    prevHours:
                        prevQuantitySubFields.length > 0 && prevQuantitySubFields[0]
                            ? this.sharedUtils.convertStringToInt(prevQuantitySubFields[0])
                            : 0,
                    prevminutes:
                        prevQuantitySubFields.length > 0 && prevQuantitySubFields[1] ? prevQuantitySubFields[1] : "00",
                });
            }
        }
    };

    //#endregion
    //#region 'handleChangeOnClickEvent
    // Series of callback functions that would set the state of the respective ID's when a selection is made inside the Dropdown.
    handleChangeClientTypeSelect = (dxValueChange: LookUpOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState(
                (prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        clientId: dxValueChange.value,
                        venueId: resolveGuardedDependentId(
                            prevState.editViewDataItem.venueId,
                            prevState.isClientSelected,
                            ""
                        ),
                        chargingTypeId: "",
                    },
                    previouslySourced: false,
                    existingAct: false,
                    isClientSelected: true,
                }),
                () => {
                    // Run after clientId has actually committed to state — handleMultiplierValueSelection
                    // reads this.state.editViewDataItem.clientId, which would otherwise still be the
                    // previous value here (setState is batched, not applied synchronously).
                    this.handleMultiplierValueSelection();
                }
            );
            // If this is a new shift, set the tax applicable status
            this.setTaxApplicableStatus(dxValueChange.value);
            this.setFeeTaxApplicableOnInitialLoad();
        }
    };

    handleChangeOriginator = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState(
                (prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        chargingTypeId: "",
                        originator: {
                            id: dxValueChange.value,
                            value: "",
                        },
                    },
                    previouslySourced: false,
                    existingAct: false,
                }),
                () => {
                    this.handleMultiplierValueSelection();
                }
            );
        } else {
            this.financialCalculations();
        }
    };
    handleChangeCorrectionUpdate = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    updateOrCorrection: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeActivityType = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    billableActivityType: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeChargingType = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    chargingTypeId: dxValueChange.value,
                },
            }), () => {
                this.deriveMultiplierForChargingType(dxValueChange.value, this.financialCalculations);
            });
        }
    };
    // A manual Charging Type change is a deliberate switch of fee basis, so it re-derives the Event
    // Multiplier itself rather than deferring to whatever the previously-sourced/existing-act check in
    // finalizeChargingType last put there (that derivation only runs once, while chargingTypeId
    // is still empty, and is not re-triggered by this handler):
    // - No Fee: multiplier is always zero.
    // - Source Intro Fee: multiplier comes from the service fee matrix's source intro fee multiplier,
    //   regardless of the provider's previously-sourced status.
    // - Regular/anything else: the normal service fee matrix derivation (same as
    //   handleMultiplierValueSelection).
    // `onDone` runs from the setState callback below rather than being called right after this method
    // returns, since fee_Percentage_Local_Ccy is not committed to state synchronously and
    // financialCalculations reads it straight off this.state.editViewDataItem.
    deriveMultiplierForChargingType = (chargingTypeId: string, onDone?: () => void) => {
        if (chargingTypeId === ChargingType.NoFee) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    fee_Percentage_Local_Ccy: 0,
                },
                isProviderNetOverride: false,
                isMultiplierOverride: false,
                providerOverrideValue: null,
                multiplierOverrideValue: null,
            }), onDone);
            return;
        }
        var serviceFeeMatrixDerivedValues = this.billableItemUtils.serviceFeeMatrixDerivation(
            this.state.editViewDataItem.clientId,
            this.state.editViewDataItem.serviceTypeId,
            this.state.editViewDataItem.serviceSubTypeId
        );
        let multiplier: any = "";
        if (chargingTypeId === ChargingType.ExistingActFee) {
            multiplier = serviceFeeMatrixDerivedValues.valueOfExistingActFeeMultiplier;
        } else if (chargingTypeId === ChargingType.SourceIntroFee) {
            multiplier = serviceFeeMatrixDerivedValues.valueOfSourceIntroFeeMultiplier;
        } else {
            multiplier = serviceFeeMatrixDerivedValues.valueOfMultiplier;
            if (serviceFeeMatrixDerivedValues.originatorMultipliers.length > 0) {
                let originatorFiltered = serviceFeeMatrixDerivedValues.originatorMultipliers.filter(
                    (item: any) => item.id === this.state.editViewDataItem.originator?.id
                );
                if (originatorFiltered.length > 0) {
                    multiplier = originatorFiltered[0].multiplier;
                }
            }
        }
        this.setState((prevState: any) => ({
            editViewDataItem: {
                ...prevState.editViewDataItem,
                fee_Percentage_Local_Ccy: this.sharedUtils.convertStringToFloat(multiplier),
            },
            isProviderNetOverride: false,
            isMultiplierOverride: false,
            providerOverrideValue: null,
            multiplierOverrideValue: null,
        }), onDone);
    };
    handleNotRequiredClick = () => {
        this.setState((prevState: any) => ({
            editViewDataItem: {
                ...prevState.editViewDataItem,
                billableActivityType: "10",
            },
        }));
    };
    handleChangeFasterPaymentTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined && this.state.editViewDataItem.fasterPayment !== dxValueChange.value) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    fasterPayment: dxValueChange.value,
                },
            }));

            // Cancel any previously scheduled debounce before rescheduling — otherwise editing this
            // field more than once within the 1s window leaves multiple independent timers pending,
            // and whichever fires first can silently cancel a later, more important one (or no-op)
            // simply by overwriting/reading this shared timer-ID variable.
            clearTimeout(this.state.rateChangeTimer);
            this.state.rateChangeTimer = setTimeout(this.startCallingFinancialAdjustment, 1000);
        }
    };

    handleChangeFasterPaymentWithdrawnTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (
            dxValueChange.event !== undefined &&
            this.state.editViewDataItem.fasterPaymentWithdrawn !== dxValueChange.value
        ) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    fasterPaymentWithdrawn: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeDoNotPayTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined && this.state.editViewDataItem.pay !== dxValueChange.value) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    pay: dxValueChange.value === "No" ? false : true,
                },
            }));
        }
    };
    handleChangeDoNotGroupPayTypeSelect= (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined && this.state.editViewDataItem.groupPayment !== dxValueChange.value) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    groupPayment: dxValueChange.value === "No" ? false : true,
                },
            }));
        }
    };
    handleChangeAdvancedPaymentTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    advancedpayment: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeEarlyPayTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    earlyPay: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeHours = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState({
                hours: dxValueChange.value,
                isChangeHour: true,
                isProviderNetOverride: false,
                isMultiplierOverride: false,
                providerOverrideValue: null,
                multiplierOverrideValue: null,
            });
            clearTimeout(this.state.hourChangeTimer);
            this.state.hourChangeTimer = setTimeout(this.reCalculateQuantity, 1000);
        }
    };

    handleChangeMinutes = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState({
                minutes: dxValueChange.value,
                isChangeMinute: true,
                isProviderNetOverride: false,
                isMultiplierOverride: false,
                providerOverrideValue: null,
                multiplierOverrideValue: null,
            });
            clearTimeout(this.state.hourChangeTimer);
            this.state.hourChangeTimer = setTimeout(this.reCalculateQuantity, 1000);
        }
    };

    //Helper function to recalulate the Quantity when either of the minute or Hour field varies.
    reCalculateQuantity = () => {
        var delimeter = ".";
        var { hours, minutes } = this.state; //Destructure the state to pull out the contents.
        var convertedHours: string = this.sharedUtils.convertNumberToString(hours);
        var quantity: string = `${convertedHours}${delimeter}${minutes}`;
        // Run after equipmentQuantity/equipmentScheduleQuantity have actually committed to state —
        // financialCalculations reads this.state.editViewDataItem, which would otherwise still hold the
        // previous quantity here (setState is batched, not applied synchronously).
        const runCalculation = () => this.financialCalculations();
        if (this.props.location && this.props.location.state && this.props.location.state.id == 0) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    equipmentQuantity: this.sharedUtils.convertStringToFloat(quantity),
                },
            }));
            this.setState(
                (prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        equipmentScheduleQuantity: prevState.editViewDataItem.equipmentQuantity,
                    },
                }),
                runCalculation
            );
        } else {
            this.setState(
                (prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        equipmentQuantity: this.sharedUtils.convertStringToFloat(quantity),
                    },
                }),
                runCalculation
            );
        }
    };

    handleChangeVenueTypeSelect = (dxValueChange: LookUpOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    venueId: dxValueChange.value,
                    // Whether this shift qualifies for the Source Intro Fee charging type depends on
                    // the provider/venue pair's previously-sourced status (see
                    // checkPreviouslySourcedApiCall / finalizeChargingType),
                    // which is only re-derived while chargingTypeId is empty. Without clearing it here,
                    // a Charging Type computed for the old venue stuck around unchanged after switching
                    // venues, since the derivation is one-shot and never reruns once a value is set.
                    chargingTypeId: "",
                },
                previouslySourced: false,
                existingAct: false,
            }), () => {
                // Re-derive it immediately for the new pair rather than waiting on some unrelated
                // field (e.g. Rate) to eventually debounce-trigger startCallingFinancialAdjustment.
                // Guarded here (rather than relying on hasProviderBeenPreviouslySourceApiCall's own
                // check) so picking Venue before Provider doesn't surface its "Provider Id and Venue
                // Id are required" validation message prematurely. Source Intro Fee/Event Multiplier
                // are an Entertainment-only concept (see finalizeChargingType), so only
                // Entertainment gigs need this re-check on Venue change.
                if (
                    this.state.editViewDataItem.providerId &&
                    this.state.editViewDataItem.venueId &&
                    this.state.editViewDataItem.serviceTypeId === ServiceType.Entertainment
                ) {
                    this.hasProviderBeenPreviouslySourceApiCall();
                }
            });
            this.setState({
                queryItem: {
                    ...this.state.queryItem,
                    venueId: dxValueChange.value,
                },
            });
        }
    };

    handleChangeStatusTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    billableStatusLookupId: dxValueChange.value,
                },
            }));
            if (dxValueChange.previousValue == Status.Pending && dxValueChange.value == Status.Approved) {
                this.setState({
                    isChangePendingToApprove: true,
                });
            }
            if (dxValueChange.value == Status.Pending && this.state.editViewDataItem.approval_Date) {
                this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        approval_Date: "",
                    },
                }));
            }
        }
    };

    handleChangeAccrualStatusTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    accrual: {
                        ...prevState.editViewDataItem.accrual,
                        accrualStatusId: dxValueChange.value,
                    },
                },
            }));
        }
    };

    handleChangeArtistConfirmedDate = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    shiftCompleteAcknowledgmentDateTime: dxValueChange.value,
                },
            }));
        }
    };

    dateToChangeLogic = () => {
        if (
            this.lookupService.isSubTypeIdEqualToUnitOfMeasureType(
                this.state.editViewDataItem.serviceSubTypeId,
                UnitOfMeasureTypes.time,
                this.state.unitOfMeasureList
            )
        ) {
            this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.time);
        } else if (
            this.lookupService.isSubTypeIdEqualToUnitOfMeasureType(
                this.state.editViewDataItem.serviceSubTypeId,
                UnitOfMeasureTypes.quantity,
                this.state.unitOfMeasureList
            )
        ) {
            this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.quantity);
        } else if (
            this.state.editViewDataItem.serviceTypeId == ServiceType.ContractCleaning ||
            this.state.editViewDataItem.serviceTypeId == ServiceType.Entertainment
        ) {
            this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.quantity);
        }
    };

    handleChangeDate = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    date: dxValueChange.value,
                },
                providerOverrideValue: null,
            }), () => {
                this.dateToChangeLogic();
                if (
                    this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionPersonnel &&
                    this.state.editViewDataItem.billable_Start &&
                    this.state.editViewDataItem.billable_Finish &&
                    this.state.editViewDataItem.rate_Decimal
                ) {
                    this.financialCalculations();
                }
            });
        }
    };

    handleChangeDateTo = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    dateTo: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeProviderTypeSelect = (dxValueChange: LookUpOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        providerId: dxValueChange.value,
                        // See handleChangeVenueTypeSelect: Charging Type is derived from this
                        // provider/venue pair's previously-sourced status, and that derivation only
                        // runs once (while chargingTypeId is empty), so it must be cleared here too or
                        // switching providers keeps the old provider's Charging Type.
                        chargingTypeId: "",
                    },
                    previouslySourced: false,
                    existingAct: false,
                }),
                () => {
                    this.editViewService
                        .getBusinessEntityIds(dxValueChange.value)
                        .then(this.handlePaymentCheckSuccessBusinessEntIds)
                        .catch((err) => {
                            this.setState({
                                errorMessage:
                                    err.response && err.response.data && err.response.data.error
                                        ? JSON.parse(JSON.stringify(err.response.data.error))
                                        : null,
                                IsShowSuccess: false,
                            });
                            this.failureMessageVisible();
                        });
                    // Re-derive Charging Type immediately for the new provider/venue pair rather than
                    // waiting on some unrelated field (e.g. Rate) to eventually debounce-trigger
                    // startCallingFinancialAdjustment. Guarded (rather than relying on
                    // hasProviderBeenPreviouslySourceApiCall's own check) so picking Provider before
                    // Venue doesn't surface its "Provider Id and Venue Id are required" validation
                    // message prematurely. Source Intro Fee/Event Multiplier are an Entertainment-only
                    // concept (see finalizeChargingType), so only Entertainment gigs need this
                    // re-check on Provider change.
                    if (
                        this.state.editViewDataItem.providerId &&
                        this.state.editViewDataItem.venueId &&
                        this.state.editViewDataItem.serviceTypeId === ServiceType.Entertainment
                    ) {
                        this.hasProviderBeenPreviouslySourceApiCall();
                    }
                }
            );
            this.setTaxApplicableStatus(dxValueChange.value);
            this.setFeeTaxApplicableOnInitialLoad();
        }
    };
    handlePaymentCheckSuccessBusinessEntIds = (response: AxiosResponse<any>) => {
        if (response.data.data.length > 0) {
            const result = response.data.data.map(
                (item: { profileId: any; professionalName: any; businessEntityId: any }) => ({
                    id: item.profileId,
                    value: `${item.professionalName} (${item.profileId})`,
                    parentMappingId: "",
                })
            );
            this.setState({ profileLookup: result });
        } else {
            this.setState({ profileLookup: [] });
        }
    };
    handleChangeProfileSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    providerBusinessEntityProfileId: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeWorkerStatus = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    workerStatusId: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeServiceTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        serviceTypeId: dxValueChange.value,
                        serviceSubTypeId: "",
                        rate_Decimal: 0,
                        chargingTypeId: "",
                    },
                    previouslySourced: false,
                    existingAct: false,
                }),
                () => {
                    this.offeringsTypeDataSource(dxValueChange.value);
                }
            );
            this.setState({
                typeLUDisablement: true,
                isServiceTypeChange: true,
            });
            if (dxValueChange.value == ServiceType.Entertainment) {
                this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        equipmentScheduleQuantity: 1,
                        equipmentQuantity: 1,
                    },
                }));
            }
            if (dxValueChange.value == ServiceType.ContractCleaning) {
                this.setState((prevState: any) => ({
                    isHideForContract: true,
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        billable_Start: "",
                        billable_Finish: "",
                        equipmentQuantity: 1,
                        typeId: "",
                    },
                }), () => {
                    this.setQuantityAutomaticallyBasedOnService();
                    this.handleMultiplierValueSelection();
                    this.selectHardApprovalHoldPaymentValue();
                });
                // serviceTypeId/serviceSubTypeId were just set above and haven't committed yet.
                this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.quantity, dxValueChange.value, "");
            } else {
                this.setState({
                    isHideForContract: false,
                    isOther: false,
                    isLableChange: false,
                }, () => {
                    this.setQuantityAutomaticallyBasedOnService();
                    this.handleMultiplierValueSelection();
                    this.selectHardApprovalHoldPaymentValue();
                });
            }
        }
    };

    setQuantityAutomaticallyBasedOnService = (serviceTypeIdOverride?: string) => {
        // Accepts an optional override so callers that already know the freshly-set serviceTypeId
        // (e.g. retrieveFormData, which sets it via setState in the same synchronous batch this reads
        // from) can supply it directly instead of reading it back from this.state before it commits.
        const serviceTypeId = serviceTypeIdOverride ?? this.state.editViewDataItem.serviceTypeId;
        if (
            serviceTypeId == ServiceType.Entertainment ||
            serviceTypeId == ServiceType.Gardening ||
            serviceTypeId == ServiceType.WindowCleaning ||
            serviceTypeId == ServiceType.Maintenance ||
            serviceTypeId == ServiceType.Miscelleanous
        ) {
            this.setState((prevState: any) => ({
                    isShowForEntertainment: true,
                    isHideForContract: false,
                    isOther: false,
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        equipmentQuantity: 1,
                        billable_Start: "",
                        billable_Finish: "",
                        shift_End: undefined,
                    },
                }),
                () => {
                    this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.quantity);
                }
            );
        } else {
            this.setState({
                isShowForEntertainment: false,
            });
        }
    };
    handleChangeServiceSubTypeSelect = (dxValueChange: LookUpOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            const newTypeId: string = "";
            this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        serviceSubTypeId: dxValueChange.value,
                        rate_Decimal:
                            this.state.editViewDataItem.serviceTypeId == "10"
                                ? 0
                                : this.state.editViewDataItem.rate_Decimal,
                        typeId: newTypeId,
                        otherDescription: "",
                        chargingTypeId: "",
                    },
                    previouslySourced: false,
                    existingAct: false,
                }),
                () => {
                    if (dxValueChange.value == SubServiceType.WeeklyCleaning) {
                        let quantitySubFields: string[] = this.outStandingActionUtils.splitQuantityIntoHoursMinutesFormat(
                            this.state.editViewDataItem.equipmentQuantity.toString()
                        );
                        this.setState({
                            hours:
                                quantitySubFields.length > 0 && quantitySubFields[0]
                                    ? this.sharedUtils.convertStringToInt(quantitySubFields[0])
                                    : 0,
                            minutes: quantitySubFields.length > 0 && quantitySubFields[1] ? quantitySubFields[1] : "00",
                        });
                    }
                    this.state.editViewDataItem.serviceTypeId == "10" &&
                    this.state.editViewDataItem.billableItemId !== ""
                        ? notify(
                              {
                                  message: "Amounts have been removed and need to be re-entered",
                                  width: 400,
                                  shading: true,
                              },
                              "error",
                              600
                          )
                        : null;
                    this.filterDataSourceForRole(this.state.typeLookUp, dxValueChange.value);
                    this.setRoleTypeOrShowOtherDesc(dxValueChange.value);
                    // Run after serviceSubTypeId has actually committed to state — these all read
                    // this.state.editViewDataItem.serviceSubTypeId, which would otherwise still hold the
                    // previous sub type here (setState is batched, not applied synchronously), causing
                    // the derived billable-min/multiplier/finance values to trail one selection behind.
                    // handleMultiplierValueSelection already recalculates (or nulls) every finance field on
                    // all its paths, so no separate financeRecalculationOnPercentageChange here — its
                    // client amounts were computed from stale state and landed after the nulls.
                    this.setBillableMinAndScheduleMin();
                    this.handleMultiplierValueSelection();
                }
            );

            if (dxValueChange.value) {
                if (dxValueChange.value != SubServiceType.WeeklyCleaning) {
                    this.setState({
                        typeLUDisablement: false,
                        isLableChange: false,
                        isWeeklyCleaning: false,
                    });
                } else {
                    this.setState({
                        typeLUDisablement: true,
                        isLableChange: true,
                    });
                }
                if (dxValueChange.value != SubServiceType.DoorSupervisionPersonnel) {
                    this.setState({
                        isSubTypeChange: true,
                    });
                }
            }

            if (
                this.lookupService.isSubTypeIdEqualToUnitOfMeasureType(
                    dxValueChange.value,
                    UnitOfMeasureTypes.time,
                    this.state.unitOfMeasureList
                )
            ) {
                this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.time, undefined, dxValueChange.value);
            } else if (
                this.lookupService.isSubTypeIdEqualToUnitOfMeasureType(
                    dxValueChange.value,
                    UnitOfMeasureTypes.quantity,
                    this.state.unitOfMeasureList
                )
            ) {
                this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.quantity, undefined, dxValueChange.value);
            }
            if (
                dxValueChange.value == SubServiceType.AdditionalCleaning ||
                dxValueChange.value == SubServiceType.Laundry
            ) {
                if (!this.state.editViewDataItem.equipmentQuantity) {
                    this.setState((prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            equipmentQuantity: 1,
                            equipmentScheduleQuantity: 1,
                        },
                    }));
                }
            }
            if (dxValueChange.value == SubServiceType.WeeklyCleaning) {
                this.setState({
                    isOther: false,
                });
            } else if (
                // typeId was cleared to "" by the setState above — use that new value rather than
                // this.state, which still holds the previous typeId here (setState is batched).
                (newTypeId == RoleTypes.Other &&
                    dxValueChange.value == SubServiceType.AdditionalCleaning) ||
                (newTypeId == RoleTypes.Other &&
                    dxValueChange.value == SubServiceType.Laundry)
            ) {
                this.setState({
                    isOther: true,
                });
            }
            this.setQuantityAutomaticallyBasedOnService();
            this.selectHardApprovalHoldPaymentValue();
        }
    };

    setRoleTypeOrShowOtherDesc = (subTypeId: string) => {
        if (subTypeId == Types.Other) {
            this.setState({
                isShowOtherDescription: true,
            });
        } else {
            this.setState({
                isShowOtherDescription: false,
            });
        }
        //if()
    };

    initializeFieldsBasedOnUnitOfMeasure = (subTypeId: string, unitOfMeasureList: LookupTypeItem[]) => {
        // Disabling fields dependent on: 1) the form data server request 2) the unit of measure list
        // Both success promises (this is one) will need to set execute the disable as it cannot be known who's promise will complete first
        if (subTypeId && subTypeId.length > 0) {
            this.lookupService.isSubTypeIdEqualToUnitOfMeasureType(
                subTypeId,
                UnitOfMeasureTypes.time,
                unitOfMeasureList
            )
                ? this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.time)
                : this.disableFieldsBasedOnUnitOfMeasure(UnitOfMeasureTypes.quantity);
        }
    };

    /**
     * Set disabled attribute based on selected unit of measure (sub type).
     * Also reset the Date To field
     *  If Time      - Date To = Date From
     *  If Equipment - Date To = Date From + 6 days
     *
     * @param unitOfMeasureType {string} - the unit of measure
     * @returns {void}
     */
    disableFieldsBasedOnUnitOfMeasure = (
        unitOfMeasureType: string,
        serviceTypeIdOverride?: string,
        serviceSubTypeIdOverride?: string
    ) => {
        // Optional overrides let callers that have just set serviceTypeId/serviceSubTypeId via setState
        // (not yet committed — setState is batched) pass the new values instead of reading stale state.
        var dateTo = this.utils.setDateToField(
            unitOfMeasureType,
            this.state.editViewDataItem.date,
            serviceTypeIdOverride ?? this.state.editViewDataItem.serviceTypeId,
            serviceSubTypeIdOverride ?? this.state.editViewDataItem.serviceSubTypeId
        );
        var isLockTimeFields = this.utils.lockTimeFields(unitOfMeasureType);
        var isLockQuantityFields = this.utils.lockQuantityFields(unitOfMeasureType);
        this.setState((prevState: any) => ({
            IsLockTimeFields: isLockTimeFields,
            IsLockQuantityFields: isLockQuantityFields,
            editViewDataItem: {
                ...prevState.editViewDataItem,
                dateTo: dateTo,
            },
        }));
    };

    clientAmountSetOnPercentageChange = () => {
        const item = this.state.editViewDataItem;
        const taxApplicable = item.client_Tax_Applicable.toUpperCase();
        const clientBillableTax =
            taxApplicable === "YES" || taxApplicable === "TRUE"
                ? item.provider_Pay_Tax_Local_Ccy + item.fee_Tax_Local_Ccy
                : 0.0;
        const clientBillableAmount = item.provider_Pay_Amount_Local_Ccy + item.fee_Amount_Local_Ccy;
        const clientBillableTotal = clientBillableAmount + clientBillableTax;
        this.setState((prevState: any) => ({
            editViewDataItem: {
                ...prevState.editViewDataItem,
                client_Billable_Tax_Local_Ccy: clientBillableTax,
                client_Billable_Amount_Local_Ccy: clientBillableAmount,
                client_Billable_Total_Local_Ccy: clientBillableTotal,
            },
        }));
    };

    financeRecalculationOnPercentageChange = () => {
        var feeAmount: number[] = [];
        var feeTaxLocalCcy: number = 0;
        var feeTotalLocalCcy: number = 0;
        if (
            (this.state.editViewDataItem.billable_Start &&
                this.state.editViewDataItem.billable_Finish &&
                this.state.editViewDataItem.rate_Decimal) ||
            ((this.state.editViewDataItem.equipmentQuantity || this.state.editViewDataItem.equipmentBillableQuantity) &&
                this.state.editViewDataItem.rate_Decimal)
        ) {
            this.financialCalculations();
        }
        feeAmount = this.utils.feeTaxCal(this.state.editViewDataItem, this.state.configuarationValueIndex);
        if (feeAmount.length > 0) {
            feeTaxLocalCcy = feeAmount[0];
            feeTotalLocalCcy = feeAmount[1];
        }
        this.setState(
            (prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    fee_Tax_Local_Ccy: feeTaxLocalCcy,
                    fee_Total_Local_Ccy: feeTotalLocalCcy,
                },
            }),
            () => {
                // Run after fee_Tax_Local_Ccy has actually committed to state — clientAmountSetOnPercentageChange
                // reads this.state.editViewDataItem.fee_Tax_Local_Ccy, which would otherwise still hold the
                // previous value here (setState is batched, not applied synchronously).
                this.clientAmountSetOnPercentageChange();
            }
        );
    };

    handleChangeOfferingsTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    typeId: dxValueChange.value,
                    otherDescription: "",
                },
            }));
            if (dxValueChange.value == RoleTypes.Other) {
                this.setState({
                    isOther: true,
                });
            }
        }
    };

    handleChangeName = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    name: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeIdentificationNumber = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    identification_Number: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeIdentificationTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    identificationTypeId: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeShiftStart = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState(
                (prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        shift_Start: prevState.editViewDataItem.date
                            ? this.replaceDateKeepTime(dxValueChange.value, prevState.editViewDataItem.date)
                            : dxValueChange.value,
                    },
                }),
                () => {
                    // Run after shift_Start has actually committed to state — otherwise
                    // onChangeAbsentNoChargeSetBillableMinutes derives billable_Start/billable_Finish
                    // from the pre-update shift_Start (setState is batched, not applied synchronously).
                    if (this.state.editViewDataItem.serviceTypeId != ServiceType.Entertainment) {
                        this.onChangeAbsentNoChargeSetBillableMinutes();
                    }
                }
            );
        }
    };
    replaceDateKeepTime = (incorrectDate: Date, correctDate: Date) => {
        const hours = incorrectDate.getHours();
        const minutes = incorrectDate.getMinutes();
        const seconds = incorrectDate.getSeconds();
        const milliseconds = incorrectDate.getMilliseconds();
        const updatedDate = new Date(correctDate);
        updatedDate.setHours(hours, minutes, seconds, milliseconds);
        return updatedDate;
    };

    handleChangeShiftEnd = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            const correctDate = this.state.editViewDataItem.date
                ? this.replaceDateKeepTime(dxValueChange.value, this.state.editViewDataItem.date)
                : dxValueChange.value;
            let addDay: NullableDate;
            if (this.state.editViewDataItem.shift_Start && correctDate && this.state.editViewDataItem.date) {
                const targetTime = new Date(correctDate);
                targetTime.setHours(6, 0, 0, 0);
                if (
                    new Date(correctDate) < new Date(this.state.editViewDataItem.shift_Start) &&
                    new Date(correctDate) > new Date(targetTime)
                ) {
                    addDay = new Date(this.state.editViewDataItem.date);
                    addDay.setDate(addDay.getDate() + 1);
                } else {
                    addDay = new Date(this.state.editViewDataItem.date);
                }
            }
            this.setState(
                (prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        shift_End: correctDate,
                        dateTo: addDay,
                    },
                }),
                () => {
                    // Run after shift_End has actually committed to state — otherwise
                    // onChangeAbsentNoChargeSetBillableMinutes derives billable_Start/billable_Finish
                    // from the pre-update shift_End (setState is batched, not applied synchronously).
                    if (this.state.editViewDataItem.serviceTypeId != ServiceType.Entertainment) {
                        this.onChangeAbsentNoChargeSetBillableMinutes();
                    }
                }
            );
        }
    };
    handleChangeArtistConfirmedTime = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    shiftCompleteAcknowledgmentTime: dxValueChange.value,
                },
            }));
        }
    };

    //sangeeta
    handleChangeBillableStart = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState(
                (prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        billable_Start: dxValueChange.value,
                    },
                    isProviderNetOverride: false,
                    isMultiplierOverride: false,
                    providerOverrideValue: null,
                    multiplierOverrideValue: null,
                }),
                () => {
                    // Run after billable_Start has actually committed to state — otherwise this guard
                    // (which decides whether to schedule the Calculate call) reads the pre-update
                    // billable_Start here (setState is batched, not applied synchronously), which could
                    // skip scheduling the recalculation entirely.
                    if (
                        this.state.editViewDataItem.billable_Finish &&
                        this.state.editViewDataItem.billable_Start &&
                        this.state.editViewDataItem.rate_Decimal
                    ) {
                        clearTimeout(this.state.approvalStartChangeTimer);
                        this.state.approvalStartChangeTimer = setTimeout(this.startCallingfinancialOnType, 1000);
                    }
                }
            );
            this.setState({
                isChangeBillableStart: true,
            });
            if (this.state.editViewDataItem.equipmentQuantity) {
                this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        equipmentQuantity: 0,
                    },
                }));
            }
        }
    };

    startCallingfinancialOnType = () => {
        if (this.state.approvalStartChangeTimer || this.state.approvalEndChangeTimer) {
            clearTimeout(this.state.approvalStartChangeTimer);
            clearTimeout(this.state.approvalEndChangeTimer);
            this.state.approvalStartChangeTimer = null;
            this.state.approvalEndChangeTimer = null;
            this.financialCalculations();
        }
    };

    handleChangeBillableFinish = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState(
                (prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        billable_Finish: dxValueChange.value,
                    },
                    isProviderNetOverride: false,
                    isMultiplierOverride: false,
                    providerOverrideValue: null,
                    multiplierOverrideValue: null,
                }),
                () => {
                    // Run after billable_Finish has actually committed to state — otherwise this guard
                    // (which decides whether to schedule the Calculate call) reads the pre-update
                    // billable_Finish here (setState is batched, not applied synchronously), which could
                    // skip scheduling the recalculation entirely.
                    if (
                        this.state.editViewDataItem.billable_Start &&
                        this.state.editViewDataItem.billable_Finish &&
                        this.state.editViewDataItem.rate_Decimal
                    ) {
                        clearTimeout(this.state.approvalEndChangeTimer);
                        this.state.approvalEndChangeTimer = setTimeout(this.startCallingfinancialOnType, 1000);
                    }
                }
            );
            this.setState({
                isChangeBillableFinish: true,
            });
            if (this.state.editViewDataItem.equipmentQuantity) {
                this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        equipmentQuantity: 0,
                    },
                }));
            }
        }
    };

    hideLoadIndicator = () => {
        this.setState({
            loadIndicatorVisible: false,
            loadIndicatorOnPercentageChange: false,
            isDisableApplyButton: false,
        });
    };

    showLoadIndicator = () => {
        this.setState({ loadIndicatorVisible: true, isDisableApplyButton: true });
    };

    financialCalculations = () => {
        if (this.state.percentageFieldChange) {
            this.setState({
                loadIndicatorOnPercentageChange: true,
                loadIndicatorVisible: false,
            });
        } else if (this.state.providerOverrideValue) {
            this.setState({
                loadIndicatorOnPercentageChange: true,
                loadIndicatorVisible: true,
            });
        } else {
            this.showLoadIndicator();
        }
        if (
            !this.state.isFasterPayChange &&
            !this.state.isArtistPayChange &&
            (this.state.editViewDataItem.fasterPayment == true ||
                this.state.editViewDataItem.fasterPayment.toString() == "Yes") &&
            !this.state.isFasterPayProp
        ) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    providerFasterPayFee: "",
                },
            }));
        }
        let editViewDataItemForCalc = { ...this.state.editViewDataItem };

        if (this.state.isArtistPayChange) {
            editViewDataItemForCalc = {
                ...editViewDataItemForCalc,
                providerFasterPayFee: undefined,
                providerPayAmountLocal: undefined,
            };
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    providerFasterPayFee: "",
                },
            }));
        }
        if (
            this.state.editViewDataItem.updateOrCorrection == "false" &&
            this.state.editViewDataItem.serviceTypeId !== "30" &&
            // IsLockBillableFields is set when Absent is "Not Present" or No Charge is "Waived" (see
            // onChangeAbsentNoChargeSetBillableMinutes/handleChangeAbsent), which forces Approved
            // Start/Finish (billable_Start/billable_Finish) to collapse to a zero-length duration so
            // nothing is paid/billed. That collapsed value is not a real schedule and must not be
            // copied onto Scheduled Start/End below — doing so was wiping out the shift's original
            // schedule every time Not Present/Waived triggered this recalculation.
            !this.state.IsLockBillableFields
        ) {
            editViewDataItemForCalc = {
                ...editViewDataItemForCalc,
                shift_Start: this.state.editViewDataItem.billable_Start,
                shift_End: this.state.editViewDataItem.billable_Finish,
            };
            // Read from prevState, not this.state — other setState calls affecting billable_Start/
            // billable_Finish can be queued in the same batch as this one (financialCalculations is
            // often called right after other setState calls in its own caller chain), and this.state
            // wouldn't reflect them yet, which could copy a stale/pre-update value into shift_Start/
            // shift_End here — directly clobbering the displayed Scheduled Start/End.
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    shift_Start: prevState.editViewDataItem.billable_Start,
                    shift_End: prevState.editViewDataItem.billable_Finish,
                },
            }));
        }
        let calCulationObject = this.utils.convertCalcDataToCalcRequest(
            editViewDataItemForCalc,
            this.state.providerOverrideValue ? this.state.providerOverrideValue : null,
            this.state.multiplierOverrideValue,
            this.props.location && this.props.location.state ? this.props.location.state.id : this.props.billableItemId
        );

        // Rapid successive field changes (e.g. Service/Sub Type/Client/Rate set in quick succession on
        // a new shift) can each dispatch their own Calculate request. Network responses aren't
        // guaranteed to arrive in the order they were sent, so without this sequence check an older
        // request's response could arrive after a newer one and silently overwrite the newer, correct
        // financial figures with stale ones — while the separately-derived Event Multiplier display
        // (set synchronously, not from this response) would already show the newer, correct value,
        // producing a mismatch between the two.
        this.state.calculationRequestSeq = (this.state.calculationRequestSeq || 0) + 1;
        const requestSeq = this.state.calculationRequestSeq;
        const isLatestRequest = () => requestSeq === this.state.calculationRequestSeq;

        this.editViewService
            .uploadFormData(calCulationObject)
            .then((response: AxiosResponse<any>) => {
                if (isLatestRequest()) {
                    this.handleCalculationSuccess(response);
                }
            })
            .catch((err) => {
                if (!isLatestRequest()) {
                    return;
                }
                this.setState({
                    errorMessage: err.response ? JSON.parse(JSON.stringify(err.response.data.error)) : null, // For capturing response at the time of exception and showing error message
                    IsShowSuccess: false,
                    disabledApplybutton: true,
                });
                this.failureMessageVisible();
                this.hideLoadIndicator();
            })
            .finally(() => {
                if (isLatestRequest()) {
                    this.hideLoadIndicator();
                }
            });
    };
    handleCalculationSuccessForExpectedFee = (response: AxiosResponse<any>) => {
        var serverResponse: CalculationResponse = response.data.data;
        this.hideLoadIndicator();
        this.setState({
            IsShowError: false,
            expectedFee: this.sharedUtils.convertStringToFloat(serverResponse.grossProfitAmountLocal),
        });
    };
    handleCalculationSuccess = (response: AxiosResponse<any>) => {
        let serverResponse: CalculationResponse = response.data.data;
        this.hideLoadIndicator();

        this.setState({
            IsShowError: false,
            disabledApplybutton: false,
        });
        if (this.state.editViewDataItem.updateOrCorrection == "false") {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    scheduledMinutes: serverResponse.billableMinutes,
                },
            }));
        }
        // Convert server response to proper data types
        this.setState((prevState: any) => ({
                isFasterPayChange: false,
                isArtistPayChange: false,
                isFasterPayProp: false,
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    billable_Minutes: this.sharedUtils.convertStringToFloat(serverResponse.billableMinutes),
                    provider_Pay_Amount_Local_Ccy: this.sharedUtils.convertStringToFloat(
                        serverResponse.providerPayAmount
                    ),
                    provider_Pay_Tax_Local_Ccy:
                        prevState.editViewDataItem.provider_Tax_Applicable == "Yes"
                            ? this.sharedUtils.convertStringToFloat(serverResponse.providerPayTaxLocalCcy)
                            : 0.0,
                    provider_Pay_Total_Local_Ccy: this.sharedUtils.convertStringToFloat(
                        serverResponse.providerPayTotalLocalCcy
                    ),
                    provider_Pay_Currency_Local_Ccy: serverResponse.providerPayAmountLocalCurrency, // Ex: "GBP"
                    client_Billable_Amount_Local_Ccy: this.sharedUtils.convertStringToFloat(
                        serverResponse.clientBillableAmountLocal
                    ),
                    client_Billable_Tax_Local_Ccy:
                        prevState.editViewDataItem.client_Tax_Applicable == "Yes"
                            ? this.sharedUtils.convertStringToFloat(serverResponse.clientBillableTaxLocalCcy)
                            : 0.0,
                    client_Billable_Total_Local_Ccy: this.sharedUtils.convertStringToFloat(
                        serverResponse.clientBillableTotalLocalCcy
                    ),
                    client_Billable_Currency_Local_Ccy: serverResponse.clientBillableAmountLocalCurrency,
                    fee_Amount_Local_Ccy: this.sharedUtils.convertStringToFloat(serverResponse.grossProfitAmountLocal),
                    fee_Tax_Local_Ccy:
                        prevState.editViewDataItem.fee_Tax_Applicable == "Yes"
                            ? this.sharedUtils.convertStringToFloat(serverResponse.grossProfitTaxLocalCcy)
                            : 0.0,
                    fee_Total_Local_Ccy: this.sharedUtils.convertStringToFloat(serverResponse.grossProfitTotalLocalCcy),
                    fee_Currency_Local_Ccy: serverResponse.grossProfitAmountLocalCurrency,
                    equipmentBillableQuantity: this.sharedUtils.convertStringToFloat(serverResponse.billableQuantity),
                    billableRate: this.sharedUtils.convertStringToFloat(serverResponse.billableRate),
                    providerPayAmountLocal: this.sharedUtils.convertStringToFloat(
                        serverResponse.providerPayAmountLocal
                    ),
                    providerPayAmountLocalExtras: this.sharedUtils.convertStringToFloat(
                        serverResponse.providerPayAmountLocalExtras
                    ),
                    providerPayAmountLocalWOExtras: this.sharedUtils.convertStringToFloat(
                        serverResponse.providerPayAmountLocalWOExtras
                    ),
                    providerFasterPayFee: this.sharedUtils.convertStringToFloat(serverResponse.providerFasterPayFee),
                    providerFasterPayOriginalAmount: this.sharedUtils.convertStringToFloat(
                        serverResponse.providerFasterPayOriginalAmount
                    ),
                    accrual: serverResponse.accrual
                        ? {
                              id: serverResponse.accrual.id,
                              accrualTypeId: serverResponse.accrual.accrualTypeId,
                              accrualStatusId: serverResponse.accrual.accrualStatusId,
                              accrualBillableItemId: serverResponse.accrual.accrualBillableItemId,
                              accrualInvoiceId: serverResponse.accrual.accrualInvoiceId,
                              providerPayAmountAccrual: serverResponse.accrual.providerPayAmountAccrual,
                              providerPayAmountTaxAccrual:
                                  prevState.editViewDataItem.provider_Tax_Applicable == "Yes"
                                      ? serverResponse.accrual.providerPayAmountTaxAccrual
                                      : 0.0,
                              providerPayAmountTotalAccrual: serverResponse.accrual.providerPayAmountTotalAccrual,
                              grossProfitAmountAccrual: serverResponse.accrual.grossProfitAmountAccrual,
                              grossProfitAmountTaxAccrual:
                                  prevState.editViewDataItem.fee_Tax_Applicable == "Yes"
                                      ? serverResponse.accrual.grossProfitAmountTaxAccrual
                                      : 0.0,
                              grossProfitAmountTotalAccrual: serverResponse.accrual.grossProfitAmountTotalAccrual,
                              clientBillableAmountAccrual: serverResponse.accrual.clientBillableAmountAccrual,
                              clientBillableAmountTaxAccrual:
                                  prevState.editViewDataItem.client_Tax_Applicable == "Yes"
                                      ? serverResponse.accrual.clientBillableAmountTaxAccrual
                                      : 0.0,
                              clientBillableAmountTotalAccrual: serverResponse.accrual.clientBillableAmountTotalAccrual,
                              lastUpdatedOn: serverResponse.accrual.lastUpdatedOn,
                              lastUpdatedBy: serverResponse.accrual.lastUpdatedBy,
                          }
                        : null,
                },
                expectedFee: this.sharedUtils.convertStringToFloat(serverResponse.grossProfitAmountLocal),
            }),
            () => {
                this.nonStandardDropDownValueSelection();
                // Run after provider_Pay_Amount_Local_Ccy/provider_Pay_Currency_Local_Ccy have actually
                // committed to state — both the isAdjust messaging below and handleItemTypeSelection
                // read this.state.editViewDataItem, which would otherwise still hold the pre-Calculate
                // values here (setState is batched, not applied synchronously).
                if (this.props.location && this.props.location.state && this.props.location.state.isAdjust) {
                    // below block is applicable for Adjustment
                    if (
                        this.state.isChangeBillableStart ||
                        this.state.isChangeBillableFinish ||
                        this.state.isChangeRate ||
                        this.state.isChangeQuantity ||
                        this.state.isChangeHour ||
                        this.state.isChangeMinute ||
                        this.state.editViewDataItem.noCharge
                    ) {
                        if (
                            (this.state.acceptDate != null ||
                                this.state.acceptDate != undefined ||
                                this.state.editViewDataItem.paymentId != null ||
                                this.state.editViewDataItem.paymentId != undefined ||
                                this.state.approvalDate != null ||
                                this.state.approvalDate != undefined ||
                                this.state.editViewDataItem.invoiceId != null ||
                                this.state.editViewDataItem.invoiceId != undefined) &&
                            (this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[1].id ||
                                this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[3].id ||
                                this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[4].id)
                        ) {
                            if (Math.sign(this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy) == 1) {
                                this.setState({
                                    calculationMessageClassName: "check-red",
                                });
                                if (UserService.isUserInGroup(RoleGroupNames.VenueManager)) {
                                    this.state.calculationMessage.push(
                                        "The new cost" +
                                            currencyTypeToSymbolMatrix[
                                                this.state.editViewDataItem.provider_Pay_Currency_Local_Ccy
                                            ] +
                                            this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy.toFixed(2) +
                                            " will be sent for processing after this has been created"
                                    );
                                } else {
                                    this.state.calculationMessage.push(
                                        "An additional cost " +
                                            currencyTypeToSymbolMatrix[
                                                this.state.editViewDataItem.provider_Pay_Currency_Local_Ccy
                                            ] +
                                            this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy.toFixed(2) +
                                            " will be shown on the Client's next available cost report (after approval)"
                                    );
                                }
                            } else if (Math.sign(this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy) == -1) {
                                this.setState({
                                    calculationMessageClassName: "check-blue",
                                });
                                if (UserService.isUserInGroup(RoleGroupNames.ProviderScheduler)) {
                                    this.state.calculationMessage.push(
                                        "The new cost " +
                                            currencyTypeToSymbolMatrix[
                                                this.state.editViewDataItem.provider_Pay_Currency_Local_Ccy
                                            ] +
                                            this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy.toFixed(2) +
                                            " will be sent for processing after this has been created"
                                    );
                                } else {
                                    this.state.calculationMessage.push(
                                        "A credit of " +
                                            currencyTypeToSymbolMatrix[
                                                this.state.editViewDataItem.provider_Pay_Currency_Local_Ccy
                                            ] +
                                            this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy.toFixed(2) +
                                            " will be shown on the Client's next available cost report (after approval)"
                                    );
                                }
                            } else if (Math.sign(this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy) == 0) {
                                this.state.calculationMessage.push("");
                            }
                        }
                    }
                }
                this.handleItemTypeSelection();
            }
        );
    };
    onCalculationTaxApplicableFieldSet = () => {
        this.providerPayTaxCalculation();
        this.feeTaxCalculation();
        this.clientTaxCalculation();
        if (this.state.editViewDataItem.accrual && this.state.editViewDataItem.isAccrual) {
            this.providerAccrualTaxCalculation();
            this.feeTaxAccrualCalculation();
            this.clientTaxAccrualCalculation();
        }
    };
    setFinanceFieldsToNull = () => {
        this.setState((prevState: any) => ({
            editViewDataItem: {
                ...prevState.editViewDataItem,
                provider_Pay_Total_Local_Ccy: 0.0,
                fee_Total_Local_Ccy: 0.0,
                client_Billable_Total_Local_Ccy: 0.0,
                provider_Pay_Amount_Local_Ccy: 0.0,
                fee_Amount_Local_Ccy: 0.0,
                client_Billable_Amount_Local_Ccy: 0.0,
                provider_Pay_Tax_Local_Ccy: 0.0,
                fee_Tax_Local_Ccy: 0.0,
                client_Billable_Tax_Local_Ccy: 0.0,
            },
        }));
        if (!this.state.headerId) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    client_Billable_Original_Amount_Local_Ccy: 0.0,
                    provider_Pay_Original_Amount_Local_Ccy: 0.0,
                },
            }));
        }
    };
    handleChangeCheckInTime = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    check_In: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeCheckOutTime = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    check_Out: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeAbsent = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState(
                (prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        absent: dxValueChange.value,
                    },
                }),
                () => {
                    // Run after `absent` has actually committed to state — both branches below read
                    // this.state.editViewDataItem.absent (directly, or via
                    // onChangeAbsentNoChargeSetBillableMinutes), which would otherwise still hold the
                    // pre-update value here (setState is batched, not applied synchronously).
                    if (this.props.location && this.props.location.state && this.props.location.state.isAmend) {
                        if (this.state.editViewDataItem.absent.toLowerCase() == "not present") {
                            this.setState(
                                (prevState: any) => ({
                                    editViewDataItem: {
                                        ...prevState.editViewDataItem,
                                        billable_Finish: prevState.editViewDataItem.billable_Start,
                                    },
                                }),
                                () => {
                                    if (
                                        this.state.editViewDataItem.billable_Start &&
                                        this.state.editViewDataItem.billable_Finish &&
                                        this.state.editViewDataItem.rate_Decimal
                                    ) {
                                        this.financialCalculations();
                                    }
                                }
                            );
                            this.setState({
                                IsLockBillableFields: true,
                            });
                        }
                    } else {
                        this.onChangeAbsentNoChargeSetBillableMinutes();
                    }
                }
            );
        }
    };

    onChangeAbsentNoChargeSetBillableMinutes = () => {
        if (this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionPersonnel) {
            // The Absent/Charge dropdowns display "Present"/"Applied" as a visual default on a brand-new
            // shift whenever the underlying field is still "" (see their `value` props) — but that's
            // display-only; the real editViewDataItem.absent/noCharge stays "" until the user explicitly
            // re-selects it. Without mirroring that same fallback here, this logic matched neither the
            // "not present"/"waived" nor "present"/"applied" branch on every new shift and silently did
            // nothing, leaving billable_Start/billable_Finish stuck at their "00:00" default — which then
            // got copied back onto Scheduled Start/End the next time financialCalculations() ran.
            const isNewShift = !!(
                this.props.location &&
                this.props.location.state &&
                this.props.location.state.id == 0
            );
            const effectiveAbsent =
                this.state.editViewDataItem.absent === "" && isNewShift
                    ? "Present"
                    : this.state.editViewDataItem.absent;
            const effectiveNoCharge =
                this.state.editViewDataItem.noCharge === "" && isNewShift
                    ? "Applied"
                    : this.state.editViewDataItem.noCharge;
            if (
                effectiveAbsent.toLowerCase() == "not present" ||
                effectiveNoCharge.toLowerCase() == "waived"
            ) {
                this.setState(
                    (prevState: any) => ({
                        editViewDataItem: {
                            ...prevState.editViewDataItem,
                            billable_Finish: prevState.editViewDataItem.billable_Start,
                        },
                    }),
                    () => {
                        // Run after billable_Finish has actually committed to state — the guard below
                        // and financialCalculations both read this.state.editViewDataItem, which would
                        // otherwise still hold the pre-update billable_Finish here (setState is batched).
                        if (
                            this.state.editViewDataItem.billable_Start &&
                            this.state.editViewDataItem.billable_Finish &&
                            this.state.editViewDataItem.rate_Decimal
                        ) {
                            this.financialCalculations();
                        }
                    }
                );
                this.setState({
                    IsLockBillableFields: true,
                });
            } else if (
                effectiveAbsent.toLowerCase() == "present" ||
                effectiveNoCharge.toLowerCase() == "applied"
            ) {
                let shiftStart = this.sharedUtils.convertTimeToString(this.state.editViewDataItem.shift_Start);
                let shiftEnd = this.sharedUtils.convertTimeToString(this.state.editViewDataItem.shift_End);
                let checkIn = this.sharedUtils.convertTimeToString(this.state.editViewDataItem.check_In);
                let checkOut = this.sharedUtils.convertTimeToString(this.state.editViewDataItem.check_Out);
                // Run the financialCalculations guard after billable_Start/billable_Finish have actually
                // committed to state (setState is batched, not applied synchronously) — otherwise the
                // guard and the Calculate call it triggers read the pre-update values.
                const runCalculationCheck = () => {
                    if (
                        this.state.editViewDataItem.billable_Start &&
                        this.state.editViewDataItem.billable_Finish &&
                        this.state.editViewDataItem.rate_Decimal
                    ) {
                        this.financialCalculations();
                    }
                };
                // Reverting to Present/Applied must also undo onChangeCharge's "Waived" branch zeroing
                // rate_Decimal (and financialCalculations' guard above requires rate_Decimal to be
                // truthy just to fire) — restore it from the originally-loaded this.state.rate, same
                // source onChangeCharge's own "Applied" branch uses. Only fill it in when it's currently
                // falsy so a genuine manual Rate edit made while Absent/Waived was active isn't clobbered.
                const restoredRate = (prevState: any) =>
                    prevState.editViewDataItem.rate_Decimal ? prevState.editViewDataItem.rate_Decimal : this.state.rate;
                if (shiftStart != "00:00" || shiftEnd != "00:00") {
                    this.setState(
                        (prevState: any) => ({
                            editViewDataItem: {
                                ...prevState.editViewDataItem,
                                billable_Start: prevState.editViewDataItem.shift_Start,
                                billable_Finish: prevState.editViewDataItem.shift_End,
                                rate_Decimal: restoredRate(prevState),
                            },
                        }),
                        runCalculationCheck
                    );
                } else if (
                    checkIn != "00:00" ||
                    checkOut != "00:00" ||
                    (shiftStart == "00:00" && shiftEnd == "00:00" && checkIn == "00:00" && checkOut == "00:00")
                ) {
                    this.setState(
                        (prevState: any) => ({
                            editViewDataItem: {
                                ...prevState.editViewDataItem,
                                billable_Start: prevState.editViewDataItem.check_In,
                                billable_Finish: prevState.editViewDataItem.check_Out,
                                rate_Decimal: restoredRate(prevState),
                            },
                        }),
                        runCalculationCheck
                    );
                } else {
                    if (!this.state.editViewDataItem.rate_Decimal && this.state.rate) {
                        this.setState((prevState: any) => ({
                            editViewDataItem: {
                                ...prevState.editViewDataItem,
                                rate_Decimal: this.state.rate,
                            },
                        }), runCalculationCheck);
                    } else {
                        runCalculationCheck();
                    }
                }
                this.setState({
                    IsLockBillableFields: false,
                });
            }
        }
    };

    onChangeCharge = () => {
        if (this.state.editViewDataItem.noCharge.toLowerCase() == "waived") {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    rate_Decimal: 0,
                    provider_Pay_Amount_Local_Ccy: 0.0,
                    fee_Amount_Local_Ccy: 0.0,
                    client_Billable_Amount_Local_Ccy: 0.0,
                    provider_Pay_Tax_Local_Ccy: 0.0,
                    fee_Tax_Local_Ccy: 0.0,
                    client_Billable_Tax_Local_Ccy: 0.0,
                    provider_Pay_Total_Local_Ccy: 0.0,
                    fee_Total_Local_Ccy: 0.0,
                    client_Billable_Total_Local_Ccy: 0.0,
                    provider_Pay_Original_Amount_Local_Ccy: 0.0,
                    client_Billable_Original_Amount_Local_Ccy: 0.0,
                },
                expectedFee: 0.0,
            }));
        } else if (this.state.editViewDataItem.noCharge.toLowerCase() == "applied") {
            this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        rate_Decimal: this.state.rate,
                    },
                }),
                () => {
                    this.financialCalculations();
                }
            );
        }
    };

    handleChangeRequestApprover = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    requestApprover: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeRequestedOn = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    requestDate: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeOtherDescription = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    otherDescription: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeRate = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined && this.state.editViewDataItem.rate_Decimal !== dxValueChange.value) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    rate_Decimal: dxValueChange.value,
                    scheduleRate:
                        this.props.location && this.props.location.state && this.props.location.state.id == 0
                            ? dxValueChange.value
                            : this.state.editViewDataItem.scheduleRate,
                },
                isProviderNetOverride: false,
                isMultiplierOverride: false,
                isChangeRate: true,
                percentageFieldChange: false,
                providerOverrideValue: null,
                multiplierOverrideValue: null,
                isArtistPayChange: true,
            }));

            // Cancel any previously scheduled debounce before rescheduling — otherwise typing more than
            // one digit within the 1s window leaves multiple independent timers pending, and whichever
            // fires first can silently cancel a later, more important one (or no-op) simply by
            // overwriting/reading this shared timer-ID variable. This is what made the recalculation
            // intermittently not fire when typing a rate.
            clearTimeout(this.state.rateChangeTimer);
            this.state.rateChangeTimer = setTimeout(this.startCallingFinancialAdjustment, 1000);
        //    this.state.rateChangeTimer = setTimeout(() => {
        //     this.hasProviderBeenPreviouslySourceApiCall();
        // }, 1000);

        }
    };
    hasProviderBeenPreviouslySourceApiCall = () =>{
        if(this.state.editViewDataItem.providerId && this.state.editViewDataItem.venueId){
            this.setState({
                loadPanelVisible: true,
            });
            // Fetch the Service Fee Matrix first so both the Previously Sourced and Existing Act checks
            // can be gated on the matrix's own allowed-flags (sourceIntroFeeAllowed / existingActAllowed)
            // rather than calling either API unconditionally.
            this.serviceFeeMatrixApiCall();
        }
        else{
            // Provider/Venue aren't both set yet, so the previously-sourced/charging-type lookup can't
            // run — but the core financial recalculation shouldn't be blocked on that. This mirrors the
            // fallback in checkPreviouslySourcedApiCall, which also just calls
            // financialCalculations() when the lookup has nothing to enrich with. Without this, typing a
            // Rate/Artist's Fee before Venue is selected silently never recalculated Provider/Event NET.
            this.setState({errorMessage:[ {
                "columnName": "Provider Id / Venue Id",
                "errorType": "Error",
                "errorMessage": "Provider Id and Venue Id are required. Please select both values."
            }]})
            this.financialCalculations();
        }
    }
    resolveChargingTypeIdFromPreviouslySourcedResponse = (responseData: any): string => {
        if (!responseData) {
            return "";
        }
        if (typeof responseData === "object") {
            const directValue = responseData.chargingTypeId || responseData?.data?.chargingTypeId || responseData?.result?.chargingTypeId;
            if (directValue !== undefined && directValue !== null && directValue !== "") {
                return directValue.toString();
            }
        }
        return "";
    }
    resolvePreviouslySourcedFlag = (responseData: any): boolean => {
        if (typeof responseData === "boolean") {
            return responseData;
        }
        if (responseData && typeof responseData === "object") {
            return responseData.previouslySourced === true || responseData?.data?.previouslySourced === true;
        }
        return false;
    }
    
    resolveExistingActFlag = (responseData: any): boolean => {
        if (typeof responseData === "boolean") {
            return responseData;
        }
        if (responseData && typeof responseData === "object") {
            return responseData.existingAct === true || responseData?.data?.existingAct === true;
        }
        return false;
    }
    
    checkExistingActApiCall = (serviceFeeMatrix: any) => {
        const originatorId = this.props.location?.state?.originatorId
            ? String(this.props.location.state.originatorId)
            : this.state.editViewDataItem.originator?.id
                ? String(this.state.editViewDataItem.originator.id)
                : "";
        const providerId = this.state.editViewDataItem.providerId;
        const venueId = this.state.editViewDataItem.venueId;
        const serviceTypeId = this.state.editViewDataItem.serviceTypeId;
        const existingActAllowed = !!(serviceFeeMatrix.existingActAllowed ?? serviceFeeMatrix.existingActFeeAllowed);
        if (
            !providerId ||
            !venueId ||
            serviceTypeId !== ServiceType.Entertainment ||
            !existingActAllowed
        ) {
            this.setState({ existingAct: false }, () => {
                this.finalizeChargingType(serviceFeeMatrix);
            });
            return;
        }
        this.editViewService
            .getCheckExistingActByProviderId(providerId, venueId, originatorId, serviceTypeId)
            .then((response: AxiosResponse<any>) => {
                const existingActValue = this.resolveExistingActFlag(response.data);
                this.setState({ existingAct: existingActValue }, () => {
                    this.finalizeChargingType(serviceFeeMatrix);
                });
            })
            .catch((err) => {
                this.setState({
                    errorMessage: err.response ? JSON.parse(JSON.stringify(err.response.data.error)) : null,
                    IsShowSuccess: false,
                    disabledApplybutton: true,
                    loadPanelVisible: false,
                });
                this.failureMessageVisible();
            });
    }

    checkPreviouslySourcedApiCall = (serviceFeeMatrix: any) => {
            const providerId = this.state.editViewDataItem.providerId;
            const venueId = this.state.editViewDataItem.venueId;
            const sourceIntroAllowed = !!serviceFeeMatrix.sourceIntroFeeAllowed;
            if (!sourceIntroAllowed) {
                this.setState({ previouslySourced: false }, () => {
                    this.checkExistingActApiCall(serviceFeeMatrix);
                });
                return;
            }
            this.editViewService.getPreviouslySourcedByProviderId(providerId, venueId)
                .then((response: AxiosResponse<any>) => {
                    const previouslySourcedValue = this.resolvePreviouslySourcedFlag(response.data);
                    this.setState({
                        previouslySourced: previouslySourcedValue,
                    },()=>{
                        this.checkExistingActApiCall(serviceFeeMatrix)
                    })
                })
                .catch((err) => {
                    this.setState({
                        errorMessage: err.response ? JSON.parse(JSON.stringify(err.response.data.error)) : null, // For capturing response at the time of exception and showing error message
                        IsShowSuccess: false,
                        disabledApplybutton: true,
                    });
                    this.failureMessageVisible();
                    this.setState({
                        loadPanelVisible: false,
                    });
                })
        }
        serviceFeeMatrixApiCall=()=>{
            this.setState({
                loadPanelVisible: true,
            });
            let clientId = this.state.editViewDataItem.clientId
            let serviceTypeId = this.state.editViewDataItem.serviceTypeId
            let serviceSubTypeId =this.state.editViewDataItem.serviceSubTypeId
            const originatorId = this.props.location?.state?.originatorId
                ? String(this.props.location.state.originatorId)
                : this.state.editViewDataItem.originator?.id
                    ? String(this.state.editViewDataItem.originator.id)
                    : "";
            this.serviceFeeService.getServiceFeeMatrixDataItemFilter(clientId,serviceTypeId,serviceSubTypeId,originatorId)
                .then((response: AxiosResponse<any>) => {
                    const serviceFeeMatrix = response.data || {};
                    this.checkPreviouslySourcedApiCall(serviceFeeMatrix);
                })
                .catch((err) => {
                    this.setState({
                        errorMessage: err.response ? JSON.parse(JSON.stringify(err.response.data.error)) : null, // For capturing response at the time of exception and showing error message
                        IsShowSuccess: false,
                        disabledApplybutton: true,
                    });
                    this.failureMessageVisible();
                    this.setState({
                        loadPanelVisible: false,
                    });
                })
        }
        finalizeChargingType = (serviceFeeMatrix: any) =>{
            const sourceIntroAllowed = !!serviceFeeMatrix.sourceIntroFeeAllowed;
            const existingActAllowed = !!(serviceFeeMatrix.existingActAllowed ?? serviceFeeMatrix.existingActFeeAllowed);
            if(!this.state.editViewDataItem.chargingTypeId){
                const applyExistingActFee = existingActAllowed && this.state.existingAct;
                const applySourceIntroFee = sourceIntroAllowed && this.state.previouslySourced && !applyExistingActFee;
                const isEntertainment = this.state.editViewDataItem.serviceTypeId === ServiceType.Entertainment;
                const toMultiplier = (raw: any) =>
                    typeof raw === "number" ? raw : this.sharedUtils.convertStringToFloat(raw);
                const entertainmentMultiplier = applyExistingActFee
                    ? toMultiplier(serviceFeeMatrix.existingActMultiplier ?? serviceFeeMatrix.existingActFeeMultiplier)
                    : applySourceIntroFee
                        ? toMultiplier(serviceFeeMatrix.sourceIntroFeeMultiplier)
                        : toMultiplier(serviceFeeMatrix.multiplier);
                this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        chargingTypeId: applyExistingActFee ? ChargingType.ExistingActFee : applySourceIntroFee ? ChargingType.SourceIntroFee : ChargingType.Regular,
                        fee_Percentage_Local_Ccy: isEntertainment
                            ? entertainmentMultiplier
                            : prevState.editViewDataItem.fee_Percentage_Local_Ccy,
                    },
                    // The multiplier is only replaced for Entertainment, so only then clear any
                    // overrides (as handleMultiplierValueSelection/deriveMultiplierForChargingType do).
                    ...(isEntertainment
                        ? {
                              isMultiplierOverride: false,
                              multiplierOverrideValue: null,
                              isProviderNetOverride: false,
                              providerOverrideValue: null,
                          }
                        : {}),
                }), () => {
                    this.setState({ loadPanelVisible: false });
                    this.financialCalculations();
                });
                return;
            }
            this.setState({ loadPanelVisible: false });
            this.financialCalculations()

        }
    handleChangeExtras = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    providerPayAmountLocalExtras: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeAdjustedAmount = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    providerPayAmountLocal: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeFasterPayFee = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (
            dxValueChange.event !== undefined &&
            this.state.editViewDataItem.providerFasterPayFee !== dxValueChange.value
        ) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    providerFasterPayFee: dxValueChange.value,
                },
                isFasterPayChange: true,
            }));

            clearTimeout(this.state.rateChangeTimer);
            this.state.rateChangeTimer = setTimeout(this.startCallingFinancialAdjustment, 1000);
        }
    };

    startCallingFinancialAdjustment = () => {
        if (this.state.rateChangeTimer || this.state.hourChangeTimer) {
            clearTimeout(this.state.rateChangeTimer);
            clearTimeout(this.state.hourChangeTimer);
            this.state.rateChangeTimer = null;
            // Previously only called hasProviderBeenPreviouslySourceApiCall (and therefore
            // financialCalculations) when either billable_Start/billable_Finish were both already set
            // (time-based services) or equipmentQuantity was set (quantity-based services) — so typing a
            // Rate/Faster Pay Fee on a Security/DoorSupervisionPersonnel shift before Approved
            // Start/Finish had been entered silently never triggered a recalculation. Mirrors the same
            // fix already applied one layer down in hasProviderBeenPreviouslySourceApiCall's own
            // provider/venue fallback: the core recalculation shouldn't be blocked on fields this
            // debounce isn't actually about.
            this.hasProviderBeenPreviouslySourceApiCall();
        }
    };
    handleChangeOriginalRate = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    originalRate: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeQuantity = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState(
                (prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        equipmentQuantity: dxValueChange.value,
                    },
                    isProviderNetOverride: false,
                    isMultiplierOverride: false,
                    providerOverrideValue: null,
                    multiplierOverrideValue: null,
                }),
                () => {
                    // Run after equipmentQuantity has actually committed to state — the reads below and
                    // financialCalculations would otherwise still see the pre-update quantity here
                    // (setState is batched, not applied synchronously).
                    if (this.props.location && this.props.location.state && this.props.location.state.id == 0) {
                        this.setState((prevState: any) => ({
                            editViewDataItem: {
                                ...prevState.editViewDataItem,
                                equipmentScheduleQuantity: prevState.editViewDataItem.equipmentQuantity,
                            },
                        }));
                    }
                    if (
                        this.state.editViewDataItem.billable_Start ||
                        this.state.editViewDataItem.billable_Finish ||
                        this.state.editViewDataItem.billable_Minutes
                    ) {
                        this.setState((prevState: any) => ({
                            editViewDataItem: {
                                ...prevState.editViewDataItem,
                                billable_Start: null,
                                billable_Finish: null,
                                billable_Minutes: null,
                            },
                        }));
                    }
                    if (
                        this.state.editViewDataItem.rate_Decimal &&
                        (this.state.editViewDataItem.equipmentQuantity == 0 ||
                            this.state.editViewDataItem.equipmentQuantity)
                    ) {
                        this.financialCalculations();
                    }
                }
            );
            this.setState({
                isChangeQuantity: true,
                percentageFieldChange: false,
            });
        }
    };
    handleChangeOriginalQuantity = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    equipmentOriginalQuantity: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeCover = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    cover: dxValueChange.value,
                    coverIndex: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeNoChange = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    noCharge: dxValueChange.value,
                },
            }), () => {
                if (this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionPersonnel) {
                    this.onChangeAbsentNoChargeSetBillableMinutes();
                } else {
                    this.onChangeCharge();
                }
            });
        }
    };
    handleChangeComments = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    comments: dxValueChange.value,
                },
            }));
            this.setState({
                queryItem: {
                    ...this.state.queryItem,
                    queryDescription: dxValueChange.value,
                },
            });
        }
    };

    handleChangeProviderTaxApplicableSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    provider_Tax_Applicable: dxValueChange.value,
                },
            }), () => {
                this.providerPayTaxCalculation();
                if (
                    this.state.editViewDataItem.isAccrual &&
                    this.state.editViewDataItem.accrual &&
                    this.state.editViewDataItem.accrual.providerPayAmountAccrual
                ) {
                    this.providerAccrualTaxCalculation();
                }
            });
        }
    };

    handleChangeUnscheduledSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    unscheduled: dxValueChange.value,
                },
            }));
        }
    };
    providerPayTaxCalculation = () => {
        const providerCalculationVal = this.utils.providerPayTaxCal(
            this.state.editViewDataItem,
            this.state.configuarationValue
        );
        const providerPayTaxLocalCcy = providerCalculationVal.length > 0 ? providerCalculationVal[0] : 0;
        const providerPayAmountTotalCcy = providerCalculationVal.length > 0 ? providerCalculationVal[1] : 0;
        const providerTaxFieldVisibility = providerCalculationVal.length == 3 ? providerCalculationVal[2] : 0;

        this.setState((prevState: any) => ({
            editViewDataItem: {
                ...prevState.editViewDataItem,
                provider_Pay_Tax_Local_Ccy: providerPayTaxLocalCcy,
                provider_Pay_Total_Local_Ccy: providerPayAmountTotalCcy,
            },
            isProviderTaxFieldVisible: providerTaxFieldVisibility == 1,
        }));
    };

    providerAccrualTaxCalculation = () => {
        const providerAccrualCalculationVal = this.utils.providerPayAccrualTaxCal(
            this.state.editViewDataItem,
            this.state.configuarationValue
        );
        const providerPayTaxAccrual = providerAccrualCalculationVal.length > 0 ? providerAccrualCalculationVal[0] : 0;
        const providerPayAmountTotalAccrual = providerAccrualCalculationVal.length > 0 ? providerAccrualCalculationVal[1] : 0;
        const providerTaxFieldVisibility = providerAccrualCalculationVal.length == 3 ? providerAccrualCalculationVal[2] : 0;

        this.setState((prevState: any) => ({
            editViewDataItem: {
                ...prevState.editViewDataItem,
                accrual: {
                    ...prevState.editViewDataItem.accrual,
                    providerPayAmountTaxAccrual: providerPayTaxAccrual,
                    providerPayAmountTotalAccrual: providerPayAmountTotalAccrual,
                },
            },
            isProviderTaxFieldVisible: providerTaxFieldVisibility == 1,
        }));
    };
    handleChangeFeeTaxApplicableSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    fee_Tax_Applicable: dxValueChange.value,
                },
            }), () => {
                this.feeTaxCalculation();
                if (
                    this.state.editViewDataItem.isAccrual &&
                    this.state.editViewDataItem.accrual &&
                    this.state.editViewDataItem.accrual.grossProfitAmountAccrual
                ) {
                    this.feeTaxAccrualCalculation();
                }
            });
        }
    };

    feeTaxCalculation = () => {
        const feeCalculationVal = this.utils.feeTaxCal(this.state.editViewDataItem, this.state.configuarationValue);
        const feeTaxLocalCcy = feeCalculationVal.length > 0 ? feeCalculationVal[0] : 0;
        const feeAmountTotalCcy = feeCalculationVal.length > 0 ? feeCalculationVal[1] : 0;
        const feeTaxFieldVisibility = feeCalculationVal.length == 3 ? feeCalculationVal[2] : 0;

        this.setState((prevState: any) => ({
            editViewDataItem: {
                ...prevState.editViewDataItem,
                fee_Tax_Local_Ccy: feeTaxLocalCcy,
                fee_Total_Local_Ccy: feeAmountTotalCcy,
            },
            isFeeTaxFieldVisible: feeTaxFieldVisibility == 1,
        }));
    };

    feeTaxAccrualCalculation = () => {
        const feeCalculationAccrualVal = this.utils.feeAccrualTaxCal(
            this.state.editViewDataItem,
            this.state.configuarationValue
        );
        const feeTaxAccrual = feeCalculationAccrualVal.length > 0 ? feeCalculationAccrualVal[0] : 0;
        const feeAmountTotalAccrual = feeCalculationAccrualVal.length > 0 ? feeCalculationAccrualVal[1] : 0;
        const feeTaxFieldVisibility = feeCalculationAccrualVal.length == 3 ? feeCalculationAccrualVal[2] : 0;

        this.setState((prevState: any) => ({
            editViewDataItem: {
                ...prevState.editViewDataItem,
                accrual: {
                    ...prevState.editViewDataItem.accrual,
                    grossProfitAmountTaxAccrual: feeTaxAccrual,
                    grossProfitAmountTotalAccrual: feeAmountTotalAccrual,
                },
            },
            isFeeTaxFieldVisible: feeTaxFieldVisibility == 1,
        }));
    };

    handleChangeClientTaxApplicableSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    client_Tax_Applicable: dxValueChange.value,
                },
            }), () => {
                this.clientTaxCalculation();
                if (
                    this.state.editViewDataItem.isAccrual &&
                    this.state.editViewDataItem.accrual &&
                    this.state.editViewDataItem.accrual.clientBillableAmountAccrual
                ) {
                    this.clientTaxAccrualCalculation();
                }
            });
        }
    };

    clientTaxCalculation = () => {
        const clientCalculationVal = this.utils.clientTaxCal(this.state.editViewDataItem, this.state.configuarationValue);
        const clientTaxLocalCcy = clientCalculationVal.length > 0 ? clientCalculationVal[0] : 0;
        const clientAmountTotalCcy = clientCalculationVal.length > 0 ? clientCalculationVal[1] : 0;
        const clientTaxFieldVisibility = clientCalculationVal.length == 3 ? clientCalculationVal[2] : 0;

        this.setState((prevState: any) => ({
            editViewDataItem: {
                ...prevState.editViewDataItem,
                client_Billable_Tax_Local_Ccy: clientTaxLocalCcy,
                client_Billable_Total_Local_Ccy: clientAmountTotalCcy,
            },
            isBillClientTaxFieldVisible: clientTaxFieldVisibility == 1,
        }));
    };

    clientTaxAccrualCalculation = () => {
        const clientCalculationAccrualVal = this.utils.clientAccrualTaxCal(
            this.state.editViewDataItem,
            this.state.configuarationValue
        );
        const clientTaxLocalAccrual = clientCalculationAccrualVal.length > 0 ? clientCalculationAccrualVal[0] : 0;
        const clientAmountTotalAccrual = clientCalculationAccrualVal.length > 0 ? clientCalculationAccrualVal[1] : 0;
        const clientTaxFieldVisibility = clientCalculationAccrualVal.length == 3 ? clientCalculationAccrualVal[2] : 0;

        this.setState((prevState: any) => ({
            editViewDataItem: {
                ...prevState.editViewDataItem,
                accrual: {
                    ...prevState.editViewDataItem.accrual,
                    clientBillableAmountTaxAccrual: clientTaxLocalAccrual,
                    clientBillableAmountTotalAccrual: clientAmountTotalAccrual,
                },
            },
            isBillClientTaxFieldVisible: clientTaxFieldVisibility == 1,
        }));
    };
    handleChangeProviderCurrencyTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    provider_Pay_Currency_Local_Ccy: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeFeeCurrencyTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    fee_Currency_Local_Ccy: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeBillCurrencyTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    client_Billable_Currency_Local_Ccy: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeAcceptDate = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    accept_Date: dxValueChange.value,
                },
            }));
        }
    };

    handleChangePercentage = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    fee_Percentage_Local_Ccy: dxValueChange.value,
                },
                multiplierOverrideValue: dxValueChange.value,
                isMultiplierOverride: true,
            }));
            this.setState({
                percentageFieldChange: true,
            });
            clearTimeout(this.state.multiplierChangeTimer);
            this.state.multiplierChangeTimer = setTimeout(this.startCallingFinancialRecalculation, 1000);
        }
    };

    startCallingFinancialRecalculation = () => {
        if (this.state.multiplierChangeTimer) {
            clearTimeout(this.state.multiplierChangeTimer);
            this.state.multiplierChangeTimer = null;
            this.financeRecalculationOnPercentageChange();
        }
    };

    handleChangeApprovalDate = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            let header = GlobalService.getHeaderResopnse();
            let approvedBy = dxValueChange.value ? (header.description ? header.description : "") : "";
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    approval_Date: dxValueChange.value,
                    approved_By: approvedBy,
                },
            }));
        }
    };

    handleChangeTwoTierApprovalDate = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            let header = GlobalService.getHeaderResopnse();
            let approvedBy = dxValueChange.value ? (header.description ? header.description : "") : "";
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    twoTierApprovalDate: dxValueChange.value,
                    twoTierApprovedBy: approvedBy,
                },
            }));
        }
    };

    handleChangeProviderLocalCurrancyAmount = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        provider_Pay_Amount_Local_Ccy: dxValueChange.value,
                    },
                    providerOverrideValue: dxValueChange.value,
                    isProviderNetOverride: true,
                }),
                () => {
                    this.providerPayTaxCalculation();
                    this.state.providerNetChangeTimer = setTimeout(this.startCallingCalcOnProviderNetChange, 1000);
                }
            );
        }
    };
    startCallingCalcOnProviderNetChange = () => {
        if (this.state.providerNetChangeTimer) {
            clearTimeout(this.state.providerNetChangeTimer);
            this.state.providerNetChangeTimer = null;
            this.financialCalculations();
        }
    };

    handleChangeProviderPayAccrualAmount = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            const existingAccrual = this.state.editViewDataItem.accrual;
            const newProviderAccrual = dxValueChange.value;
            const clientBillableAmountAccrual = existingAccrual
                ? newProviderAccrual + existingAccrual.grossProfitAmountAccrual
                : newProviderAccrual;

            const updatedAccrual = {
                ...existingAccrual,
                providerPayAmountAccrual: newProviderAccrual,
                clientBillableAmountAccrual,
            };
            const updatedItem = {
                ...this.state.editViewDataItem,
                accrual: updatedAccrual,
            };

            const clientAccrualAmount = this.utils.clientAccrualTaxCal(updatedItem as AddEditFormData, this.state.configuarationValue);
            const clientBillableAccrualTax = clientAccrualAmount.length > 0 ? clientAccrualAmount[0] : 0;
            const clientBillableAccrualTotal = clientAccrualAmount.length > 0 ? clientAccrualAmount[1] : 0;

            const providerAccrualAmount = this.utils.providerPayAccrualTaxCal(updatedItem as AddEditFormData, this.state.configuarationValue);
            const providerAccrualTaxLocalCcy = providerAccrualAmount.length > 0 ? providerAccrualAmount[0] : 0;
            const providerAccrualTotalLocalCcy = providerAccrualAmount.length > 0 ? providerAccrualAmount[1] : 0;

            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    accrual: {
                        ...prevState.editViewDataItem.accrual,
                        providerPayAmountAccrual: newProviderAccrual,
                        clientBillableAmountAccrual,
                        clientBillableAmountTaxAccrual: clientBillableAccrualTax,
                        clientBillableAmountTotalAccrual: clientBillableAccrualTotal,
                        providerPayAmountTaxAccrual: providerAccrualTaxLocalCcy,
                        providerPayAmountTotalAccrual: providerAccrualTotalLocalCcy,
                    },
                },
            }));
        }
    };

    handleChangeFeeLocalCurrancyAmount = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            const newFeeAmount = dxValueChange.value;
            const providerAmount = this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy;
            const clientBillableAmount = providerAmount
                ? providerAmount + newFeeAmount
                : newFeeAmount;

            const updatedItem = {
                ...this.state.editViewDataItem,
                fee_Amount_Local_Ccy: newFeeAmount,
                client_Billable_Amount_Local_Ccy: clientBillableAmount,
            };

            const clientAmount = this.utils.clientTaxCal(updatedItem, this.state.configuarationValue);
            const clientBillableTaxLocalCcy = clientAmount.length > 0 ? clientAmount[0] : 0;
            const clientBillableTotalLocalCcy = this.state.editViewDataItem.client_Tax_Applicable != ""
                ? clientBillableAmount + clientBillableTaxLocalCcy
                : clientBillableAmount;

            const feeAmount = this.utils.feeTaxCal(updatedItem, this.state.configuarationValue);
            const feeTaxLocalCcy = feeAmount.length > 0 ? feeAmount[0] : 0;
            const feeTotalLocalCcy = feeAmount.length > 0 ? feeAmount[1] : 0;

            this.setState(
                (prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        fee_Amount_Local_Ccy: newFeeAmount,
                        client_Billable_Amount_Local_Ccy: clientBillableAmount,
                        client_Billable_Tax_Local_Ccy: clientBillableTaxLocalCcy,
                        client_Billable_Total_Local_Ccy: clientBillableTotalLocalCcy,
                        fee_Tax_Local_Ccy: feeTaxLocalCcy,
                        fee_Total_Local_Ccy: feeTotalLocalCcy,
                    },
                }),
                () => {
                    // Run after fee_Amount_Local_Ccy has actually committed to state —
                    // nonStandardDropDownValueSelection reads this.state.editViewDataItem.fee_Amount_Local_Ccy,
                    // which would otherwise still hold the pre-update amount here (setState is batched,
                    // not applied synchronously).
                    this.nonStandardDropDownValueSelection();
                }
            );
        }
    };

    handleChangeFeeAccrualAmount = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            const existingAccrual = this.state.editViewDataItem.accrual;
            const newGrossProfitAccrual = dxValueChange.value;

            const clientBillableAmountAccrual = existingAccrual && existingAccrual.providerPayAmountAccrual
                ? existingAccrual.providerPayAmountAccrual + newGrossProfitAccrual
                : existingAccrual ? newGrossProfitAccrual : 0;

            const updatedAccrual = {
                ...existingAccrual,
                grossProfitAmountAccrual: newGrossProfitAccrual,
                clientBillableAmountAccrual,
            };

            const updatedItem = {
                ...this.state.editViewDataItem,
                accrual: updatedAccrual,
            };

            const clientAccrualAmount = this.utils.clientAccrualTaxCal(updatedItem as AddEditFormData, this.state.configuarationValue);
            const clientBillableAccrualTaxLocalCcy = clientAccrualAmount.length > 0 ? clientAccrualAmount[0] : 0;

            const clientBillableAmountTotalAccrual = this.state.editViewDataItem.client_Tax_Applicable != ""
                ? clientBillableAmountAccrual + clientBillableAccrualTaxLocalCcy
                : clientBillableAmountAccrual;

            const updatedAccrualWithTax = {
                ...updatedAccrual,
                clientBillableAmountTaxAccrual: clientBillableAccrualTaxLocalCcy,
                clientBillableAmountTotalAccrual,
            };

            const feeAccrualAmount = this.utils.feeAccrualTaxCal(
                { ...updatedItem, accrual: updatedAccrualWithTax } as AddEditFormData,
                this.state.configuarationValue
            );

            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    accrual: feeAccrualAmount.length > 0
                        ? {
                            ...updatedAccrualWithTax,
                            grossProfitAmountTaxAccrual: feeAccrualAmount[0],
                            grossProfitAmountTotalAccrual: feeAccrualAmount[1],
                        }
                        : updatedAccrualWithTax,
                },
            }));
        }
    };
    handleChangeBillLocalCurrancyAmountForFiancialAdj = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState({ clientOriginalAmountForFinancialAdj: dxValueChange.value });
        }
    };
    handleChangeBillLocalCurrancyAmount = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            const newClientAmount = dxValueChange.value;
            const updatedItem = {
                ...this.state.editViewDataItem,
                client_Billable_Amount_Local_Ccy: newClientAmount,
            };
            const clientAmount = this.utils.clientTaxCal(updatedItem, this.state.configuarationValue);
            const clientBillableTaxLocalCcy = clientAmount.length > 0 ? clientAmount[0] : 0;
            const clientBillableTotalLocalCcy = clientAmount.length > 0 ? clientAmount[1] : 0;

            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    client_Billable_Amount_Local_Ccy: newClientAmount,
                    client_Billable_Tax_Local_Ccy: clientBillableTaxLocalCcy,
                    client_Billable_Total_Local_Ccy: clientBillableTotalLocalCcy,
                },
            }));
        }
    };

    handleChangeBillAccrualAmount = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    accrual: {
                        ...prevState.editViewDataItem.accrual,
                        clientBillableAmountAccrual: dxValueChange.value,
                    },
                },
            }), () => {
                this.clientTaxAccrualCalculation();
            });
        }
    };

    handleChangeProviderLocalCurrancyTax = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    provider_Pay_Tax_Local_Ccy: dxValueChange.value,
                    provider_Pay_Total_Local_Ccy:
                        this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy + dxValueChange.value,
                },
            }));
        }
    };

    handleChangeFeeLocalCurrancyTax = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    fee_Tax_Local_Ccy: dxValueChange.value,
                    fee_Total_Local_Ccy: this.state.editViewDataItem.fee_Amount_Local_Ccy + dxValueChange.value,
                },
            }));
        }
    };

    handleChangeBillLocalCurrancyTax = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    client_Billable_Tax_Local_Ccy: dxValueChange.value,
                    client_Billable_Total_Local_Ccy:
                        this.state.editViewDataItem.client_Billable_Amount_Local_Ccy + dxValueChange.value,
                },
            }));
        }
    };

    handleChangeProviderOriginalAmount = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    provider_Pay_Original_Amount_Local_Ccy: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeFeeNonStandardTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    non_Standard: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeAccrualTypeSelect = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        // Run after isAccrual has actually committed to state (when this is a real value change below) —
        // otherwise this guard reads the pre-update isAccrual here (setState is batched, not applied
        // synchronously), so toggling accrual wouldn't trigger a recalculation on that click.
        const runCalculationCheck = () => {
            if (
                (this.state.editViewDataItem.isAccrual.toString() == "Yes" ||
                    this.state.editViewDataItem.isAccrual == true) &&
                this.state.editViewDataItem.rate_Decimal
            ) {
                this.financialCalculations();
            }
        };
        if (dxValueChange.event !== undefined) {
            this.setState(
                (prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        isAccrual: dxValueChange.value,
                        accrual: null,
                    },
                }),
                runCalculationCheck
            );
        } else {
            runCalculationCheck();
        }
    };

    handleChangeHoldPayment = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    holdPayment: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeHardApproval = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    hardApproval: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeBillOriginalAmount = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    client_Billable_Original_Amount_Local_Ccy: dxValueChange.value,
                },
            }));
        }
    };

    handleChangePayDate = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    pay_Date: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeBillDate = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    bill_Date: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeInternalComments = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    internalComments: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeSetNumber = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    performanceInformationSetsNumber: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeDuration = (dxValueChange: NumberBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    performanceInformationSetsDuration: dxValueChange.value,
                },
            }));
        }
    };
    handleChangePerformanceInfo = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    performanceInformation: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeAdditionalInfo = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    additionalInformation: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeEquipmentRequired = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    equipmentRequired: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeDescription = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    shiftCompleteAcknowledgmentDescription: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeExtraDescription = (dxValueChange: TextBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    providerPayAmountLocalExtrasDescription: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeArtistConfirmation = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    shiftCompleteAcknowledgment: dxValueChange.value,
                },
            }));
        }
    };
    handleChangeReoccurance = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    reoccurance: dxValueChange.value,
                },
            }));
        }
    };

    //#endregion
    //#region DataSubmissionToServer
    // Submit the form data to the server.
    successMessageVisible = () => {
        this.setState({
            IsShowSuccess: true,
        });
    };

    failureMessageVisible = () => {
        this.setState({
            IsShowError: true,
        });
    };

    hideLoadpanel = () => {
        this.setState({ loadPanelVisible: false });
    };

    renderRedirect = (billableItemId: string, isShowSuccess: boolean = this.state.IsShowSuccess) => {
        //sangeeta
        this.utils.renderRedirectCommonMethod(this.props, isShowSuccess, "apply", billableItemId);
    };

    onCancel = () => {
        if (window.location.pathname.includes("queryGrid")) {
            this.props.hidePopup(false);
        }
        this.utils.renderRedirectCommonMethod(this.props, this.state.IsShowSuccess, "cancel", "");
    };

    handleFormDataSubmissionSuccess = (response: any) => {
        this.hideLoadpanel();
        this.successMessageVisible();
        let billableItemId: string = "";
        if (response && response.data && response.data.data.length > 0) {
            billableItemId = response.data.data[0].billableItemId;
        }
        if (window.location.pathname.includes("queryGrid")) {
            this.props.hidePopup(false);
        }
        this.setState({
            IsShowError: false,
        });
        if (!this.state.createClientCreditPopUp) {
            // Pass true directly — IsShowSuccess set by successMessageVisible above hasn't committed to
            // state yet (setState is batched), so this.state.IsShowSuccess would still be false here.
            this.renderRedirect(billableItemId, true);
        }
    };
    validate = (statusId: string, itemTypeId: string) => {
        // we are going to store errors for all fields
        // in a signle array
        let errorsAdjustment: string[] = [];

        if (
            itemTypeId == this.state.itemTypeLookUp[1].id ||
            itemTypeId == this.state.itemTypeLookUp[3].id ||
            itemTypeId == this.state.itemTypeLookUp[4].id
        ) {
            if (
                this.state.editViewDataItem.approval_Date != null ||
                this.state.editViewDataItem.approval_Date != undefined ||
                this.state.editViewDataItem.bill_Date != null ||
                this.state.editViewDataItem.bill_Date != undefined ||
                this.state.editViewDataItem.accept_Date != null ||
                this.state.editViewDataItem.accept_Date != undefined
            ) {
                return errorsAdjustment;
            } else if (
                this.state.editViewDataItem.approval_Date == null ||
                this.state.editViewDataItem.approval_Date == undefined
            ) {
                errorsAdjustment.push("For Adjustment, Shift should be 'Approved'/'Billed'/'Accepted'/'Paid'");
            } else if (
                this.state.editViewDataItem.bill_Date == null ||
                this.state.editViewDataItem.bill_Date == undefined
            ) {
                errorsAdjustment.push("For Adjustment, Shift should be 'Approved'/'Billed'/'Accepted'/'Paid'");
            } else if (
                this.state.editViewDataItem.accept_Date == null ||
                this.state.editViewDataItem.accept_Date == undefined
            ) {
                errorsAdjustment.push("For Adjustment, Shift should be 'Approved'/'Billed'/'Accepted'/'Paid'");
            } else if (
                this.state.editViewDataItem.pay_Date == null ||
                this.state.editViewDataItem.pay_Date == undefined
            ) {
                errorsAdjustment.push("For Adjustment, Shift should be 'Approved'/'Billed'/'Accepted'/'Paid'");
            }
        }
        return errorsAdjustment;
    };

    checkAmounts = () => {
        if (
            this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy == 0 ||
            this.state.editViewDataItem.fee_Amount_Local_Ccy == 0 ||
            this.state.editViewDataItem.client_Billable_Amount_Local_Ccy == 0
        ) {
            this.setState({ showWarningPopup: true });
        } 
        // else if (this.state.editViewDataItem.billableActivityType === "20") {
        //     this.setState({ createClientCreditPopUp: true });
        // } 
        else {
            this.onSubmit();
        }
    };
    hideWarningPopup = () => {
        this.setState({ showWarningPopup: false });
    };
    hideProviderReversalPopup1 = () => {
        this.setState({ showReversalPopupTab1: false, showReversalPopupTab2: true });
    };
    closeAllPopUp = () => {
        this.setState({ showReversalPopupTab1: false });
    };
    closeAllPopUp2 = () => {
        this.setState({ showReversalPopupTab2: false });
    };
    hideProviderReversalPopup2 = () => {
        this.setState({ showReversalPopupTab2: false });
    };
    hideShowPromotionPopUp= () => {
        this.setState({ showPromotionPopUp: false });
    };
    handleFinishProviderReversal = () => {
        this.setState({ showReversalPopupTab2: false });
        this.onSubmit();
    };
    hideCreateClientCreditPopUp = () => {
        this.setState({ createClientCreditPopUp: false });
    };
    onSubmitFromPopUp = () => {
        // if (this.state.editViewDataItem.billableActivityType === "20") {
        //     this.setState({ createClientCreditPopUp: true });
        // }else{
        this.onSubmit();
        // }
    };
    onSubmit = () => {
        let itemType = "";
        let statusId = "";
        let billableItemIdValueForAdjustment = "";
        let paretRecordIdForAdjustment = "";
        let originalAmountForAdjustment = "";
        let approveDate = null;
        let acceptDate = null;
        let artistConfirmation: boolean = false;
        let amend: boolean = false;
        amend = this.props.location && this.props.location.state && this.props.location.state.isAmend;
        var serviceFeeMatrixVal = this.billableItemUtils.serviceFeeMatrixDerivation(
            this.state.editViewDataItem.clientId,
            this.state.editViewDataItem.serviceTypeId,
            this.state.editViewDataItem.serviceSubTypeId
        );
        this.setState({
            loadPanelVisible: true,
        });
        if (this.state.editViewDataItem.shiftCompleteAcknowledgment) {
            if (
                this.state.editViewDataItem.shiftCompleteAcknowledgment.toString().toUpperCase() == "TRUE" ||
                this.state.editViewDataItem.shiftCompleteAcknowledgment.toString().toUpperCase() == "YES"
            ) {
                artistConfirmation = true;
            }
        }
        if (this.props.location && this.props.location.state && this.props.location.state.id == 0) {
            if (this.state.editViewDataItem.itemTypeId == "") {
                itemType = this.state.itemTypeLookUp[0].id;
            }
        }
        if (this.props.location && this.props.location.state && this.props.location.state.isEdit) {
            if (UserService.isUserInGroup(RoleGroupNames.VenueManager)) {
                if (this.state.editViewDataItem.billableStatusLookupId == Status.Approved) {
                    approveDate = new Date();
                }
            }
            if (UserService.isUserInGroup(RoleGroupNames.ProviderScheduler)) {
                if (this.state.editViewDataItem.billableStatusLookupId == Status.Accepted) {
                    acceptDate = new Date();
                }
            }
            amend = this.billableItemUtils.acceptanceRecordCreation(
                this.state.editViewDataItem.tenseFlag,
                this.state.editViewDataItem.itemTypeId,
                this.state.isChangePendingToApprove,
                this.state.editViewDataItem.serviceSubTypeId,
                this.state.editViewDataItem.billable_Minutes,
                this.state.editViewDataItem.scheduledMinutes,
                this.state.editViewDataItem.billableRate,
                this.state.editViewDataItem.scheduleRate,
                this.state.editViewDataItem.equipmentBillableQuantity,
                this.state.editViewDataItem.equipmentScheduleQuantity,
                serviceFeeMatrixVal.valueOfProviderAcceptance
            );
            if (amend) {
                statusId = this.billableItemUtils.billableItemStatusSetBasedOnItemType(
                    this.state.editViewDataItem.itemTypeId,
                    serviceFeeMatrixVal.valueOfProviderAcceptance
                );
            }
        }
        if (this.props.location && this.props.location.state && this.props.location.state.isAdjust) {
            if (
                (this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[1].id ||
                    this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[3].id ||
                    this.state.editViewDataItem.itemTypeId == this.state.itemTypeLookUp[4].id) &&
                (this.state.acceptDate != null ||
                    this.state.acceptDate != undefined ||
                    this.state.editViewDataItem.paymentId != null ||
                    this.state.editViewDataItem.paymentId != undefined ||
                    this.state.approvalDate != null ||
                    this.state.approvalDate != undefined ||
                    this.state.editViewDataItem.invoiceId != null ||
                    this.state.editViewDataItem.invoiceId != undefined)
            ) {
                if (this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy == 0) {
                    statusId = Status.Pending;
                    itemType = this.state.itemTypeLookUp[1].id; // Adjustment
                } else if (Math.sign(this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy) == 1) {
                    if (UserService.isUserInGroup(RoleGroupNames.VenueManager)) {
                        statusId = Status.Approved;
                        approveDate = new Date();
                    } else {
                        statusId = Status.Pending;
                    }
                    itemType = this.state.itemTypeLookUp[3].id; // AdjustmentClientDebit
                } else if (Math.sign(this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy) == -1) {
                    if (UserService.isUserInGroup(RoleGroupNames.ProviderScheduler)) {
                        statusId = Status.Accepted;
                        acceptDate = new Date();
                    } else {
                        statusId = this.billableItemUtils.billableItemStatusSetBasedOnItemType(
                            this.state.editViewDataItem.itemTypeId,
                            serviceFeeMatrixVal.valueOfProviderAcceptance
                        );
                    }
                    itemType = this.state.itemTypeLookUp[4].id; // adjustmentProviderDebit
                }
                billableItemIdValueForAdjustment = "0";
                paretRecordIdForAdjustment = this.state.editViewDataItem.billableItemId;
            }
        }

        var billableItemSubmitRequest = this.utils.convertFormDataToBillableItemRequest(
            this.state.editViewDataItem,
            statusId,
            itemType,
            amend,
            billableItemIdValueForAdjustment,
            paretRecordIdForAdjustment,
            originalAmountForAdjustment,
            acceptDate,
            approveDate,
            artistConfirmation,
            ""
        );

        if (billableItemSubmitRequest.updateOrCorrection == false) {
            billableItemSubmitRequest.equipmentScheduleQuantity = billableItemSubmitRequest.equipmentQuantity;
            billableItemSubmitRequest.scheduleRate = billableItemSubmitRequest.rate;
        }

        var billableItemSubmitRequestArr: BillableItemSubmitRequest[] = [];
        billableItemSubmitRequestArr.push(billableItemSubmitRequest);
        this.setState({ showWarningPopup: false });
        //passing object data to the server
        this.editViewService
            .uploadEditAddDataV2(billableItemSubmitRequestArr)
            .then(this.handleFormDataSubmissionSuccess)
            .catch((err) => {
                this.setState({
                    errorMessage:
                        err.response && err.response.data && err.response.data.error
                            ? JSON.parse(JSON.stringify(err.response.data.error))
                            : null,
                    IsShowSuccess: false,
                });
                this.failureMessageVisible();
                this.hideLoadpanel();
            })
            .finally(() => {
                this.hideLoadpanel();
            });
    };

    onSubmitQuery = () => {
        let querySubmissionError: string = "";
        querySubmissionError = this.validationCheckFunction();
        if (querySubmissionError.length > 0) {
            this.setState({
                validationMessage: querySubmissionError,
            });
        } else {
            this.setState({
                validationMessage: "",
                loadPanelVisible: true,
            });
            this.editViewService
                .uploadQueryFormData(this.state.queryItem)
                .then(this.handleQuerySubmissionSuccess)
                .catch(this.handleQuerySubmissionFailure);
        }
    };

    validationCheckFunction = () => {
        let errorMessage: string = "";
        let commentsField: string = this.state.editViewDataItem.comments.trim();
        if (commentsField.length === 0) {
            errorMessage = "Please Enter the Query Description in the comments.";
        }
        return errorMessage;
    };

    handleQuerySubmissionSuccess = (response: AxiosResponse<any>) => {
        this.hideLoadpanel();
        this.navigateBack();
    };

    handleQuerySubmissionFailure = (error: any) => {
        this.hideLoadpanel();
    };

    navigateBack = () => {
        this.props.history.goBack(); // Return back to the page on a form submission success.
    };

    nonStandardDropDownValueSelection = () => {
        if (this.state.editViewDataItem.fee_Amount_Local_Ccy && this.state.expectedFee) {
            var eventNet: string = this.state.editViewDataItem.fee_Amount_Local_Ccy.toString();
            var expectedFee: string = this.state.expectedFee.toString();
            if (parseFloat(eventNet) == parseFloat(expectedFee)) {
                this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        non_Standard: "Standard",
                    },
                }));
            } else {
                this.setState((prevState: any) => ({
                    editViewDataItem: {
                        ...prevState.editViewDataItem,
                        non_Standard: "Non - Standard",
                    },
                }));
            }
        }
    };

    onContentReadyDateBox = (e: any) => {
        this.onClickElementSelection(e);
    };

    onContentReadyNumberBox = (e: any) => {
        this.onClickElementSelection(e);
    };

    onClickElementSelection = (e: any) => {
        e.element.addEventListener("click", function () {
            let inputElement = e.element.querySelector(".dx-texteditor-input");
            inputElement.selectionStart = 0;
            inputElement.selectionEnd = inputElement.value.length;
        });
    };

    //#endregion
    renderPersonnelShiftPanel = () => {
        var maskedValue: string =
            this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionPersonnel
                ? "0000-0000-0000-0000"
                : "";

        let calendarMin;
        if (UserService.isUserInGroup(RoleGroupNames.ProviderScheduler)) {
            calendarMin = new Date();
        }
        if (this.state.editViewDataItem.serviceTypeId == ServiceType.Security) {
            if (
                this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionPersonnel ||
                (this.state.editViewDataItem.serviceTypeId == ServiceType.Security &&
                    this.state.editViewDataItem.serviceSubTypeId != SubServiceType.DoorSupervisionEquipment)
            ) {
                return (
                    <section className="card card-form my-5">
                        <div className="card-body">
                            <h3 className="card-form__section-heading">Shift</h3>
                            <hr className="horizontal_border_style"></hr>
                            <div className="row mx-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Service
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DropDownFromLookupTableDynamic
                                            lookupTypeIndex={LookupTypeIndexes.serviceType}
                                            isRoot={true}
                                            parentMappingId={"0"}
                                            onValueChanged={this.handleChangeServiceTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.serviceTypeId}
                                        />
                                        <input
                                            data-testid={LookupTypeIndexes.serviceType}
                                            type="hidden"
                                            name={LookupTypeIndexes.serviceType}
                                            value={
                                                this.state.editViewDataItem.serviceTypeId
                                                    ? this.state.editViewDataItem.serviceTypeId
                                                    : ""
                                            }
                                        ></input>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Status
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DropDownFromLookupTable
                                            lookupTypeIndex={LookupTypeIndexes.statusType}
                                            onValueChanged={this.handleChangeStatusTypeSelect}
                                            signal={this.state.createAdjustment}
                                            disableSignal={
                                                this.editAllowed ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.isDisableStatusDropDown ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.billableStatusLookupId}
                                        />
                                        <input
                                            data-testid={LookupTypeIndexes.statusType}
                                            type="hidden"
                                            name={LookupTypeIndexes.statusType}
                                            value={
                                                this.state.editViewDataItem.billableStatusLookupId
                                                    ? this.state.editViewDataItem.billableStatusLookupId
                                                    : 0
                                            }
                                        ></input>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Client
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            lookupTypeIndex={LookupTypeIndexes.clientType}
                                            onValueChanged={this.handleChangeClientTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            isRoot={false}
                                            parentMappingId={""}
                                            displayExpression={"value"}
                                            value={this.state.editViewDataItem.clientId}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Provider
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            lookupTypeIndex={LookupTypeIndexes.providerType}
                                            onValueChanged={this.handleChangeProviderTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            isRoot={false}
                                            parentMappingId={""}
                                            displayExpression={"value"}
                                            value={this.state.editViewDataItem.providerId}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Date
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DateBox
                                            disabled={
                                                this.state.createAdjustment
                                                    ? this.state.createAdjustment
                                                    : (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAmend) ||
                                                      this.state.readOnlyView ||
                                                      (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeDate}
                                            value={
                                                this.state.editViewDataItem.date
                                                    ? this.state.editViewDataItem.date
                                                    : undefined
                                            }
                                            useMaskBehavior={true}
                                            displayFormat="dd/MM/yyyy"
                                            min={calendarMin}
                                        ></DateBox>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Venue
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            lookupTypeIndex={LookupTypeIndexes.venueType}
                                            onValueChanged={this.handleChangeVenueTypeSelect}
                                            isRoot={false}
                                            parentMappingId={this.state.editViewDataItem.clientId}
                                            value={this.state.editViewDataItem.venueId}
                                            displayExpression={"value"}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Sub Type
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            lookupTypeIndex={LookupTypeIndexes.subServiceType}
                                            isRoot={false}
                                            parentMappingId={this.state.editViewDataItem.serviceTypeId}
                                            displayExpression={"value"}
                                            onValueChanged={this.handleChangeServiceSubTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.serviceSubTypeId}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Unscheduled
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <SelectBox
                                            dataSource={this.decisionTypesDataSource}
                                            displayExpr="value"
                                            valueExpr="value"
                                            onValueChanged={this.handleChangeUnscheduledSelect}
                                            value={
                                                this.state.editViewDataItem.unscheduled == "Yes" ||
                                                this.state.editViewDataItem.unscheduled == "True"
                                                    ? "Yes"
                                                    : "No"
                                            }
                                            disabled={
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Worker Status
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DropDownFromLookupTable
                                            lookupTypeIndex={LookupTypeIndexes.workerstatus}
                                            onValueChanged={this.handleChangeWorkerStatus}
                                            signal={this.state.createAdjustment}
                                            disableSignal={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.workerStatusId}
                                            recordType="active"
                                        />
                                        <input
                                            data-testid={LookupTypeIndexes.workerstatus}
                                            type="hidden"
                                            name={LookupTypeIndexes.workerstatus}
                                            value={
                                                this.state.editViewDataItem.workerStatusId
                                                    ? this.state.editViewDataItem.workerStatusId
                                                    : 0
                                            }
                                        ></input>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <LoadIndicator
                                        id="load-indicator"
                                        className="load-indicator--centered"
                                        height={40}
                                        width={40}
                                        visible={this.state.loadIndicatorVisible}
                                    />
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Type/Role
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>

                                    <div className="col-12 col-xl-9 pl-0">
                                        <DropDownFromLookupTableDynamic
                                            lookupTypeIndex={LookupTypeIndexes.offeringsType}
                                            isRoot={false}
                                            parentMappingId={this.state.editViewDataItem.serviceSubTypeId}
                                            onValueChanged={this.handleChangeOfferingsTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.typeId}
                                        />
                                        <input
                                            data-testid={LookupTypeIndexes.offeringsType}
                                            type="hidden"
                                            name={LookupTypeIndexes.offeringsType}
                                            value={
                                                this.state.editViewDataItem.typeId
                                                    ? this.state.editViewDataItem.typeId
                                                    : ""
                                            }
                                        ></input>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 pr-0">
                                    <div className="row">
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-md-auto col-12 col-xl-6 text-left text-xl-right">
                                                Scheduled Start
                                            </label>
                                            <sup className="card-form__mandatory-symbol-Scheduled-Start">*</sup>
                                            <div className="col-12 col-xl-6 pl-2">
                                                <DateBox
                                                    type="time"
                                                    interval={15}
                                                    placeholder="00:00"
                                                    useMaskBehavior={true}
                                                    displayFormat={"HH:mm"}
                                                    disabled={
                                                        this.state.createAdjustment ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAmend) ||
                                                        this.state.IsLockTimeFields ||
                                                        this.state.readOnlyView ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAdjust)
                                                    }
                                                    onValueChanged={this.handleChangeShiftStart}
                                                    value={
                                                        this.state.editViewDataItem.shift_Start
                                                            ? this.state.editViewDataItem.shift_Start
                                                            : undefined
                                                    }
                                                    onContentReady={this.onContentReadyDateBox}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                End
                                            </label>
                                            <div className="col-12 col-xl-6 pl-0">
                                                <DateBox
                                                    type="time"
                                                    interval={15}
                                                    placeholder="00:00"
                                                    useMaskBehavior={true}
                                                    displayFormat={"HH:mm"}
                                                    disabled={
                                                        this.state.createAdjustment ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAmend) ||
                                                        this.state.IsLockTimeFields ||
                                                        this.state.readOnlyView ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAdjust)
                                                    }
                                                    onValueChanged={this.handleChangeShiftEnd}
                                                    value={
                                                        this.state.editViewDataItem.shift_End
                                                            ? this.state.editViewDataItem.shift_End
                                                            : undefined
                                                    }
                                                    onContentReady={this.onContentReadyDateBox}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Rate
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>

                                    <div className="col-12 col-xl-9 pl-0">
                                        <NumberBox
                                            disabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            format={{
                                                type: "currency",
                                                precision: 2,
                                                currency: "GBP",
                                            }}
                                            onValueChanged={this.handleChangeRate}
                                            valueChangeEvent="keyup"
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.rate_Decimal
                                                    : this.state.editViewDataItem.rate_Decimal
                                            }
                                            onContentReady={this.onContentReadyNumberBox}
                                            step={0}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Name
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <TextBox
                                            disabled={
                                                this.state.createAdjustment
                                                    ? this.state.createAdjustment
                                                    : (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAmend) ||
                                                      this.state.readOnlyView ||
                                                      (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeName}
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.name
                                                    : this.state.editViewDataItem.name
                                            }
                                        ></TextBox>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 pr-0">
                                    <div className="row">
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Check In
                                            </label>
                                            <div className="col-12 col-xl-6 pl-2">
                                                <DateBox
                                                    type="time"
                                                    placeholder="00:00"
                                                    useMaskBehavior={true}
                                                    displayFormat={"HH:mm"}
                                                    disabled={true}
                                                    value={
                                                        this.state.editViewDataItem.check_In
                                                            ? this.state.editViewDataItem.check_In
                                                            : undefined
                                                    }
                                                ></DateBox>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Check Out
                                            </label>
                                            <div className="col-12 col-xl-6 pl-0">
                                                <DateBox
                                                    type="time"
                                                    placeholder="00:00"
                                                    useMaskBehavior={true}
                                                    displayFormat={"HH:mm"}
                                                    disabled={true}
                                                    value={
                                                        this.state.editViewDataItem.check_Out
                                                            ? this.state.editViewDataItem.check_Out
                                                            : undefined
                                                    }
                                                ></DateBox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Chargeable Time
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <NumberBox
                                            disabled={true}
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.billable_Minutes
                                                    : this.state.editViewDataItem.billable_Minutes
                                            }
                                        ></NumberBox>
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-md-auto col-xl-3 text-left text-xl-right">
                                        Licence No.
                                    </label>
                                    <sup className="card-form__mandatory-symbol-Licence-No">*</sup>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <TextBox
                                            mask={maskedValue}
                                            disabled={
                                                this.state.createAdjustment
                                                    ? this.state.createAdjustment
                                                    : (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAmend) ||
                                                      this.state.readOnlyView ||
                                                      (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeIdentificationNumber}
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.identification_Number
                                                    : this.state.editViewDataItem.identification_Number
                                            }
                                        ></TextBox>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 pr-0">
                                    <div className="row">
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-md-auto col-xl-6 text-left text-xl-right">
                                                Approved Start
                                            </label>
                                            <sup className="card-form__mandatory-symbol-Approved-Start">*</sup>
                                            <div className="col-12 col-xl-6 pl-2">
                                                <DateBox
                                                    type="time"
                                                    interval={15}
                                                    placeholder="00:00"
                                                    useMaskBehavior={true}
                                                    displayFormat={"HH:mm"}
                                                    onValueChanged={this.handleChangeBillableStart}
                                                    valueChangeEvent="keyup"
                                                    value={
                                                        this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust &&
                                                        this.state.editViewVirtualDataItem.billable_Start
                                                            ? this.state.editViewVirtualDataItem.billable_Start
                                                            : this.state.editViewDataItem.billable_Start
                                                            ? this.state.editViewDataItem.billable_Start
                                                            : undefined
                                                    }
                                                    disabled={
                                                        this.state.IsLockBillableFields ||
                                                        this.state.IsLockTimeFields ||
                                                        this.state.readOnlyView ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAdjust)
                                                    }
                                                    onContentReady={this.onContentReadyDateBox}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                End
                                            </label>
                                            <div className="col-12 col-xl-6 pl-0">
                                                <DateBox
                                                    type="time"
                                                    interval={15}
                                                    placeholder="00:00"
                                                    useMaskBehavior={true}
                                                    displayFormat={"HH:mm"}
                                                    onValueChanged={this.handleChangeBillableFinish}
                                                    valueChangeEvent="keyup"
                                                    value={
                                                        this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust &&
                                                        this.state.editViewVirtualDataItem.billable_Finish
                                                            ? this.state.editViewVirtualDataItem.billable_Finish
                                                            : this.state.editViewDataItem.billable_Finish
                                                            ? this.state.editViewDataItem.billable_Finish
                                                            : undefined
                                                    }
                                                    disabled={
                                                        this.state.IsLockBillableFields ||
                                                        this.state.IsLockTimeFields ||
                                                        this.state.readOnlyView ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAdjust)
                                                    }
                                                    onContentReady={this.onContentReadyDateBox}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-md-auto col-md col-xl-3 text-left text-xl-right">
                                        Provider Net
                                    </label>
                                    <sup className="card-form__mandatory-symbol-Provider-Net">*</sup>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <NumberBox
                                            format={{
                                                type: "currency",
                                                precision: 2,
                                                currency: "GBP",
                                            }}
                                            onValueChanged={this.handleChangeProviderLocalCurrancyAmount}
                                            valueChangeEvent="keyup"
                                            value={this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy}
                                            disabled={
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            step={0}
                                            onContentReady={this.onContentReadyNumberBox}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Cover
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <SelectBox
                                            disabled={
                                                this.state.createAdjustment ||
                                                this.state.IsLockTimeFields ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            dataSource={this.decisionTypesDataSource}
                                            displayExpr="value"
                                            valueExpr="value"
                                            onValueChanged={this.handleChangeCover}
                                            value={
                                                this.state.editViewDataItem.cover == "" &&
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.id == 0
                                                    ? "No"
                                                    : this.props.location &&
                                                      this.props.location.state &&
                                                      this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.cover
                                                    : this.state.editViewDataItem.cover
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Absent
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <SelectBox
                                            disabled={
                                                this.state.createAdjustment ||
                                                this.state.IsLockTimeFields ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            dataSource={this.absentTypeDataSource}
                                            displayExpr="value"
                                            valueExpr="value"
                                            onValueChanged={this.handleChangeAbsent}
                                            value={
                                                this.state.editViewDataItem.absent == "" &&
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.id == 0
                                                    ? "Present"
                                                    : this.props.location &&
                                                      this.props.location.state &&
                                                      this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.absent
                                                    : this.state.editViewDataItem.absent
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Charge
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <SelectBox
                                            disabled={
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            dataSource={this.chargeTypesDataSource}
                                            displayExpr="value"
                                            valueExpr="value"
                                            onValueChanged={this.handleChangeNoChange}
                                            value={
                                                this.state.editViewDataItem.noCharge == "" &&
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.id == 0
                                                    ? "Applied"
                                                    : this.props.location &&
                                                      this.props.location.state &&
                                                      this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.noCharge
                                                    : this.state.editViewDataItem.noCharge
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-1 text-left text-xl-right">
                                        External Comments (Public)
                                    </label>
                                    <div className="col-12 col-xl-11 pl-0">
                                        <TextArea
                                            height={100}
                                            value={this.state.editViewDataItem.comments}
                                            onValueChanged={this.handleChangeComments}
                                            disabled={this.state.readOnlyView}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-md-auto col-xl-1 text-left text-xl-right">
                                        Internal Comments (Private)
                                    </label>
                                    <sup className="card-form__mandatory-symbol-Internal-Comments">*</sup>
                                    <div className="col-12 col-xl-11 pl-0">
                                        <TextArea
                                            height={100}
                                            value={this.state.editViewDataItem.internalComments}
                                            onValueChanged={this.handleChangeInternalComments}
                                            disabled={this.state.readOnlyView}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                );
            }
        }
    };

    renderEquipmentShiftPanel = () => {
        var maskedValue: string =
            this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionPersonnel
                ? "0000-0000-0000-0000"
                : "";
        let calendarMin;
        if (UserService.isUserInGroup(RoleGroupNames.ProviderScheduler)) {
            calendarMin = new Date();
        }
        if (
            this.state.editViewDataItem.serviceTypeId == ServiceType.Security &&
            this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionEquipment
        ) {
            if (
                this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionEquipment ||
                this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionEquipment
            ) {
                return (
                    <section className="card card-form my-5">
                        <div className="card-body">
                            <h3 className="card-form__section-heading">Shift</h3>
                            <hr className="horizontal_border_style"></hr>
                            <div className="row mx-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Service
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DropDownFromLookupTableDynamic
                                            lookupTypeIndex={LookupTypeIndexes.serviceType}
                                            isRoot={true}
                                            parentMappingId={"0"}
                                            onValueChanged={this.handleChangeServiceTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.serviceTypeId}
                                        />
                                        <input
                                            data-testid={LookupTypeIndexes.serviceType}
                                            type="hidden"
                                            name={LookupTypeIndexes.serviceType}
                                            value={
                                                this.state.editViewDataItem.serviceTypeId
                                                    ? this.state.editViewDataItem.serviceTypeId
                                                    : ""
                                            }
                                        ></input>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Status
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DropDownFromLookupTable
                                            lookupTypeIndex={LookupTypeIndexes.statusType}
                                            onValueChanged={this.handleChangeStatusTypeSelect}
                                            signal={this.state.createAdjustment}
                                            disableSignal={
                                                this.editAllowed ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.isDisableStatusDropDown ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.billableStatusLookupId}
                                        />
                                        <input
                                            data-testid={LookupTypeIndexes.statusType}
                                            type="hidden"
                                            name={LookupTypeIndexes.statusType}
                                            value={
                                                this.state.editViewDataItem.billableStatusLookupId
                                                    ? this.state.editViewDataItem.billableStatusLookupId
                                                    : 0
                                            }
                                        ></input>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Client
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            lookupTypeIndex={LookupTypeIndexes.clientType}
                                            onValueChanged={this.handleChangeClientTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            isRoot={false}
                                            parentMappingId={""}
                                            displayExpression={"value"}
                                            value={this.state.editViewDataItem.clientId}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Provider
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            lookupTypeIndex={LookupTypeIndexes.providerType}
                                            onValueChanged={this.handleChangeProviderTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            isRoot={false}
                                            parentMappingId={""}
                                            displayExpression={"value"}
                                            value={this.state.editViewDataItem.providerId}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-md-auto col-12 col-xl-3 text-left text-xl-right">
                                        Date From
                                    </label>
                                    <sup className="card-form__mandatory-symbol-Date-From">*</sup>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DateBox
                                            disabled={
                                                this.state.createAdjustment
                                                    ? this.state.createAdjustment
                                                    : (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAmend) ||
                                                      this.state.readOnlyView ||
                                                      (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeDate}
                                            value={
                                                this.state.editViewDataItem.date
                                                    ? this.state.editViewDataItem.date
                                                    : undefined
                                            }
                                            useMaskBehavior={true}
                                            displayFormat="dd/MM/yyyy"
                                            min={calendarMin}
                                        ></DateBox>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Venue
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            lookupTypeIndex={LookupTypeIndexes.venueType}
                                            onValueChanged={this.handleChangeVenueTypeSelect}
                                            isRoot={false}
                                            parentMappingId={this.state.editViewDataItem.clientId}
                                            value={this.state.editViewDataItem.venueId}
                                            displayExpression={"value"}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Sub Type
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            lookupTypeIndex={LookupTypeIndexes.subServiceType}
                                            isRoot={false}
                                            parentMappingId={this.state.editViewDataItem.serviceTypeId}
                                            displayExpression={"value"}
                                            onValueChanged={this.handleChangeServiceSubTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.serviceSubTypeId}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Date To
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DateBox
                                            disabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.IsLockQuantityFields ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeDateTo}
                                            value={
                                                this.state.editViewDataItem.dateTo
                                                    ? this.state.editViewDataItem.dateTo
                                                    : undefined
                                            }
                                            useMaskBehavior={true}
                                            displayFormat="dd/MM/yyyy"
                                            onContentReady={this.onContentReadyDateBox}
                                        ></DateBox>
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Role/Type
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DropDownFromLookupTableDynamic
                                            lookupTypeIndex={LookupTypeIndexes.offeringsType}
                                            isRoot={false}
                                            parentMappingId={this.state.editViewDataItem.serviceSubTypeId}
                                            onValueChanged={this.handleChangeOfferingsTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                // this.state.typeLUDisablement ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.typeId}
                                        />
                                        <input
                                            data-testid={LookupTypeIndexes.offeringsType}
                                            type="hidden"
                                            name={LookupTypeIndexes.offeringsType}
                                            value={
                                                this.state.editViewDataItem.typeId
                                                    ? this.state.editViewDataItem.typeId
                                                    : ""
                                            }
                                        ></input>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Serial No.
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <TextBox
                                            mask={maskedValue}
                                            disabled={
                                                this.state.createAdjustment
                                                    ? this.state.createAdjustment
                                                    : (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAmend) ||
                                                      this.state.readOnlyView ||
                                                      (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeIdentificationNumber}
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.identification_Number
                                                    : this.state.editViewDataItem.identification_Number
                                            }
                                        ></TextBox>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Charge
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <SelectBox
                                            disabled={
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            dataSource={this.chargeTypesDataSource}
                                            displayExpr="value"
                                            valueExpr="value"
                                            onValueChanged={this.handleChangeNoChange}
                                            value={
                                                this.state.editViewDataItem.noCharge == "" &&
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.id == 0
                                                    ? "Applied"
                                                    : this.props.location &&
                                                      this.props.location.state &&
                                                      this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.noCharge
                                                    : this.state.editViewDataItem.noCharge
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="w-50 mx-auto">
                                    <LoadIndicator
                                        id="load-indicator"
                                        className="load-indicator"
                                        height={40}
                                        width={40}
                                        visible={this.state.loadIndicatorVisible}
                                    />
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Quantity
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <NumberBox
                                            disabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.IsLockQuantityFields ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeQuantity}
                                            valueChangeEvent="keyup"
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.equipmentQuantity
                                                    : this.state.editViewDataItem.equipmentQuantity
                                            }
                                            onContentReady={this.onContentReadyNumberBox}
                                            step={0}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Rate
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <NumberBox
                                            disabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            format={{
                                                type: "currency",
                                                precision: 2,
                                                currency: "GBP",
                                            }}
                                            onValueChanged={this.handleChangeRate}
                                            valueChangeEvent="keyup"
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.rate_Decimal
                                                    : this.state.editViewDataItem.rate_Decimal
                                            }
                                            step={0}
                                            onContentReady={this.onContentReadyNumberBox}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-md-auto col-12 col-xl-3 text-left text-xl-right">
                                        Provider Net
                                    </label>
                                    <sup className="card-form__mandatory-symbol-Provider-Net">*</sup>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <NumberBox
                                            format={{
                                                type: "currency",
                                                precision: 2,
                                                currency: "GBP",
                                            }}
                                            onValueChanged={this.handleChangeProviderLocalCurrancyAmount}
                                            valueChangeEvent="keyup"
                                            value={this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy}
                                            disabled={
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            onContentReady={this.onContentReadyNumberBox}
                                            step={0}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-1 text-left text-xl-right">
                                        External Comments (Public)
                                    </label>
                                    <div className="col-12 col-xl-11 pl-0">
                                        <TextArea
                                            height={100}
                                            value={this.state.editViewDataItem.comments}
                                            onValueChanged={this.handleChangeComments}
                                            disabled={this.state.readOnlyView}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-md-auto col-xl-1 text-left text-xl-right">
                                        Internal Comments (Private)
                                    </label>
                                    <sup className="card-form__mandatory-symbol-Internal-Comments">*</sup>
                                    <div className="col-12 col-xl-11 pl-0">
                                        <TextArea
                                            height={100}
                                            value={this.state.editViewDataItem.internalComments}
                                            onValueChanged={this.handleChangeInternalComments}
                                            disabled={this.state.readOnlyView}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                );
            }
        }
    };

    renderWeeklyCleaningShiftPanel = () => {
        let calendarMin;
        if (UserService.isUserInGroup(RoleGroupNames.ProviderScheduler)) {
            calendarMin = new Date();
        }
        let isDisableOfferingsType: boolean = true;
        let showOtherDesc: boolean = false;
        if (
            this.state.offeringsTypeLookup &&
            this.state.offeringsTypeLookup.length > 0 &&
            this.state.editViewDataItem.serviceSubTypeId
        ) {
            isDisableOfferingsType = false;
        }
        if (
            this.state.editViewDataItem.serviceTypeId == ServiceType.WindowCleaning &&
            this.state.editViewDataItem.serviceSubTypeId == "108" &&
            this.state.editViewDataItem.typeId == "516"
        ) {
            showOtherDesc = true;
        }
        if (this.state.editViewDataItem.serviceTypeId == ServiceType.ContractCleaning) {
            if (
                this.state.editViewDataItem.serviceSubTypeId == SubServiceType.WeeklyCleaning ||
                (this.state.editViewDataItem.serviceTypeId == ServiceType.ContractCleaning &&
                    this.state.editViewDataItem.serviceSubTypeId == "") ||
                this.state.editViewDataItem.serviceSubTypeId == SubServiceType.WeeklyCleaning
            ) {
                return (
                    <section className="card card-form my-5">
                        <div className="card-body">
                            <h3 className="card-form__section-heading">Shift</h3>
                            <hr className="horizontal_border_style"></hr>
                            <div className="row mx-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Service
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DropDownFromLookupTableDynamic
                                            lookupTypeIndex={LookupTypeIndexes.serviceType}
                                            isRoot={true}
                                            parentMappingId={"0"}
                                            onValueChanged={this.handleChangeServiceTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.serviceTypeId}
                                        />
                                        <input
                                            data-testid={LookupTypeIndexes.serviceType}
                                            type="hidden"
                                            name={LookupTypeIndexes.serviceType}
                                            value={
                                                this.state.editViewDataItem.serviceTypeId
                                                    ? this.state.editViewDataItem.serviceTypeId
                                                    : ""
                                            }
                                        ></input>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Status
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DropDownFromLookupTable
                                            lookupTypeIndex={LookupTypeIndexes.statusType}
                                            onValueChanged={this.handleChangeStatusTypeSelect}
                                            signal={this.state.createAdjustment}
                                            disableSignal={
                                                this.editAllowed ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.isDisableStatusDropDown ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.billableStatusLookupId}
                                        />
                                        <input
                                            data-testid={LookupTypeIndexes.statusType}
                                            type="hidden"
                                            name={LookupTypeIndexes.statusType}
                                            value={
                                                this.state.editViewDataItem.billableStatusLookupId
                                                    ? this.state.editViewDataItem.billableStatusLookupId
                                                    : 0
                                            }
                                        ></input>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Client
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            lookupTypeIndex={LookupTypeIndexes.clientType}
                                            onValueChanged={this.handleChangeClientTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            isRoot={false}
                                            parentMappingId={""}
                                            displayExpression={"value"}
                                            value={this.state.editViewDataItem.clientId}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Provider
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            lookupTypeIndex={LookupTypeIndexes.providerType}
                                            onValueChanged={this.handleChangeProviderTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            isRoot={false}
                                            parentMappingId={""}
                                            displayExpression={"value"}
                                            value={this.state.editViewDataItem.providerId}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-md-auto col-12 col-xl-3 text-left text-xl-right">
                                        Date From
                                    </label>
                                    <sup className="card-form__mandatory-symbol-Date-From">*</sup>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DateBox
                                            disabled={
                                                this.state.createAdjustment
                                                    ? this.state.createAdjustment
                                                    : (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAmend) ||
                                                      this.state.readOnlyView ||
                                                      (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeDate}
                                            value={
                                                this.state.editViewDataItem.date
                                                    ? this.state.editViewDataItem.date
                                                    : undefined
                                            }
                                            useMaskBehavior={true}
                                            displayFormat="dd/MM/yyyy"
                                            min={calendarMin}
                                        ></DateBox>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Venue
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            lookupTypeIndex={LookupTypeIndexes.venueType}
                                            onValueChanged={this.handleChangeVenueTypeSelect}
                                            isRoot={false}
                                            parentMappingId={this.state.editViewDataItem.clientId}
                                            value={this.state.editViewDataItem.venueId}
                                            displayExpression={"value"}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Sub Type
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            lookupTypeIndex={LookupTypeIndexes.subServiceType}
                                            isRoot={false}
                                            parentMappingId={this.state.editViewDataItem.serviceTypeId}
                                            displayExpression={"value"}
                                            onValueChanged={this.handleChangeServiceSubTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.serviceSubTypeId}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Date To
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DateBox
                                            disabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.IsLockQuantityFields ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeDateTo}
                                            value={
                                                this.state.editViewDataItem.dateTo
                                                    ? this.state.editViewDataItem.dateTo
                                                    : undefined
                                            }
                                            useMaskBehavior={true}
                                            displayFormat="dd/MM/yyyy"
                                        ></DateBox>
                                    </div>
                                </div>
                            </div>

                            <div className="row mx-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Type
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <SelectBox
                                            dataSource={this.state.offeringsTypeLookup}
                                            displayExpr={"value"}
                                            valueExpr={"id"}
                                            onValueChanged={this.handleChangeOfferingsTypeSelect}
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.typeId
                                                    : this.state.editViewDataItem.typeId
                                            }
                                            disabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                isDisableOfferingsType ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3" hidden={showOtherDesc}>
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Description
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <TextBox
                                            disabled={
                                                this.state.createAdjustment
                                                    ? this.state.createAdjustment
                                                    : (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAmend) ||
                                                      this.state.readOnlyView ||
                                                      (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeOtherDescription}
                                            value={this.state.editViewDataItem.otherDescription}
                                        ></TextBox>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Pay Request Description
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <TextBox
                                            disabled={
                                                this.state.createAdjustment
                                                    ? this.state.createAdjustment
                                                    : (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAmend) ||
                                                      this.state.readOnlyView ||
                                                      (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.paymentRequest?.description}
                                            readOnly={true}
                                        ></TextBox>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="w-50 mx-auto">
                                    <LoadIndicator
                                        id="load-indicator"
                                        className="load-indicator"
                                        height={40}
                                        width={40}
                                        visible={this.state.loadIndicatorVisible}
                                    />
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 pr-0">
                                    <div className="row">
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Hours
                                                <sup className="card-form__mandatory-symbol">*</sup>
                                            </label>
                                            <div className="col-12 col-xl-6 pl-2">
                                                <NumberBox
                                                    disabled={
                                                        this.state.createAdjustment ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAmend) ||
                                                        this.state.readOnlyView ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAdjust)
                                                    }
                                                    onValueChanged={this.handleChangeHours}
                                                    valueChangeEvent="keyup"
                                                    value={
                                                        this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust
                                                            ? this.state.virtualHours
                                                            : this.state.hours
                                                    }
                                                    onContentReady={this.onContentReadyNumberBox}
                                                    step={0}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Min
                                            </label>
                                            <div className="col-12 col-xl-6 pl-0">
                                                <SelectBox
                                                    dataSource={minuteLookup}
                                                    displayExpr="value"
                                                    valueExpr="id"
                                                    onValueChanged={this.handleChangeMinutes}
                                                    value={
                                                        this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust
                                                            ? this.state.virtualMinutes
                                                            : this.state.minutes
                                                    }
                                                    disabled={
                                                        this.state.createAdjustment ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAmend) ||
                                                        this.state.readOnlyView ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAdjust)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Rate
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <NumberBox
                                            disabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            format={{
                                                type: "currency",
                                                precision: 2,
                                                currency: "GBP",
                                            }}
                                            onValueChanged={this.handleChangeRate}
                                            valueChangeEvent="keyup"
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.rate_Decimal
                                                    : this.state.editViewDataItem.rate_Decimal
                                            }
                                            onContentReady={this.onContentReadyNumberBox}
                                            step={0}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-md-auto col-12 col-xl-3 text-left text-xl-right">
                                        Provider Net
                                    </label>
                                    <sup className="card-form__mandatory-symbol-Provider-Net">*</sup>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <NumberBox
                                            format={{
                                                type: "currency",
                                                precision: 2,
                                                currency: "GBP",
                                            }}
                                            onValueChanged={this.handleChangeProviderLocalCurrancyAmount}
                                            valueChangeEvent="keyup"
                                            value={this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy}
                                            disabled={
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            onContentReady={this.onContentReadyNumberBox}
                                            step={0}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Charge
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <SelectBox
                                            disabled={
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            dataSource={this.chargeTypesDataSource}
                                            displayExpr="value"
                                            valueExpr="value"
                                            onValueChanged={this.handleChangeNoChange}
                                            value={
                                                this.state.editViewDataItem.noCharge == "" &&
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.id == 0
                                                    ? "Applied"
                                                    : this.props.location &&
                                                      this.props.location.state &&
                                                      this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.noCharge
                                                    : this.state.editViewDataItem.noCharge
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Cleaner Confirmed
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <SelectBox
                                            disabled={
                                                this.state.createAdjustment ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            dataSource={this.decisionTypesDataSource}
                                            displayExpr="value"
                                            valueExpr="value"
                                            onValueChanged={this.handleChangeArtistConfirmation}
                                            value={
                                                this.state.editViewDataItem.shiftCompleteAcknowledgment == true
                                                    ? "Yes"
                                                    : this.props.location &&
                                                      this.props.location.state &&
                                                      this.props.location.state.id != 0 &&
                                                      this.state.editViewDataItem.shiftCompleteAcknowledgment == false
                                                    ? "No"
                                                    : this.state.editViewDataItem.shiftCompleteAcknowledgment
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Confirmed Date
                                    </label>
                                    <div className="col-12 col-xl-5 pl-0">
                                        <DateBox
                                            disabled={
                                                this.state.createAdjustment
                                                    ? this.state.createAdjustment
                                                    : (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAmend) ||
                                                      this.state.readOnlyView ||
                                                      (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeArtistConfirmedDate}
                                            value={
                                                this.state.editViewDataItem.shiftCompleteAcknowledgmentDateTime
                                                    ? this.state.editViewDataItem.shiftCompleteAcknowledgmentDateTime
                                                    : undefined
                                            }
                                            useMaskBehavior={true}
                                            displayFormat="dd/MM/yyyy"
                                            min={calendarMin}
                                        ></DateBox>
                                    </div>

                                    <div className="col-12 col-xl-4 pl-0">
                                        <DateBox
                                            type="time"
                                            interval={15}
                                            useMaskBehavior={true}
                                            displayFormat={"HH:mm"}
                                            disabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeArtistConfirmedTime}
                                            value={
                                                this.state.editViewDataItem.shiftCompleteAcknowledgmentTime
                                                    ? this.state.editViewDataItem.shiftCompleteAcknowledgmentTime
                                                    : undefined
                                            }
                                            onContentReady={this.onContentReadyDateBox}
                                        />
                                    </div>
                                </div>
                            </div>
                            <hr className="horizontal_border_style"></hr>

                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 pr-0">
                                    <div className="row">
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Mon
                                            </label>
                                            <div className="col-12 col-xl-6 pl-0">
                                                <TextBox
                                                    readOnly={true}
                                                    value={
                                                        this.state.editViewDataItem.contractHours
                                                            ? this.state.editViewDataItem.contractHours.monday
                                                            : undefined
                                                    }
                                                ></TextBox>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Tue
                                            </label>
                                            <div className="col-12 col-xl-6 pl-0">
                                                <TextBox
                                                    readOnly={true}
                                                    value={
                                                        this.state.editViewDataItem.contractHours
                                                            ? this.state.editViewDataItem.contractHours.tuesday
                                                            : undefined
                                                    }
                                                ></TextBox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 pr-0">
                                    <div className="row">
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Wed
                                            </label>
                                            <div className="col-12 col-xl-6 pl-0">
                                                <TextBox
                                                    readOnly={true}
                                                    value={
                                                        this.state.editViewDataItem.contractHours
                                                            ? this.state.editViewDataItem.contractHours.wednesday
                                                            : undefined
                                                    }
                                                ></TextBox>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Thu
                                            </label>
                                            <div className="col-12 col-xl-6 pl-0">
                                                <TextBox
                                                    readOnly={true}
                                                    value={
                                                        this.state.editViewDataItem.contractHours
                                                            ? this.state.editViewDataItem.contractHours.thursday
                                                            : undefined
                                                    }
                                                ></TextBox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 pr-0">
                                    <div className="row">
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Fri
                                            </label>
                                            <div className="col-12 col-xl-6 pl-0">
                                                <TextBox
                                                    readOnly={true}
                                                    value={
                                                        this.state.editViewDataItem.contractHours
                                                            ? this.state.editViewDataItem.contractHours.friday
                                                            : undefined
                                                    }
                                                ></TextBox>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Sat
                                            </label>
                                            <div className="col-12 col-xl-6 pl-0">
                                                <TextBox
                                                    readOnly={true}
                                                    value={
                                                        this.state.editViewDataItem.contractHours
                                                            ? this.state.editViewDataItem.contractHours.saturday
                                                            : undefined
                                                    }
                                                ></TextBox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 pr-0"> </div>
                                <div className="col-12 col-lg-4 pr-0">
                                    <div className="row">
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Sun
                                            </label>
                                            <div className="col-12 col-xl-6 pl-0">
                                                <TextBox
                                                    readOnly={true}
                                                    value={
                                                        this.state.editViewDataItem.contractHours
                                                            ? this.state.editViewDataItem.contractHours.sunday
                                                            : undefined
                                                    }
                                                ></TextBox>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Weekly Hours
                                            </label>
                                            <div className="col-12 col-xl-6 pl-0">
                                                <TextBox
                                                    readOnly={true}
                                                    value={
                                                        this.state.editViewDataItem.contractHours
                                                            ? this.state.editViewDataItem.contractHours.totalHours
                                                            : undefined
                                                    }
                                                ></TextBox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 pr-0"></div>
                            </div>
                            <hr className="horizontal_border_style"></hr>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-1 text-left text-xl-right">
                                        External Comments (Public)
                                    </label>
                                    <div className="col-12 col-xl-11 pl-0">
                                        <TextArea
                                            height={100}
                                            value={this.state.editViewDataItem.comments}
                                            onValueChanged={this.handleChangeComments}
                                            disabled={this.state.readOnlyView}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-md-auto col-xl-1 text-left text-xl-right">
                                        Internal Comments (Private)
                                    </label>
                                    <sup className="card-form__mandatory-symbol-Internal-Comments">*</sup>
                                    <div className="col-12 col-xl-11 pl-0">
                                        <TextArea
                                            height={100}
                                            value={this.state.editViewDataItem.internalComments}
                                            onValueChanged={this.handleChangeInternalComments}
                                            disabled={this.state.readOnlyView}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                );
            }
        }
    };

    renderAdditionalCleaningShiftPanel = () => {
        let calendarMin;
        if (UserService.isUserInGroup(RoleGroupNames.ProviderScheduler)) {
            calendarMin = new Date();
        }
        let labelName: string = "";
        if (this.state.editViewDataItem)
            if (
                (this.state.editViewDataItem.serviceTypeId == ServiceType.ContractCleaning &&
                    this.state.editViewDataItem.serviceSubTypeId == SubServiceType.AdditionalCleaning) ||
                (this.state.editViewDataItem.serviceTypeId == ServiceType.ContractCleaning &&
                    this.state.editViewDataItem.serviceSubTypeId == SubServiceType.Laundry) ||
                this.state.editViewDataItem.serviceTypeId == ServiceType.Gardening ||
                this.state.editViewDataItem.serviceTypeId == ServiceType.Maintenance ||
                this.state.editViewDataItem.serviceTypeId == ServiceType.Miscelleanous ||
                this.state.editViewDataItem.serviceTypeId == ServiceType.WindowCleaning
            ) {
                if (
                    this.state.editViewDataItem.serviceSubTypeId == SubServiceType.AdditionalCleaning ||
                    (this.props.location &&
                        this.props.location.state &&
                        this.props.location.state.service == "Contract Cleaning - Additional Cleaning") ||
                    this.state.editViewDataItem.serviceSubTypeId == SubServiceType.Laundry ||
                    this.state.editViewDataItem.serviceTypeId == ServiceType.Gardening ||
                    this.state.editViewDataItem.serviceTypeId == ServiceType.Maintenance ||
                    this.state.editViewDataItem.serviceTypeId == ServiceType.Miscelleanous ||
                    this.state.editViewDataItem.serviceTypeId == ServiceType.WindowCleaning
                    // ||
                    // this.props.location && this.props.location.state && this.props.location.state.serviceTypeId == ServiceType.Gardening ||
                    // this.props.location && this.props.location.state && this.props.location.state.serviceTypeId == ServiceType.Maintenance ||
                    // this.props.location && this.props.location.state && this.props.location.state.serviceTypeId == ServiceType.Miscelleanous ||
                    // this.props.location && this.props.location.state && this.props.location.state.serviceTypeId == ServiceType.WindowCleaning
                ) {
                    let isDisableOfferingsType: boolean = true;
                    let showOtherDesc: boolean = false;
                    let showType: boolean = true;
                    let showMisMainQuantity: boolean = false;
                    if (
                        this.state.editViewDataItem.serviceTypeId == ServiceType.Maintenance ||
                        this.state.editViewDataItem.serviceTypeId == ServiceType.Miscelleanous
                    ) {
                        showType = false;
                    }
                    if (
                        this.state.offeringsTypeLookup &&
                        this.state.offeringsTypeLookup.length > 0 &&
                        this.state.editViewDataItem.serviceSubTypeId
                    ) {
                        isDisableOfferingsType = false;
                    }
                    if (
                        (this.state.editViewDataItem.serviceTypeId == ServiceType.ContractCleaning &&
                            this.state.editViewDataItem.serviceSubTypeId == SubServiceType.AdditionalCleaning &&
                            this.state.editViewDataItem.typeId == "227") ||
                        (this.state.editViewDataItem.serviceTypeId == ServiceType.WindowCleaning &&
                            this.state.editViewDataItem.serviceSubTypeId == "108" &&
                            this.state.editViewDataItem.typeId == "516") ||
                        (this.state.editViewDataItem.serviceTypeId == ServiceType.Gardening &&
                            this.state.editViewDataItem.serviceSubTypeId == "106" &&
                            this.state.editViewDataItem.typeId == "405")
                    ) {
                        showOtherDesc = true;
                    }
                    if (
                        this.state.editViewDataItem.serviceTypeId == ServiceType.Maintenance ||
                        this.state.editViewDataItem.serviceTypeId == ServiceType.Miscelleanous
                    ) {
                        showMisMainQuantity = true;
                    }
                    return (
                        <section className="card card-form my-5">
                            <div className="card-body">
                                <h3 className="card-form__section-heading">Shift</h3>
                                <hr className="horizontal_border_style"></hr>
                                <div className="row mx-0">
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Service
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <DropDownFromLookupTableDynamic
                                                lookupTypeIndex={LookupTypeIndexes.serviceType}
                                                isRoot={true}
                                                parentMappingId={"0"}
                                                onValueChanged={this.handleChangeServiceTypeSelect}
                                                isDisabled={
                                                    this.state.createAdjustment ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAmend) ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                value={this.state.editViewDataItem.serviceTypeId}
                                            />
                                            <input
                                                data-testid={LookupTypeIndexes.serviceType}
                                                type="hidden"
                                                name={LookupTypeIndexes.serviceType}
                                                value={
                                                    this.state.editViewDataItem.serviceTypeId
                                                        ? this.state.editViewDataItem.serviceTypeId
                                                        : ""
                                                }
                                            ></input>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Status
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <DropDownFromLookupTable
                                                lookupTypeIndex={LookupTypeIndexes.statusType}
                                                onValueChanged={this.handleChangeStatusTypeSelect}
                                                signal={this.state.createAdjustment}
                                                disableSignal={
                                                    this.editAllowed ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAmend) ||
                                                    this.state.isDisableStatusDropDown ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                value={this.state.editViewDataItem.billableStatusLookupId}
                                            />
                                            <input
                                                data-testid={LookupTypeIndexes.statusType}
                                                type="hidden"
                                                name={LookupTypeIndexes.statusType}
                                                value={
                                                    this.state.editViewDataItem.billableStatusLookupId
                                                        ? this.state.editViewDataItem.billableStatusLookupId
                                                        : 0
                                                }
                                            ></input>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Client
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <LookupTypeListDynamic
                                                lookupTypeIndex={LookupTypeIndexes.clientType}
                                                onValueChanged={this.handleChangeClientTypeSelect}
                                                isDisabled={
                                                    this.state.createAdjustment ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAmend) ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                isRoot={false}
                                                parentMappingId={""}
                                                displayExpression={"value"}
                                                value={this.state.editViewDataItem.clientId}
                                                recordType={
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isEdit) ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isMasterEdit)
                                                        ? "all"
                                                        : "active"
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mx-0">
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Provider
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <LookupTypeListDynamic
                                                lookupTypeIndex={LookupTypeIndexes.providerType}
                                                onValueChanged={this.handleChangeProviderTypeSelect}
                                                isDisabled={
                                                    this.state.createAdjustment ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAmend) ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                isRoot={false}
                                                parentMappingId={""}
                                                displayExpression={"value"}
                                                value={this.state.editViewDataItem.providerId}
                                                recordType={
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isEdit) ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isMasterEdit)
                                                        ? "all"
                                                        : "active"
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-md-auto col-12 col-xl-3 text-left text-xl-right">
                                            Date From
                                        </label>
                                        <sup className="card-form__mandatory-symbol-Date-From">*</sup>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <DateBox
                                                disabled={
                                                    this.state.createAdjustment
                                                        ? this.state.createAdjustment
                                                        : (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAmend) ||
                                                          this.state.readOnlyView ||
                                                          (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAdjust)
                                                }
                                                onValueChanged={this.handleChangeDate}
                                                value={
                                                    this.state.editViewDataItem.date
                                                        ? this.state.editViewDataItem.date
                                                        : undefined
                                                }
                                                useMaskBehavior={true}
                                                displayFormat="dd/MM/yyyy"
                                                min={calendarMin}
                                            ></DateBox>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Venue
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <LookupTypeListDynamic
                                                isDisabled={
                                                    this.state.createAdjustment ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAmend) ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                lookupTypeIndex={LookupTypeIndexes.venueType}
                                                onValueChanged={this.handleChangeVenueTypeSelect}
                                                isRoot={false}
                                                parentMappingId={this.state.editViewDataItem.clientId}
                                                value={this.state.editViewDataItem.venueId}
                                                displayExpression={"value"}
                                                recordType={
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isEdit) ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isMasterEdit)
                                                        ? "all"
                                                        : "active"
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mx-0">
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Sub Type
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <LookupTypeListDynamic
                                                lookupTypeIndex={LookupTypeIndexes.subServiceType}
                                                isRoot={false}
                                                parentMappingId={this.state.editViewDataItem.serviceTypeId}
                                                displayExpression={"value"}
                                                onValueChanged={this.handleChangeServiceSubTypeSelect}
                                                isDisabled={
                                                    this.state.createAdjustment ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAmend) ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                value={this.state.editViewDataItem.serviceSubTypeId}
                                                recordType={
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isEdit) ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isMasterEdit)
                                                        ? "all"
                                                        : "active"
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Date To
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <DateBox
                                                disabled={
                                                    this.state.createAdjustment ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAmend) ||
                                                    this.state.IsLockQuantityFields ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                onValueChanged={this.handleChangeDateTo}
                                                value={
                                                    this.state.editViewDataItem.dateTo
                                                        ? this.state.editViewDataItem.dateTo
                                                        : undefined
                                                }
                                                useMaskBehavior={true}
                                                displayFormat="dd/MM/yyyy"
                                            ></DateBox>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3" hidden={!showMisMainQuantity}>
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Quantity
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <NumberBox
                                                disabled={
                                                    this.state.createAdjustment ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAmend) ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                onValueChanged={this.handleChangeQuantity}
                                                valueChangeEvent="keyup"
                                                value={
                                                    this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust
                                                        ? this.state.editViewVirtualDataItem.equipmentQuantity
                                                        : this.state.editViewDataItem.equipmentQuantity
                                                }
                                                onContentReady={this.onContentReadyNumberBox}
                                                step={0}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mx-0">
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3" hidden={!showType}>
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Type
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <SelectBox
                                                dataSource={this.state.offeringsTypeLookup}
                                                displayExpr={"value"}
                                                valueExpr={"id"}
                                                onValueChanged={this.handleChangeOfferingsTypeSelect}
                                                value={
                                                    this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust
                                                        ? this.state.editViewVirtualDataItem.typeId
                                                        : this.state.editViewDataItem.typeId
                                                }
                                                disabled={
                                                    this.state.createAdjustment ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAmend) ||
                                                    isDisableOfferingsType ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3" hidden={!showType}>
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Description
                                            <sup className="card-form__mandatory-symbol" hidden={!showOtherDesc}>
                                                *
                                            </sup>
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <TextBox
                                                disabled={
                                                    this.state.createAdjustment
                                                        ? this.state.createAdjustment
                                                        : (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAmend) ||
                                                          this.state.readOnlyView ||
                                                          (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAdjust)
                                                }
                                                onValueChanged={this.handleChangeOtherDescription}
                                                value={this.state.editViewDataItem.otherDescription}
                                            ></TextBox>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3" hidden={showMisMainQuantity}>
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Pay Request Description
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <TextBox
                                                disabled={
                                                    this.state.createAdjustment
                                                        ? this.state.createAdjustment
                                                        : (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAmend) ||
                                                          this.state.readOnlyView ||
                                                          (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAdjust)
                                                }
                                                readOnly={true}
                                                value={this.state.editViewDataItem.paymentRequest?.description}
                                            ></TextBox>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="w-50 mx-auto">
                                        <LoadIndicator
                                            id="load-indicator"
                                            className="load-indicator"
                                            height={40}
                                            width={40}
                                            visible={this.state.loadIndicatorVisible}
                                        />
                                    </div>
                                </div>
                                <div className="row mx-0 pr-0">
                                    <div
                                        className="col-12 col-lg-4 row mx-0 pr-0 mt-3"
                                        hidden={
                                            this.state.editViewDataItem.serviceTypeId == ServiceType.ContractCleaning ||
                                            this.state.editViewDataItem.serviceTypeId == ServiceType.Entertainment ||
                                            this.state.editViewDataItem.serviceTypeId == ServiceType.WindowCleaning ||
                                            this.state.editViewDataItem.serviceTypeId == ServiceType.Gardening
                                        }
                                    >
                                        <label className="card-form__label col-md-auto col-12 col-xl-3 text-left text-xl-right">
                                            Description
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <TextBox
                                                disabled={
                                                    this.state.createAdjustment
                                                        ? this.state.createAdjustment
                                                        : (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAmend) ||
                                                          this.state.readOnlyView ||
                                                          (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAdjust)
                                                }
                                                onValueChanged={this.handleChangeOtherDescription}
                                                value={this.state.editViewDataItem.otherDescription}
                                            ></TextBox>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3" hidden={showMisMainQuantity}>
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Quantity
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <NumberBox
                                                disabled={
                                                    this.state.createAdjustment ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAmend) ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                onValueChanged={this.handleChangeQuantity}
                                                valueChangeEvent="keyup"
                                                value={
                                                    this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust
                                                        ? this.state.editViewVirtualDataItem.equipmentQuantity
                                                        : this.state.editViewDataItem.equipmentQuantity
                                                }
                                                onContentReady={this.onContentReadyNumberBox}
                                                step={0}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Rate
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <NumberBox
                                                disabled={
                                                    this.state.createAdjustment ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAmend) ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                format={{
                                                    type: "currency",
                                                    precision: 2,
                                                    currency: "GBP",
                                                }}
                                                onValueChanged={this.handleChangeRate}
                                                valueChangeEvent="keyup"
                                                value={
                                                    this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust
                                                        ? this.state.editViewVirtualDataItem.rate_Decimal
                                                        : this.state.editViewDataItem.rate_Decimal
                                                }
                                                onContentReady={this.onContentReadyNumberBox}
                                                step={0}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-12 col-md-auto col-md col-xl-3 text-left text-xl-right">
                                            Provider Net
                                        </label>
                                        <sup className="card-form__mandatory-symbol-Provider-Net">*</sup>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <NumberBox
                                                format={{
                                                    type: "currency",
                                                    precision: 2,
                                                    currency: "GBP",
                                                }}
                                                onValueChanged={this.handleChangeProviderLocalCurrancyAmount}
                                                valueChangeEvent="keyup"
                                                value={this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy}
                                                disabled={
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                onContentReady={this.onContentReadyNumberBox}
                                                step={0}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mx-0 pr-0">
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-md-auto col-12 col-xl-3 text-left text-xl-right">
                                            Request Approver
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <TextBox
                                                disabled={
                                                    this.state.createAdjustment
                                                        ? this.state.createAdjustment
                                                        : (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAmend) ||
                                                          this.state.readOnlyView ||
                                                          (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAdjust)
                                                }
                                                onValueChanged={this.handleChangeRequestApprover}
                                                value={this.state.editViewDataItem.requestApprover}
                                            ></TextBox>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label-requested-on col-12 col-xl-3 text-left text-xl-right">
                                            Requested On
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <DateBox
                                                disabled={
                                                    this.state.createAdjustment ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAmend) ||
                                                    this.state.IsLockQuantityFields ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                onValueChanged={this.handleChangeRequestedOn}
                                                value={
                                                    this.state.editViewDataItem.requestDate
                                                        ? this.state.editViewDataItem.requestDate
                                                        : undefined
                                                }
                                                useMaskBehavior={true}
                                                displayFormat="dd/MM/yyyy"
                                            ></DateBox>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Charge
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <SelectBox
                                                disabled={
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                dataSource={this.chargeTypesDataSource}
                                                displayExpr="value"
                                                valueExpr="value"
                                                onValueChanged={this.handleChangeNoChange}
                                                value={
                                                    this.state.editViewDataItem.noCharge == "" &&
                                                    this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.id == 0
                                                        ? "Applied"
                                                        : this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust
                                                        ? this.state.editViewVirtualDataItem.noCharge
                                                        : this.state.editViewDataItem.noCharge
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mx-0 pr-0">
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Confirmed?
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <SelectBox
                                                disabled={
                                                    this.state.createAdjustment ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                dataSource={this.decisionTypesDataSource}
                                                displayExpr="value"
                                                valueExpr="value"
                                                onValueChanged={this.handleChangeArtistConfirmation}
                                                value={
                                                    this.state.editViewDataItem.shiftCompleteAcknowledgment == true
                                                        ? "Yes"
                                                        : this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.id != 0 &&
                                                          this.state.editViewDataItem.shiftCompleteAcknowledgment ==
                                                              false
                                                        ? "No"
                                                        : this.state.editViewDataItem.shiftCompleteAcknowledgment
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Confirmed Date
                                        </label>
                                        <div className="col-12 col-xl-5 pl-0">
                                            <DateBox
                                                disabled={
                                                    this.state.createAdjustment
                                                        ? this.state.createAdjustment
                                                        : (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAmend) ||
                                                          this.state.readOnlyView ||
                                                          (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAdjust)
                                                }
                                                onValueChanged={this.handleChangeArtistConfirmedDate}
                                                value={
                                                    this.state.editViewDataItem.shiftCompleteAcknowledgmentDateTime
                                                        ? this.state.editViewDataItem
                                                              .shiftCompleteAcknowledgmentDateTime
                                                        : undefined
                                                }
                                                useMaskBehavior={true}
                                                displayFormat="dd/MM/yyyy"
                                                min={calendarMin}
                                            ></DateBox>
                                        </div>
                                        <div className="col-12 col-xl-4 pl-0">
                                            <DateBox
                                                type="time"
                                                interval={15}
                                                useMaskBehavior={true}
                                                displayFormat={"HH:mm"}
                                                disabled={
                                                    this.state.createAdjustment ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAmend) ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                onValueChanged={this.handleChangeArtistConfirmedTime}
                                                value={
                                                    this.state.editViewDataItem.shiftCompleteAcknowledgmentTime
                                                        ? this.state.editViewDataItem.shiftCompleteAcknowledgmentTime
                                                        : undefined
                                                }
                                                onContentReady={this.onContentReadyDateBox}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-2 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-md-auto col-12 col-xl-6 text-left text-xl-right">
                                            Faster Pay Fee
                                        </label>
                                        <div className="col-12 col-xl-6 pl-0">
                                            <NumberBox
                                                disabled={
                                                    this.state.createAdjustment ||
                                                    this.state.readOnlyView ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                                format={{
                                                    type: "currency",
                                                    precision: 2,
                                                    currency: "GBP",
                                                }}
                                                onValueChanged={this.handleChangeFasterPayFee}
                                                onContentReady={this.onContentReadyNumberBox}
                                                valueChangeEvent="keyup"
                                                step={0}
                                                value={this.state.editViewDataItem.providerFasterPayFee}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-2 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-md-auto col-12 col-xl-6 text-left text-xl-right">
                                            Adjusted Artist Fee
                                        </label>
                                        <div className="col-12 col-xl-6 pl-0">
                                            <NumberBox
                                                disabled={true}
                                                format={{
                                                    type: "currency",
                                                    precision: 2,
                                                    currency: "GBP",
                                                }}
                                                onValueChanged={this.handleChangeAdjustedAmount}
                                                onContentReady={this.onContentReadyNumberBox}
                                                valueChangeEvent="keyup"
                                                step={0}
                                                value={this.state.editViewDataItem.providerPayAmountLocal}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3" hidden={!showMisMainQuantity}>
                                        <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                            Pay Request Description
                                        </label>
                                        <div className="col-12 col-xl-9 pl-0">
                                            <TextBox
                                                disabled={
                                                    this.state.createAdjustment
                                                        ? this.state.createAdjustment
                                                        : (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAmend) ||
                                                          this.state.readOnlyView ||
                                                          (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAdjust)
                                                }
                                                readOnly={true}
                                                value={this.state.editViewDataItem.paymentRequest?.description}
                                            ></TextBox>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mx-0 pr-0">
                                    <div className="col-12 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-1 text-left text-xl-right">
                                            External Comments (Public)
                                        </label>
                                        <div className="col-12 col-xl-11 pl-0">
                                            <TextArea
                                                height={100}
                                                value={this.state.editViewDataItem.comments}
                                                onValueChanged={this.handleChangeComments}
                                                disabled={this.state.readOnlyView}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mx-0 pr-0">
                                    <div className="col-12 row mx-0 pr-0 mt-3">
                                        <label className="card-form__label col-12 col-md-auto col-xl-1 text-left text-xl-right">
                                            Internal Comments (Private)
                                        </label>
                                        <sup className="card-form__mandatory-symbol-Internal-Comments">*</sup>
                                        <div className="col-12 col-xl-11 pl-0">
                                            <TextArea
                                                height={100}
                                                value={this.state.editViewDataItem.internalComments}
                                                onValueChanged={this.handleChangeInternalComments}
                                                disabled={this.state.readOnlyView}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    );
                }
            }
    };

    renderEntertainmentShiftPanel = () => {
        let calendarMin;
        if (UserService.isUserInGroup(RoleGroupNames.ProviderScheduler)) {
            calendarMin = new Date();
        }
        let isDisableOfferingsType: boolean = true;
        let isOtherDescToShow: boolean = false;
        if (
            this.state.offeringsTypeLookup &&
            this.state.offeringsTypeLookup.length > 0 &&
            this.state.editViewDataItem.serviceSubTypeId
        ) {
            isDisableOfferingsType = false;
        } else {
            if (this.state.editViewDataItem.serviceSubTypeId == Types.Other) {
                isOtherDescToShow = true;
            } else {
                isDisableOfferingsType = true;
            }
        }
        if (this.state.editViewDataItem.serviceTypeId == ServiceType.Entertainment) {
            if (
                this.state.editViewDataItem.serviceTypeId == ServiceType.Entertainment ||
                this.state.editViewDataItem.serviceTypeId == ServiceType.Entertainment
            ) {
                return (
                    <section className="card card-form my-5">
                        <div className="card-body">
                            <h3 className="card-form__section-heading">Shift</h3>
                            <hr className="horizontal_border_style"></hr>
                            <div className="row mx-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Service
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DropDownFromLookupTableDynamic
                                            lookupTypeIndex={LookupTypeIndexes.serviceType}
                                            isRoot={true}
                                            parentMappingId={"0"}
                                            onValueChanged={this.handleChangeServiceTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.serviceTypeId}
                                        />
                                        <input
                                            data-testid={LookupTypeIndexes.serviceType}
                                            type="hidden"
                                            name={LookupTypeIndexes.serviceType}
                                            value={
                                                this.state.editViewDataItem.serviceTypeId
                                                    ? this.state.editViewDataItem.serviceTypeId
                                                    : ""
                                            }
                                        ></input>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Status
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DropDownFromLookupTable
                                            lookupTypeIndex={LookupTypeIndexes.statusType}
                                            onValueChanged={this.handleChangeStatusTypeSelect}
                                            signal={this.state.createAdjustment}
                                            disableSignal={
                                                this.editAllowed ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.isDisableStatusDropDown ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.billableStatusLookupId}
                                        />
                                        <input
                                            data-testid={LookupTypeIndexes.statusType}
                                            type="hidden"
                                            name={LookupTypeIndexes.statusType}
                                            value={
                                                this.state.editViewDataItem.billableStatusLookupId
                                                    ? this.state.editViewDataItem.billableStatusLookupId
                                                    : 0
                                            }
                                        ></input>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Client
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            lookupTypeIndex={LookupTypeIndexes.clientType}
                                            onValueChanged={this.handleChangeClientTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            isRoot={false}
                                            parentMappingId={""}
                                            displayExpression={"value"}
                                            value={this.state.editViewDataItem.clientId}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Provider
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            lookupTypeIndex={LookupTypeIndexes.providerType}
                                            onValueChanged={this.handleChangeProviderTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            isRoot={false}
                                            parentMappingId={""}
                                            displayExpression={"value"}
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.providerId
                                                    : this.state.editViewDataItem.providerId
                                            }
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Date
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <DateBox
                                            disabled={
                                                this.state.createAdjustment
                                                    ? this.state.createAdjustment
                                                    : (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAmend) ||
                                                      this.state.readOnlyView ||
                                                      (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeDate}
                                            value={
                                                this.state.editViewDataItem.date
                                                    ? this.state.editViewDataItem.date
                                                    : undefined
                                            }
                                            useMaskBehavior={true}
                                            displayFormat="dd/MM/yyyy"
                                            min={calendarMin}
                                        ></DateBox>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Venue
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            lookupTypeIndex={LookupTypeIndexes.venueType}
                                            onValueChanged={this.handleChangeVenueTypeSelect}
                                            isRoot={false}
                                            parentMappingId={this.state.editViewDataItem.clientId}
                                            value={this.state.editViewDataItem.venueId}
                                            displayExpression={"value"}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Profile
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        {/* <LookupTypeListDynamic
                                            lookupTypeIndex={LookupTypeIndexes.subServiceType}
                                            isRoot={false}
                                            parentMappingId={this.state.editViewDataItem.serviceTypeId}
                                            displayExpression={"value"}
                                            onValueChanged={this.handleChangeServiceSubTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.serviceSubTypeId}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        /> */}
                                        <SelectBox
                                            dataSource={this.state.profileLookup}
                                            displayExpr={"value"}
                                            valueExpr={"id"}
                                            onValueChanged={this.handleChangeProfileSelect}
                                            value={
                                                this.state.editViewDataItem.providerBusinessEntityProfileId
                                                    ? this.state.editViewDataItem.providerBusinessEntityProfileId
                                                    : ""
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Booking Id
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <TextBox
                                            disabled={true}
                                            value={this.state.editViewDataItem.requestId}
                                        ></TextBox>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Charge
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <SelectBox
                                            disabled={
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            dataSource={this.chargeTypesDataSource}
                                            displayExpr="value"
                                            valueExpr="value"
                                            onValueChanged={this.handleChangeNoChange}
                                            value={
                                                this.state.editViewDataItem.noCharge == "" &&
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.id == 0
                                                    ? "Applied"
                                                    : this.props.location &&
                                                      this.props.location.state &&
                                                      this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.noCharge
                                                    : this.state.editViewDataItem.noCharge
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <LoadIndicator
                                    id="load-indicator"
                                    className="load-indicator"
                                    height={40}
                                    width={40}
                                    visible={this.state.loadIndicatorVisible}
                                />
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Sub Type
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <LookupTypeListDynamic
                                            lookupTypeIndex={LookupTypeIndexes.subServiceType}
                                            isRoot={false}
                                            parentMappingId={this.state.editViewDataItem.serviceTypeId}
                                            displayExpression={"value"}
                                            onValueChanged={this.handleChangeServiceSubTypeSelect}
                                            isDisabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            value={this.state.editViewDataItem.serviceSubTypeId}
                                            recordType={
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isEdit) ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isMasterEdit)
                                                    ? "all"
                                                    : "active"
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Description
                                        {isOtherDescToShow ? (
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        ) : null}
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <TextBox
                                            disabled={
                                                this.state.createAdjustment
                                                    ? this.state.createAdjustment
                                                    : (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAmend) ||
                                                      this.state.readOnlyView ||
                                                      (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeOtherDescription}
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.otherDescription
                                                    : this.state.editViewDataItem.otherDescription
                                            }
                                        ></TextBox>
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Role/Type
                                        <sup className="card-form__mandatory-symbol" hidden={isDisableOfferingsType}>
                                            *
                                        </sup>
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <SelectBox
                                            dataSource={this.state.offeringsTypeLookup}
                                            displayExpr={"value"}
                                            valueExpr={"id"}
                                            onValueChanged={this.handleChangeOfferingsTypeSelect}
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.typeId
                                                    : this.state.editViewDataItem.typeId
                                            }
                                            disabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                isDisableOfferingsType ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Residency
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <SelectBox
                                            disabled={
                                                this.state.createAdjustment ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            dataSource={this.decisionTypesDataSource}
                                            displayExpr="value"
                                            valueExpr="value"
                                            onValueChanged={this.handleChangeReoccurance}
                                            value={this.state.editViewDataItem.reoccurance}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 pr-0">
                                    <div className="row">
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Performance Start
                                            </label>
                                            <div className="col-12 col-xl-6 pl-2">
                                                <DateBox
                                                    type="time"
                                                    interval={15}
                                                    placeholder="00:00"
                                                    useMaskBehavior={true}
                                                    displayFormat={"HH:mm"}
                                                    disabled={
                                                        this.state.createAdjustment ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAmend) ||
                                                        this.state.readOnlyView ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAdjust)
                                                    }
                                                    onValueChanged={this.handleChangeShiftStart}
                                                    value={
                                                        this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust &&
                                                        this.state.editViewVirtualDataItem.shift_Start
                                                            ? this.state.editViewVirtualDataItem.shift_Start
                                                            : this.state.editViewDataItem.shift_Start
                                                            ? this.state.editViewDataItem.shift_Start
                                                            : undefined
                                                    }
                                                    onContentReady={this.onContentReadyDateBox}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Performance End
                                            </label>
                                            <div className="col-12 col-xl-6 pl-0">
                                                <DateBox
                                                    type="time"
                                                    interval={15}
                                                    useMaskBehavior={true}
                                                    displayFormat={"HH:mm"}
                                                    disabled={
                                                        this.state.createAdjustment ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAmend) ||
                                                        this.state.readOnlyView ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAdjust)
                                                    }
                                                    onValueChanged={this.handleChangeShiftEnd}
                                                    value={
                                                        this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust &&
                                                        this.state.editViewVirtualDataItem.shift_End
                                                            ? this.state.editViewVirtualDataItem.shift_End
                                                            : this.state.editViewDataItem.shift_End
                                                            ? this.state.editViewDataItem.shift_End
                                                            : undefined
                                                    }
                                                    onContentReady={this.onContentReadyDateBox}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 pr-0">
                                    <div className="row">
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Sets
                                            </label>
                                            <div className="col-12 col-xl-6 pl-2">
                                                <NumberBox
                                                    value={
                                                        this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust
                                                            ? parseInt(
                                                                  this.state.editViewVirtualDataItem
                                                                      .performanceInformationSetsNumber
                                                              )
                                                            : parseInt(
                                                                  this.state.editViewDataItem
                                                                      .performanceInformationSetsNumber
                                                              )
                                                    }
                                                    max={5}
                                                    min={0}
                                                    showSpinButtons={true}
                                                    onValueChanged={this.handleChangeSetNumber}
                                                    disabled={
                                                        this.state.createAdjustment
                                                            ? this.state.createAdjustment
                                                            : (this.props.location &&
                                                                  this.props.location.state &&
                                                                  this.props.location.state.isAmend) ||
                                                              this.state.readOnlyView ||
                                                              (this.props.location &&
                                                                  this.props.location.state &&
                                                                  this.props.location.state.isAdjust)
                                                    }
                                                    onContentReady={this.onContentReadyNumberBox}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Duration
                                            </label>
                                            <div className="col-12 col-xl-6 pl-0">
                                                <NumberBox
                                                    min={0}
                                                    max={90}
                                                    step={15}
                                                    showSpinButtons={true}
                                                    value={
                                                        this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust
                                                            ? parseInt(
                                                                  this.state.editViewVirtualDataItem
                                                                      .performanceInformationSetsDuration
                                                              )
                                                            : parseInt(
                                                                  this.state.editViewDataItem
                                                                      .performanceInformationSetsDuration
                                                              )
                                                    }
                                                    onValueChanged={this.handleChangeDuration}
                                                    disabled={
                                                        this.state.createAdjustment
                                                            ? this.state.createAdjustment
                                                            : (this.props.location &&
                                                                  this.props.location.state &&
                                                                  this.props.location.state.isAmend) ||
                                                              this.state.readOnlyView ||
                                                              (this.props.location &&
                                                                  this.props.location.state &&
                                                                  this.props.location.state.isAdjust)
                                                    }
                                                    onContentReady={this.onContentReadyNumberBox}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Performance Information
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <TextBox
                                            disabled={
                                                this.state.createAdjustment
                                                    ? this.state.createAdjustment
                                                    : (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAmend) ||
                                                      this.state.readOnlyView ||
                                                      (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangePerformanceInfo}
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.performanceInformation
                                                    : this.state.editViewDataItem.performanceInformation
                                            }
                                        ></TextBox>
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Pay Request Description
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <TextBox
                                            disabled={
                                                this.state.createAdjustment
                                                    ? this.state.createAdjustment
                                                    : (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAmend) ||
                                                      this.state.readOnlyView ||
                                                      (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust)
                                            }
                                            readOnly={true}
                                            value={this.state.editViewDataItem.paymentRequest?.description}
                                        ></TextBox>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right mr-2">
                                        Artist's Fee
                                    </label>
                                    <sup className="card-form__mandatory-symbol-Artist-Fee">*</sup>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <NumberBox
                                            disabled={
                                                this.state.createAdjustment ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAmend) ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            format={{
                                                type: "currency",
                                                precision: 2,
                                                currency: "GBP",
                                            }}
                                            onValueChanged={this.handleChangeRate}
                                            onContentReady={this.onContentReadyNumberBox}
                                            valueChangeEvent="keyup"
                                            step={0}
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.rate_Decimal
                                                    : this.state.editViewDataItem.rate_Decimal
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Equipment
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <TextBox
                                            disabled={
                                                this.state.createAdjustment
                                                    ? this.state.createAdjustment
                                                    : (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAmend) ||
                                                      this.state.readOnlyView ||
                                                      (this.props.location &&
                                                          this.props.location.state &&
                                                          this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeEquipmentRequired}
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust
                                                    ? this.state.editViewVirtualDataItem.equipmentRequired
                                                    : this.state.editViewDataItem.equipmentRequired
                                            }
                                        ></TextBox>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 pr-0">
                                    <div className="row">
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                                Extras
                                            </label>
                                            <div className="col-12 col-xl-6 pl-2">
                                                <NumberBox
                                                    disabled={true}
                                                    format={{
                                                        type: "currency",
                                                        precision: 2,
                                                        currency: "GBP",
                                                    }}
                                                    onValueChanged={this.handleChangeExtras}
                                                    onContentReady={this.onContentReadyNumberBox}
                                                    valueChangeEvent="keyup"
                                                    step={0}
                                                    value={this.state.editViewDataItem.providerPayAmountLocalExtras}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 row mx-0 mt-3">
                                            <div className="col-12 col-xl-8 pl-0">
                                                <TextBox
                                                    disabled={
                                                        this.state.createAdjustment ||
                                                        this.state.readOnlyView ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAdjust)
                                                    }
                                                    onValueChanged={this.handleChangeExtraDescription}
                                                    value={
                                                        this.state.editViewDataItem
                                                            .providerPayAmountLocalExtrasDescription
                                                    }
                                                    className="extra-desc"
                                                ></TextBox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-2 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-md-auto col-12 col-xl-6 text-left text-xl-right">
                                        Faster Pay Fee
                                    </label>
                                    <div className="col-12 col-xl-6 pl-0">
                                        <NumberBox
                                            disabled={
                                                this.state.createAdjustment ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            format={{
                                                type: "currency",
                                                precision: 2,
                                                currency: "GBP",
                                            }}
                                            onValueChanged={this.handleChangeFasterPayFee}
                                            onContentReady={this.onContentReadyNumberBox}
                                            valueChangeEvent="keyup"
                                            step={0}
                                            value={this.state.editViewDataItem.providerFasterPayFee}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-2 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-md-auto col-12 col-xl-6 text-left text-xl-right">
                                        Adjusted Artist Fee
                                    </label>
                                    <div className="col-12 col-xl-6 pl-0">
                                        <NumberBox
                                            disabled={true}
                                            format={{
                                                type: "currency",
                                                precision: 2,
                                                currency: "GBP",
                                            }}
                                            onValueChanged={this.handleChangeAdjustedAmount}
                                            onContentReady={this.onContentReadyNumberBox}
                                            valueChangeEvent="keyup"
                                            step={0}
                                            value={this.state.editViewDataItem.providerPayAmountLocal}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Artist Confirmed
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <SelectBox
                                            disabled={
                                                this.state.createAdjustment ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            dataSource={this.decisionTypesDataSource}
                                            displayExpr="value"
                                            valueExpr="value"
                                            onValueChanged={this.handleChangeArtistConfirmation}
                                            value={
                                                this.state.editViewDataItem.shiftCompleteAcknowledgment == true
                                                    ? "Yes"
                                                    : this.props.location &&
                                                      this.props.location.state &&
                                                      this.props.location.state.id != 0 &&
                                                      this.state.editViewDataItem.shiftCompleteAcknowledgment == false
                                                    ? "No"
                                                    : this.state.editViewDataItem.shiftCompleteAcknowledgment
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 pr-0">
                                    <div className="row">
                                        <div className="col-12 col-lg-8 row mx-0 mt-3">
                                            <label className="card-form__label label-padding col-12 col-xl-4 text-left text-xl-right">
                                                Confirmed Date/Time
                                            </label>
                                            <div className="col-12 col-xl-8 pl-2">
                                                <DateBox
                                                    disabled={
                                                        this.state.createAdjustment
                                                            ? this.state.createAdjustment
                                                            : (this.props.location &&
                                                                  this.props.location.state &&
                                                                  this.props.location.state.isAmend) ||
                                                              this.state.readOnlyView ||
                                                              (this.props.location &&
                                                                  this.props.location.state &&
                                                                  this.props.location.state.isAdjust)
                                                    }
                                                    onValueChanged={this.handleChangeArtistConfirmedDate}
                                                    value={
                                                        this.state.editViewDataItem.shiftCompleteAcknowledgmentDateTime
                                                            ? this.state.editViewDataItem
                                                                  .shiftCompleteAcknowledgmentDateTime
                                                            : undefined
                                                    }
                                                    useMaskBehavior={true}
                                                    displayFormat="dd/MM/yyyy"
                                                    min={calendarMin}
                                                    className="confirmed-date"
                                                ></DateBox>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-4 row mx-0 mt-3">
                                            <div className="col-12 pl-0">
                                                <DateBox
                                                    type="time"
                                                    interval={15}
                                                    useMaskBehavior={true}
                                                    displayFormat={"HH:mm"}
                                                    disabled={
                                                        this.state.createAdjustment ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAmend) ||
                                                        this.state.readOnlyView ||
                                                        (this.props.location &&
                                                            this.props.location.state &&
                                                            this.props.location.state.isAdjust)
                                                    }
                                                    onValueChanged={this.handleChangeArtistConfirmedTime}
                                                    value={
                                                        this.state.editViewDataItem.shiftCompleteAcknowledgmentTime
                                                            ? this.state.editViewDataItem
                                                                  .shiftCompleteAcknowledgmentTime
                                                            : undefined
                                                    }
                                                    onContentReady={this.onContentReadyDateBox}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                        Artist Description
                                    </label>
                                    <div className="col-12 col-xl-9 pl-0">
                                        <TextBox
                                            disabled={
                                                this.state.createAdjustment ||
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            onValueChanged={this.handleChangeDescription}
                                            value={this.state.editViewDataItem.shiftCompleteAcknowledgmentDescription}
                                        ></TextBox>
                                    </div>
                                </div>
                            </div>

                            <div className="row mx-0 pr-0">
                                <div className="col-12 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-1 text-left text-xl-right">
                                        External Comments (Public)
                                    </label>
                                    <div className="col-12 col-xl-11 pl-0">
                                        <TextArea
                                            height={100}
                                            value={this.state.editViewDataItem.comments}
                                            onValueChanged={this.handleChangeComments}
                                            disabled={this.state.readOnlyView}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mx-0 pr-0">
                                <div className="col-12 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-md-auto col-xl-1 text-left text-xl-right">
                                        Internal Comments (Private)
                                    </label>
                                    <sup className="card-form__mandatory-symbol-Internal-Comments">*</sup>
                                    <div className="col-12 col-xl-11 pl-0">
                                        <TextArea
                                            height={100}
                                            value={this.state.editViewDataItem.internalComments}
                                            onValueChanged={this.handleChangeInternalComments}
                                            disabled={this.state.readOnlyView}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                );
            }
        }
    };

    renderPersonnelAdjustmentPanel = () => {
        var readOnlyView: boolean = false;
        if (this.props.location && this.props.location.state && this.props.location.state.isReadOnly) {
            readOnlyView = this.props.location.state.isReadOnly;
        }
        var maskedValue: string =
            this.state.editViewDataItem.identificationTypeId == IdentificationType.SIALicense
                ? "0000-0000-0000-0000"
                : "";
        if (
            (this.props.location &&
                this.props.location.state &&
                this.props.location.state.isAdjust &&
                this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionPersonnel) ||
            (this.props.location &&
                this.props.location.state &&
                this.props.location.state.isAdjust &&
                (this.props.location.state.service == "Security - Door Supervision Personnel" ||
                    this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionPersonnel))
        ) {
            return (
                <section className="card card-form my-5">
                    <div className="card-body">
                        <h3 className="card-form__section-heading">Adjustment</h3>
                        <hr className="horizontal_border_style"></hr>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Type/Role
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <DropDownFromLookupTableDynamic
                                        lookupTypeIndex={LookupTypeIndexes.offeringsType}
                                        isRoot={false}
                                        parentMappingId={this.state.editViewDataItem.serviceSubTypeId}
                                        onValueChanged={this.handleChangeOfferingsTypeSelect}
                                        isDisabled={
                                            this.state.createAdjustment ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAmend) ||
                                            this.state.typeLUDisablement ||
                                            readOnlyView
                                        }
                                        value={this.state.editViewDataItem.typeId}
                                    />
                                    <input
                                        data-testid={LookupTypeIndexes.offeringsType}
                                        type="hidden"
                                        name={LookupTypeIndexes.offeringsType}
                                        value={
                                            this.state.editViewDataItem.typeId ? this.state.editViewDataItem.typeId : ""
                                        }
                                    ></input>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 pr-0">
                                <div className="row">
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                            Approved Start
                                        </label>
                                        <div className="col-12 col-xl-6 pl-0">
                                            <DateBox
                                                type="time"
                                                interval={15}
                                                placeholder="00:00"
                                                useMaskBehavior={true}
                                                displayFormat={"HH:mm"}
                                                valueChangeEvent="keyup"
                                                value={
                                                    this.state.editViewDataItem.originalBillableStartTime
                                                        ? this.state.editViewDataItem.originalBillableStartTime
                                                        : undefined
                                                }
                                                disabled={true}
                                                onContentReady={this.onContentReadyDateBox}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                            End
                                        </label>
                                        <div className="col-12 col-xl-6 pl-0">
                                            <DateBox
                                                type="time"
                                                interval={15}
                                                placeholder="00:00"
                                                useMaskBehavior={true}
                                                displayFormat={"HH:mm"}
                                                valueChangeEvent="keyup"
                                                value={
                                                    this.state.editViewDataItem.originalBillableFinishTime
                                                        ? this.state.editViewDataItem.originalBillableFinishTime
                                                        : undefined
                                                }
                                                disabled={true}
                                                onContentReady={this.onContentReadyDateBox}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">Rate</label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeOriginalRate}
                                        valueChangeEvent="keyup"
                                        value={this.state.editViewDataItem.originalRate}
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="w-50 mx-auto">
                                <LoadIndicator
                                    id="load-indicator"
                                    className="load-indicator"
                                    height={40}
                                    width={40}
                                    visible={this.state.loadIndicatorVisible}
                                />
                            </div>
                        </div>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Name
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <TextBox
                                        disabled={
                                            this.state.createAdjustment
                                                ? this.state.createAdjustment
                                                : (this.props.location &&
                                                      this.props.location.state &&
                                                      this.props.location.state.isAmend) ||
                                                  readOnlyView
                                        }
                                        onValueChanged={this.handleChangeName}
                                        value={this.state.editViewDataItem.name}
                                    ></TextBox>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 pr-0">
                                <div className="row">
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label-requested-on col-12 col-xl-6 text-left text-xl-right">
                                            Adjusted Start
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-6 pl-0">
                                            <DateBox
                                                type="time"
                                                interval={15}
                                                placeholder="00:00"
                                                useMaskBehavior={true}
                                                displayFormat={"HH:mm"}
                                                onValueChanged={this.handleChangeBillableStart}
                                                valueChangeEvent="keyup"
                                                value={
                                                    this.state.editViewDataItem.billable_Start
                                                        ? this.state.editViewDataItem.billable_Start
                                                        : undefined
                                                }
                                                disabled={
                                                    this.state.IsLockBillableFields ||
                                                    this.state.IsLockTimeFields ||
                                                    readOnlyView
                                                }
                                                onContentReady={this.onContentReadyDateBox}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                            End
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-6 pl-0">
                                            <DateBox
                                                type="time"
                                                interval={15}
                                                placeholder="00:00"
                                                useMaskBehavior={true}
                                                displayFormat={"HH:mm"}
                                                onValueChanged={this.handleChangeBillableFinish}
                                                valueChangeEvent="keyup"
                                                value={
                                                    this.state.editViewDataItem.billable_Finish
                                                        ? this.state.editViewDataItem.billable_Finish
                                                        : undefined
                                                }
                                                disabled={
                                                    this.state.IsLockBillableFields ||
                                                    this.state.IsLockTimeFields ||
                                                    readOnlyView
                                                }
                                                onContentReady={this.onContentReadyDateBox}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label-requested-on col-12 col-xl-3 text-left text-xl-right">
                                    Adjusted Rate
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={
                                            this.state.createAdjustment ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAmend) ||
                                            readOnlyView
                                        }
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeRate}
                                        valueChangeEvent="keyup"
                                        value={this.state.editViewDataItem.rate_Decimal}
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label-requested-on col-12 col-xl-3 text-left text-xl-right">
                                    License No.
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <TextBox
                                        mask={maskedValue}
                                        disabled={
                                            this.state.createAdjustment
                                                ? this.state.createAdjustment
                                                : (this.props.location &&
                                                      this.props.location.state &&
                                                      this.props.location.state.isAmend) ||
                                                  readOnlyView
                                        }
                                        onValueChanged={this.handleChangeIdentificationNumber}
                                        value={this.state.editViewDataItem.identification_Number}
                                    ></TextBox>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Difference
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        value={this.state.editViewDataItem.billable_Minutes}
                                    ></NumberBox>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Difference
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={this.state.editViewDataItem.billableRate}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label-requested-on col-12 col-xl-3 text-left text-xl-right">
                                    Absent
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <SelectBox
                                        disabled={
                                            this.state.createAdjustment || this.state.IsLockTimeFields || readOnlyView
                                        }
                                        dataSource={this.absentTypeDataSource}
                                        displayExpr="value"
                                        valueExpr="value"
                                        onValueChanged={this.handleChangeAbsent}
                                        value={
                                            this.state.editViewDataItem.absent == "" &&
                                            this.props.location &&
                                            this.props.location.state &&
                                            this.props.location.state.id == 0
                                                ? "Present"
                                                : this.state.editViewDataItem.absent
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Cover
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <SelectBox
                                        disabled={
                                            this.state.createAdjustment || this.state.IsLockTimeFields || readOnlyView
                                        }
                                        dataSource={this.decisionTypesDataSource}
                                        displayExpr="value"
                                        valueExpr="value"
                                        onValueChanged={this.handleChangeCover}
                                        value={
                                            this.state.editViewDataItem.cover == "" &&
                                            this.props.location &&
                                            this.props.location.state &&
                                            this.props.location.state.id == 0
                                                ? "No"
                                                : this.state.editViewDataItem.cover
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Charge
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <SelectBox
                                        disabled={readOnlyView}
                                        dataSource={this.chargeTypesDataSource}
                                        displayExpr="value"
                                        valueExpr="value"
                                        onValueChanged={this.handleChangeNoChange}
                                        value={
                                            this.state.editViewDataItem.noCharge == "" &&
                                            this.props.location &&
                                            this.props.location.state &&
                                            this.props.location.state.id == 0
                                                ? "Applied"
                                                : this.state.editViewDataItem.noCharge
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 row mx-0 pr-0 mt-3">
                                <p className="text-danger font-weight-bold mx-auto">
                                    {
                                        <span className={this.state.calculationMessageClassName}>
                                            <b>
                                                {this.state.calculationMessage.length > 0
                                                    ? this.state.calculationMessage[
                                                          this.state.calculationMessage.length - 1
                                                      ]
                                                    : null}
                                            </b>
                                        </span>
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }
    };

    renderEquipmentAdjustmentPanel = () => {
        var readOnlyView: boolean = false;
        if (this.props.location && this.props.location.state && this.props.location.state.isReadOnly) {
            readOnlyView = this.props.location.state.isReadOnly;
        }
        var maskedValue: string =
            this.state.editViewDataItem.identificationTypeId == IdentificationType.SIALicense
                ? "0000-0000-0000-0000"
                : "";

        if (
            (this.props.location &&
                this.props.location.state &&
                this.props.location.state.isAdjust &&
                this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionEquipment) ||
            (this.props.location &&
                this.props.location.state &&
                this.props.location.state.isAdjust &&
                ((this.props.location &&
                    this.props.location.state &&
                    this.props.location.state.service == "Security - Door Supervision Equipment") ||
                    this.state.editViewDataItem.serviceSubTypeId == SubServiceType.DoorSupervisionEquipment))
        ) {
            return (
                <section className="card card-form my-5">
                    <div className="card-body">
                        <h3 className="card-form__section-heading">Adjustment</h3>
                        <hr className="horizontal_border_style"></hr>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Role/Type
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <DropDownFromLookupTableDynamic
                                        lookupTypeIndex={LookupTypeIndexes.offeringsType}
                                        isRoot={false}
                                        parentMappingId={this.state.editViewDataItem.serviceSubTypeId}
                                        onValueChanged={this.handleChangeOfferingsTypeSelect}
                                        isDisabled={
                                            this.state.createAdjustment ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAmend) ||
                                            this.state.typeLUDisablement ||
                                            readOnlyView
                                        }
                                        value={this.state.editViewDataItem.typeId}
                                    />
                                    <input
                                        data-testid={LookupTypeIndexes.offeringsType}
                                        type="hidden"
                                        name={LookupTypeIndexes.offeringsType}
                                        value={
                                            this.state.editViewDataItem.typeId ? this.state.editViewDataItem.typeId : ""
                                        }
                                    ></input>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Quantity
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        onValueChanged={this.handleChangeOriginalQuantity}
                                        valueChangeEvent="keyup"
                                        value={this.state.editViewDataItem.equipmentOriginalQuantity}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Previous Rate
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeOriginalRate}
                                        valueChangeEvent="keyup"
                                        value={this.state.editViewDataItem.originalRate}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="w-50 mx-auto">
                                <LoadIndicator
                                    id="load-indicator"
                                    className="load-indicator"
                                    height={40}
                                    width={40}
                                    visible={this.state.loadIndicatorVisible}
                                />
                            </div>
                        </div>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Serial No.
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <TextBox
                                        mask={maskedValue}
                                        disabled={
                                            this.state.createAdjustment
                                                ? this.state.createAdjustment
                                                : (this.props.location &&
                                                      this.props.location.state &&
                                                      this.props.location.state.isAmend) ||
                                                  readOnlyView
                                        }
                                        onValueChanged={this.handleChangeIdentificationNumber}
                                        value={this.state.editViewDataItem.identification_Number}
                                    ></TextBox>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-md-auto col-12 col-xl-3 text-left text-xl-right">
                                    Adjusted Quantity
                                </label>
                                <sup className="card-form__mandatory-symbol-Provider-Net">*</sup>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={
                                            this.state.createAdjustment ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAmend) ||
                                            this.state.IsLockQuantityFields ||
                                            readOnlyView
                                        }
                                        onValueChanged={this.handleChangeQuantity}
                                        valueChangeEvent="keyup"
                                        value={this.state.editViewDataItem.equipmentQuantity}
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label-requested-on col-md-auto col-12 col-xl-3 text-left text-xl-right">
                                    Adjusted Rate
                                </label>
                                <sup className="card-form__mandatory-symbol-Adjusted-Rate">*</sup>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={
                                            this.state.createAdjustment ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAmend) ||
                                            readOnlyView
                                        }
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeRate}
                                        valueChangeEvent="keyup"
                                        value={this.state.editViewDataItem.rate_Decimal}
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Charge
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <SelectBox
                                        disabled={readOnlyView}
                                        dataSource={this.chargeTypesDataSource}
                                        displayExpr="value"
                                        valueExpr="value"
                                        onValueChanged={this.handleChangeNoChange}
                                        value={
                                            this.state.editViewDataItem.noCharge == "" &&
                                            this.props.location &&
                                            this.props.location.state &&
                                            this.props.location.state.id == 0
                                                ? "Applied"
                                                : this.state.editViewDataItem.noCharge
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Difference
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        value={this.state.editViewDataItem.equipmentBillableQuantity}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Difference
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={this.state.editViewDataItem.billableRate}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 row mx-0 pr-0 mt-3">
                                <p className="text-danger font-weight-bold mx-auto">
                                    {
                                        <span className={this.state.calculationMessageClassName}>
                                            {this.state.calculationMessage.length > 0
                                                ? this.state.calculationMessage[
                                                      this.state.calculationMessage.length - 1
                                                  ]
                                                : null}
                                        </span>
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }
    };

    renderWeeklyCleaningAdjustmentPanel = () => {
        var readOnlyView: boolean = false;
        if (this.props.location && this.props.location.state && this.props.location.state.isReadOnly) {
            readOnlyView = this.props.location.state.isReadOnly;
        }

        if (
            (this.props.location &&
                this.props.location.state &&
                this.props.location.state.isAdjust &&
                this.state.editViewDataItem.serviceSubTypeId == SubServiceType.WeeklyCleaning) ||
            (this.props.location &&
                this.props.location.state &&
                this.props.location.state.isAdjust &&
                ((this.props.location &&
                    this.props.location.state &&
                    this.props.location.state.service == "Contract Cleaning - Weekly Cleaning") ||
                    this.state.editViewDataItem.serviceSubTypeId == SubServiceType.WeeklyCleaning))
        ) {
            return (
                <section className="card card-form my-5">
                    <div className="card-body">
                        <h3 className="card-form__section-heading">Adjustment</h3>
                        <hr className="horizontal_border_style"></hr>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 col-lg-4 pr-0">
                                <div className="row">
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                            Hours
                                        </label>
                                        <div className="col-12 col-xl-6 pl-2">
                                            <NumberBox
                                                disabled={true}
                                                valueChangeEvent="keyup"
                                                value={this.state.prevHours}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                            Min
                                        </label>
                                        <div className="col-12 col-xl-6 pl-0">
                                            <SelectBox
                                                disabled={true}
                                                dataSource={minuteLookup}
                                                displayExpr="value"
                                                valueExpr="id"
                                                value={this.state.prevminutes}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">Rate</label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeOriginalRate}
                                        valueChangeEvent="keyup"
                                        value={this.state.editViewDataItem.originalRate}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Charge
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <SelectBox
                                        disabled={true}
                                        dataSource={this.chargeTypesDataSource}
                                        displayExpr="value"
                                        valueExpr="value"
                                        onValueChanged={this.handleChangeNoChange}
                                        value={
                                            this.state.editViewDataItem.noCharge == "" &&
                                            this.props.location &&
                                            this.props.location.state &&
                                            this.props.location &&
                                            this.props.location.state.id == 0
                                                ? "Applied"
                                                : this.props.location &&
                                                  this.props.location.state &&
                                                  this.props.location.state.isAdjust
                                                ? this.state.editViewVirtualDataItem.noCharge
                                                : this.state.editViewDataItem.noCharge
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="w-50 mx-auto">
                                <LoadIndicator
                                    id="load-indicator"
                                    className="load-indicator"
                                    height={40}
                                    width={40}
                                    visible={this.state.loadIndicatorVisible}
                                />
                            </div>
                        </div>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 col-lg-4 pr-0">
                                <div className="row">
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                            Hours
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-6 pl-2">
                                            <NumberBox
                                                disabled={false}
                                                onValueChanged={this.handleChangeHours}
                                                valueChangeEvent="keyup"
                                                value={this.state.hours}
                                                onContentReady={this.onContentReadyNumberBox}
                                                step={0}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                            Min
                                            <sup className="card-form__mandatory-symbol">*</sup>
                                        </label>
                                        <div className="col-12 col-xl-6 pl-0">
                                            <SelectBox
                                                dataSource={minuteLookup}
                                                displayExpr="value"
                                                valueExpr="id"
                                                onValueChanged={this.handleChangeMinutes}
                                                value={this.state.minutes}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label-requested-on col-md-auto col-12 col-xl-3 text-left text-xl-right">
                                    Adjusted Rate
                                </label>
                                <sup className="card-form__mandatory-symbol-Adjusted-Rate">*</sup>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={
                                            this.state.createAdjustment ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAmend) ||
                                            readOnlyView
                                        }
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeRate}
                                        valueChangeEvent="keyup"
                                        value={this.state.editViewDataItem.rate_Decimal}
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Difference
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        value={this.state.editViewDataItem.equipmentBillableQuantity}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Difference
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={this.state.editViewDataItem.billableRate}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 row mx-0 pr-0 mt-3">
                                <p className="text-danger font-weight-bold mx-auto">
                                    {
                                        <span className={this.state.calculationMessageClassName}>
                                            {this.state.calculationMessage.length > 0
                                                ? this.state.calculationMessage[
                                                      this.state.calculationMessage.length - 1
                                                  ]
                                                : null}
                                        </span>
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }
    };

    renderEntertainmentAdjustmentPanel = () => {
        var readOnlyView: boolean = false;
        if (this.props.location && this.props.location.state && this.props.location.state.isReadOnly) {
            readOnlyView = this.props.location.state.isReadOnly;
        }
        let isDisableOfferingsType: boolean = true;
        let isOtherDescToShow: boolean = false;
        if (
            this.state.offeringsTypeLookup &&
            this.state.offeringsTypeLookup.length > 0 &&
            this.state.editViewDataItem.serviceSubTypeId
        ) {
            isDisableOfferingsType = false;
        } else {
            if (this.state.editViewDataItem.serviceSubTypeId == Types.Other) {
                isOtherDescToShow = true;
            } else {
                isDisableOfferingsType = true;
            }
        }
        if (
            (this.props.location &&
                this.props.location.state &&
                this.props.location.state.isAdjust &&
                this.state.editViewDataItem.serviceTypeId == ServiceType.Entertainment) ||
            (this.props.location &&
                this.props.location.state &&
                this.props.location.state.isAdjust &&
                ((this.props.location &&
                    this.props.location.state &&
                    this.props.location.state.service &&
                    this.props.location.state.service.includes("Entertainment")) ||
                    this.state.editViewDataItem.serviceTypeId == ServiceType.Entertainment))
        ) {
            return (
                <section className="card card-form my-5">
                    <div className="card-body">
                        <h3 className="card-form__section-heading">Adjustment</h3>
                        <hr className="horizontal_border_style"></hr>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Provider
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <LookupTypeListDynamic
                                        lookupTypeIndex={LookupTypeIndexes.providerType}
                                        onValueChanged={this.handleChangeProviderTypeSelect}
                                        isDisabled={
                                            this.state.createAdjustment ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAmend) ||
                                            this.state.readOnlyView
                                        }
                                        isRoot={false}
                                        parentMappingId={""}
                                        displayExpression={"value"}
                                        value={this.state.editViewDataItem.providerId}
                                        recordType={
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isEdit) ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isMasterEdit)
                                                ? "all"
                                                : "active"
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3"></div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Performance Information
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <TextBox
                                        disabled={
                                            this.state.createAdjustment
                                                ? this.state.createAdjustment
                                                : (this.props.location &&
                                                      this.props.location.state &&
                                                      this.props.location.state.isAmend) ||
                                                  this.state.readOnlyView
                                        }
                                        onValueChanged={this.handleChangePerformanceInfo}
                                        value={this.state.editViewDataItem.performanceInformation}
                                    ></TextBox>
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    {isOtherDescToShow ? "Description" : "Role/Type"}
                                    {isOtherDescToShow ? (
                                        <sup className="card-form__mandatory-symbol">*</sup>
                                    ) : (
                                        <sup className="card-form__mandatory-symbol" hidden={isDisableOfferingsType}>
                                            *
                                        </sup>
                                    )}
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    {isOtherDescToShow ? (
                                        <TextBox
                                            onValueChanged={this.handleChangeOtherDescription}
                                            value={this.state.editViewDataItem.otherDescription}
                                        ></TextBox>
                                    ) : (
                                        <SelectBox
                                            dataSource={this.state.offeringsTypeLookup}
                                            displayExpr={"value"}
                                            valueExpr={"id"}
                                            onValueChanged={this.handleChangeOfferingsTypeSelect}
                                            value={this.state.editViewDataItem.typeId}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 pr-0">
                                <div className="row">
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                            Performance Start
                                        </label>
                                        <div className="col-12 col-xl-6 pl-0">
                                            <DateBox
                                                type="time"
                                                interval={15}
                                                placeholder="00:00"
                                                useMaskBehavior={true}
                                                displayFormat={"HH:mm"}
                                                onValueChanged={this.handleChangeShiftStart}
                                                value={
                                                    this.state.editViewDataItem.shift_Start
                                                        ? this.state.editViewDataItem.shift_Start
                                                        : undefined
                                                }
                                                onContentReady={this.onContentReadyDateBox}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                            Performance End
                                        </label>
                                        <div className="col-12 col-xl-6 pl-0">
                                            <DateBox
                                                type="time"
                                                interval={15}
                                                placeholder="00:00"
                                                useMaskBehavior={true}
                                                displayFormat={"HH:mm"}
                                                onValueChanged={this.handleChangeShiftEnd}
                                                value={
                                                    this.state.editViewDataItem.shift_End
                                                        ? this.state.editViewDataItem.shift_End
                                                        : undefined
                                                }
                                                onContentReady={this.onContentReadyDateBox}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Previous Provider Net
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeOriginalRate}
                                        valueChangeEvent="keyup"
                                        value={this.state.editViewDataItem.originalRate}
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="w-50 mx-auto">
                                <LoadIndicator
                                    id="load-indicator"
                                    className="load-indicator"
                                    height={40}
                                    width={40}
                                    visible={this.state.loadIndicatorVisible}
                                />
                            </div>
                        </div>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Pay Request Description
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <TextBox
                                        disabled={
                                            this.state.createAdjustment
                                                ? this.state.createAdjustment
                                                : (this.props.location &&
                                                      this.props.location.state &&
                                                      this.props.location.state.isAmend) ||
                                                  this.state.readOnlyView
                                        }
                                        readOnly={true}
                                        value={this.state.editViewDataItem.paymentRequest?.description}
                                    ></TextBox>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 pr-0">
                                <div className="row">
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                            Sets
                                        </label>
                                        <div className="col-12 col-xl-6 pl-0">
                                            <NumberBox
                                                value={parseInt(
                                                    this.state.editViewDataItem.performanceInformationSetsNumber
                                                )}
                                                max={5}
                                                min={0}
                                                showSpinButtons={true}
                                                onValueChanged={this.handleChangeSetNumber}
                                                disabled={
                                                    this.state.createAdjustment
                                                        ? this.state.createAdjustment
                                                        : (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAmend) ||
                                                          this.state.readOnlyView
                                                }
                                                onContentReady={this.onContentReadyNumberBox}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                            Duration
                                        </label>
                                        <div className="col-12 col-xl-6 pl-0">
                                            <NumberBox
                                                min={0}
                                                max={90}
                                                step={15}
                                                showSpinButtons={true}
                                                value={parseInt(
                                                    this.state.editViewDataItem.performanceInformationSetsDuration
                                                )}
                                                onValueChanged={this.handleChangeDuration}
                                                disabled={
                                                    this.state.createAdjustment
                                                        ? this.state.createAdjustment
                                                        : (this.props.location &&
                                                              this.props.location.state &&
                                                              this.props.location.state.isAmend) ||
                                                          this.state.readOnlyView
                                                }
                                                onContentReady={this.onContentReadyNumberBox}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label-provider-net col-md-auto col-12 col-xl-3 text-left text-xl-right">
                                    Adjusted Provider Net
                                </label>
                                <sup className="card-form__mandatory-symbol-Adjusted-Provider-Rate">*</sup>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={
                                            this.state.createAdjustment ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAmend) ||
                                            readOnlyView
                                        }
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeRate}
                                        valueChangeEvent="keyup"
                                        value={this.state.editViewDataItem.rate_Decimal}
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0 pr-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Charge
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <SelectBox
                                        disabled={readOnlyView}
                                        dataSource={this.chargeTypesDataSource}
                                        displayExpr="value"
                                        valueExpr="value"
                                        onValueChanged={this.handleChangeNoChange}
                                        value={
                                            this.state.editViewDataItem.noCharge == "" &&
                                            this.props.location &&
                                            this.props.location.state &&
                                            this.props.location.state.id == 0
                                                ? "Applied"
                                                : this.state.editViewDataItem.noCharge
                                        }
                                    />
                                </div>
                            </div>

                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Equipment
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <TextBox
                                        disabled={
                                            this.state.createAdjustment
                                                ? this.state.createAdjustment
                                                : (this.props.location &&
                                                      this.props.location.state &&
                                                      this.props.location.state.isAmend) ||
                                                  this.state.readOnlyView
                                        }
                                        onValueChanged={this.handleChangeEquipmentRequired}
                                        value={this.state.editViewDataItem.equipmentRequired}
                                    ></TextBox>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Difference
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        value={this.state.editViewDataItem.billableRate}
                                    ></NumberBox>
                                </div>
                            </div>
                        </div>

                        <div className="row mx-0 pr-0">
                            <div className="col-12 row mx-0 pr-0 mt-3">
                                <p className="text-danger font-weight-bold mx-auto">
                                    {
                                        <span className={this.state.calculationMessageClassName}>
                                            <b>
                                                {this.state.calculationMessage.length > 0
                                                    ? this.state.calculationMessage[
                                                          this.state.calculationMessage.length - 1
                                                      ]
                                                    : null}
                                            </b>
                                        </span>
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }
    };

    //Helper function to navigate to the Simple shifts page by storing the appropriate service type id's into session storage.
    viewSimpleShiftsForService = (serviceTypeId: string) => {
        sessionStorage.setItem("serviceTypeFilter", serviceTypeId);
    };

    renderFinancialPanel = () => {
        var hideButtonAddFinance: boolean = true;
        if (UserService.isUserInGroup(RoleGroupNames.EventUKSeniorManager)) {
            hideButtonAddFinance = false;
        }
        var readOnlyView: boolean = false;
        if (this.props.location && this.props.location.state && this.props.location.state.isReadOnly) {
            readOnlyView = this.props.location.state.isReadOnly;
        }

        var disableViewPaymentLink: boolean = false;
        var disableViewBillingLink: boolean = false;
        if (!this.state.editViewDataItem.paymentId) {
            disableViewPaymentLink = true;
        }
        if (!this.state.editViewDataItem.invoiceId) {
            disableViewBillingLink = true;
        }
        let paymentRequestVal: string = "";
        let paymentRequestId: string = "";
        let disableViewPaymentBtn: boolean = true;
        if (
            this.state.editViewDataItem.paymentRequest &&
            this.state.editViewDataItem.paymentRequest.fasterPayment &&
            this.state.editViewDataItem.paymentRequest.id
        ) {
            paymentRequestVal = this.state.editViewDataItem.paymentRequest.fasterPayment;
            paymentRequestId = this.state.editViewDataItem.paymentRequest.id;
            disableViewPaymentBtn = false;
        } else if (
            this.state.editViewDataItem.paymentRequest == null &&
            this.state.editViewDataItem.shiftCompleteAcknowledgment
        ) {
            paymentRequestVal = "Confirmed";
        }
        if (this.state.isLoadFinancialPanel) {
            return (
                <section className="card card-form my-5">
                    <div className="card-body">
                        <h3 className="card-form__section-heading">Financials</h3>
                        <hr className="horizontal_border_style"></hr>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Provider VAT
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <SelectBox
                                        dataSource={this.decisionTypesDataSource}
                                        displayExpr="value"
                                        valueExpr="value"
                                        onValueChanged={this.handleChangeProviderTaxApplicableSelect}
                                        value={
                                            this.state.editViewDataItem.provider_Tax_Applicable == "Yes" ||
                                            this.state.editViewDataItem.provider_Tax_Applicable == "True"
                                                ? "Yes"
                                                : "No"
                                        }
                                        disabled={
                                            this.state.readOnlyView ||
                                            this.editAllowed ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Event VAT
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <SelectBox
                                        dataSource={this.decisionTypesDataSource}
                                        displayExpr="value"
                                        valueExpr="value"
                                        onValueChanged={this.handleChangeFeeTaxApplicableSelect}
                                        value={
                                            this.state.editViewDataItem.fee_Tax_Applicable == "Yes" ||
                                            this.state.editViewDataItem.fee_Tax_Applicable == "True"
                                                ? "Yes"
                                                : "No"
                                        }
                                        disabled={
                                            this.state.readOnlyView ||
                                            this.editAllowed ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Client VAT
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <SelectBox
                                        dataSource={this.decisionTypesDataSource}
                                        displayExpr="value"
                                        valueExpr="value"
                                        onValueChanged={this.handleChangeClientTaxApplicableSelect}
                                        value={
                                            this.state.editViewDataItem.client_Tax_Applicable == "Yes" ||
                                            this.state.editViewDataItem.client_Tax_Applicable == "True"
                                                ? "Yes"
                                                : "No"
                                        }
                                        disabled={
                                            this.state.readOnlyView ||
                                            this.editAllowed ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Provider NET
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeProviderLocalCurrancyAmount}
                                        valueChangeEvent="keyup"
                                        value={this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy}
                                        disabled={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                    />
                                    <span>
                                        {" "}
                                        <LoadIndicator
                                            height={40}
                                            width={40}
                                            visible={this.state.loadIndicatorOnPercentageChange}
                                        />
                                    </span>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Event NET
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeFeeLocalCurrancyAmount}
                                        valueChangeEvent="keyup"
                                        value={this.state.editViewDataItem.fee_Amount_Local_Ccy}
                                        disabled={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Client NET
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeBillLocalCurrancyAmount}
                                        valueChangeEvent="keyup"
                                        value={this.state.editViewDataItem.client_Billable_Amount_Local_Ccy}
                                        disabled={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Provider VAT
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeProviderLocalCurrancyTax}
                                        value={this.state.editViewDataItem.provider_Pay_Tax_Local_Ccy}
                                        disabled={
                                            !this.state.isProviderTaxFieldVisible ||
                                            this.editAllowed ||
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                        valueChangeEvent="keyup"
                                        step={0}
                                        onContentReady={this.onContentReadyNumberBox}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Event VAT
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeFeeLocalCurrancyTax}
                                        value={this.state.editViewDataItem.fee_Tax_Local_Ccy}
                                        disabled={
                                            !this.state.isFeeTaxFieldVisible ||
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                        valueChangeEvent="keyup"
                                        step={0}
                                        onContentReady={this.onContentReadyNumberBox}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Client VAT
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeBillLocalCurrancyTax}
                                        value={this.state.editViewDataItem.client_Billable_Tax_Local_Ccy}
                                        disabled={
                                            !this.state.isBillClientTaxFieldVisible ||
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Provider GROSS
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={this.state.editViewDataItem.provider_Pay_Total_Local_Ccy}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Event GROSS
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={this.state.editViewDataItem.fee_Total_Local_Ccy}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Client GROSS
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={this.state.editViewDataItem.client_Billable_Total_Local_Ccy}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Provider Previous Net
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={this.state.editViewDataItem.provider_Pay_Original_Amount_Local_Ccy}
                                        disabled={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Expected Fee
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={this.state.expectedFee}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Client Previous Net
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeProviderOriginalAmount}
                                        value={this.state.editViewDataItem.client_Billable_Original_Amount_Local_Ccy}
                                        disabled={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Acceptance Date
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <DateBox
                                        onValueChanged={this.handleChangeAcceptDate}
                                        useMaskBehavior={true}
                                        displayFormat="dd/MM/yyyy"
                                        value={
                                            this.state.editViewDataItem.accept_Date
                                                ? this.state.editViewDataItem.accept_Date
                                                : undefined
                                        }
                                        disabled={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Event Multiplier
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format="0.0000"
                                        onValueChanged={this.handleChangePercentage}
                                        valueChangeEvent="keyup"
                                        value={
                                            this.state.isMultiplierOverride
                                                ? this.state.multiplierOverrideValue
                                                : this.state.editViewDataItem.fee_Percentage_Local_Ccy
                                        }
                                        disabled={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                    ></NumberBox>
                                    <span>
                                        {" "}
                                        <LoadIndicator
                                            height={40}
                                            width={40}
                                            visible={this.state.loadIndicatorOnPercentageChange}
                                        />
                                    </span>
                                </div>
                            </div>
                            <div className="col-12 col-lg-2 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                    Approval Date
                                </label>
                                <div className="col-12 col-xl-6 pl-0">
                                    <DateBox
                                        onValueChanged={this.handleChangeApprovalDate}
                                        useMaskBehavior={true}
                                        displayFormat="dd/MM/yyyy"
                                        value={
                                            this.state.editViewDataItem.approval_Date
                                                ? this.state.editViewDataItem.approval_Date
                                                : undefined
                                        }
                                        disabled={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-2 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                    2<sup>nd</sup> Approval Date
                                </label>
                                <div className="col-12 col-xl-6 pl-0">
                                    <DateBox
                                        onValueChanged={this.handleChangeTwoTierApprovalDate}
                                        useMaskBehavior={true}
                                        displayFormat="dd/MM/yyyy"
                                        value={
                                            this.state.editViewDataItem.twoTierApprovalDate
                                                ? this.state.editViewDataItem.twoTierApprovalDate
                                                : undefined
                                        }
                                        disabled={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Accepted By
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <TextBox
                                        disabled={true}
                                        value={
                                            this.state.editViewDataItem.accept_Date &&
                                            this.state.editViewDataItem.accepted_By
                                                ? this.state.editViewDataItem.accepted_By
                                                : ""
                                        }
                                    ></TextBox>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Accrual?
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <SelectBox
                                        dataSource={this.decisionTypesDataSource}
                                        displayExpr="value"
                                        valueExpr="value"
                                        onValueChanged={this.handleChangeAccrualTypeSelect}
                                        value={
                                            this.state.editViewDataItem.isAccrual == true ||
                                            this.state.editViewDataItem?.isAccrual?.toString() == "Yes"
                                                ? "Yes"
                                                : "No"
                                        }
                                        disabled={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust) ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isEdit)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-2 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                    Approved By
                                </label>
                                <div className="col-12 col-xl-6 pl-0">
                                    <TextBox
                                        disabled={true}
                                        value={
                                            this.state.editViewDataItem.approval_Date &&
                                            this.state.editViewDataItem.approved_By
                                                ? this.state.editViewDataItem.approved_By
                                                : ""
                                        }
                                    ></TextBox>
                                </div>
                            </div>
                            <div className="col-12 col-lg-2 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                    2<sup>nd</sup> Approved By
                                </label>
                                <div className="col-12 col-xl-6 pl-0">
                                    <TextBox
                                        disabled={true}
                                        value={
                                            this.state.editViewDataItem.twoTierApprovedBy
                                                ? this.state.editViewDataItem.twoTierApprovedBy
                                                : ""
                                        }
                                    ></TextBox>
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Pay Date
                                </label>
                                <div className="col-12 col-xl-5 pl-0">
                                    <DateBox
                                        onValueChanged={this.handleChangePayDate}
                                        useMaskBehavior={true}
                                        displayFormat="dd/MM/yyyy"
                                        value={
                                            this.state.editViewDataItem.pay_Date
                                                ? this.state.editViewDataItem.pay_Date
                                                : undefined
                                        }
                                        disabled={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                    />
                                </div>
                                <div className="col-12 col-xl-4 pl-0 mt-3 mt-xl-0">
                                    <Link
                                        to={{
                                            pathname: "/AddEditPaymentForm",
                                            state: {
                                                id: this.state.editViewDataItem.paymentId,
                                                cycleId: this.state.editViewDataItem.paymentCycleId,
                                                comesFrom: "ManageShift",
                                            },
                                        }}
                                    >
                                        <button
                                            className="btn btn-primary btn--small"
                                            disabled={disableViewPaymentLink}
                                        >
                                            View Payment
                                        </button>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Non Standard
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <SelectBox
                                        dataSource={this.nonStandardTypesDataSource}
                                        displayExpr="value"
                                        valueExpr="value"
                                        onValueChanged={this.handleChangeFeeNonStandardTypeSelect}
                                        value={
                                            this.state.editViewDataItem.non_Standard == "True"
                                                ? "Non - Standard"
                                                : this.state.editViewDataItem.non_Standard == "False"
                                                ? "Standard"
                                                : this.state.editViewDataItem.non_Standard
                                        }
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Bill Date
                                </label>
                                <div className="col-12 col-xl-5 pl-0">
                                    <DateBox
                                        onValueChanged={this.handleChangeBillDate}
                                        useMaskBehavior={true}
                                        displayFormat="dd/MM/yyyy"
                                        value={
                                            this.state.editViewDataItem.bill_Date
                                                ? this.state.editViewDataItem.bill_Date
                                                : undefined
                                        }
                                        disabled={
                                            readOnlyView ||
                                            !this.state.isClickedOnEdit ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                    />
                                </div>
                                <div className="col-12 col-xl-4 pl-0 mt-3 mt-xl-0">
                                    <Link
                                        to={{
                                            pathname: "/BillingPageV2",
                                            state: {
                                                id: this.state.editViewDataItem.invoiceId
                                                    ? this.state.editViewDataItem.invoiceId.toString()
                                                    : "",
                                            },
                                        }}
                                    >
                                        <button
                                            className="btn btn-primary btn--small"
                                            disabled={disableViewBillingLink}
                                        >
                                            View Bill
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Payment Request
                                </label>
                                <div className="col-12 col-xl-5 pl-0">
                                    <TextBox value={paymentRequestVal} disabled={true}></TextBox>
                                </div>
                                <div className="col-12 col-xl-4 pl-0 mt-3 mt-xl-0">
                                    <Link
                                        className="approval-query-column"
                                        onClick={(e: MouseEvent) => {
                                            e.preventDefault();
                                            window.open(
                                                `/MatchedPopUpPage?filterBy=${paymentRequestId}`,
                                                "Related Payment Request/ Artist Job Notification",
                                                "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=1050,height=400,left=100,top=100"
                                            );
                                        }}
                                        to="#"
                                    >
                                        <button className="btn btn-primary btn--small" disabled={disableViewPaymentBtn}>
                                            View Request
                                        </button>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Originator
                                    <sup className="card-form__mandatory-symbol">*</sup>
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <DropDownFromLookupTable
                                        lookupTypeIndex={LookupTypeIndexes.originator}
                                        onValueChanged={this.handleChangeOriginator}
                                        signal={this.state.createAdjustment}
                                        disableSignal={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                        value={
                                            this.state.editViewDataItem.originator &&
                                            this.state.editViewDataItem.originator.id
                                                ? this.state.editViewDataItem.originator.id.toString()
                                                : "50"
                                        }
                                        recordType="active"
                                    />
                                    <input
                                        data-testid={LookupTypeIndexes.originator}
                                        type="hidden"
                                        name={LookupTypeIndexes.originator}
                                        value={
                                            this.state.editViewDataItem.originator &&
                                            this.state.editViewDataItem.originator.id
                                                ? this.state.editViewDataItem.originator.id
                                                : 50
                                        }
                                    ></input>
                                </div>
                            </div>
                            <div
                                className={
                                    !hideButtonAddFinance
                                        ? "col-12 col-lg-2 row mx-0 pr-0 mt-3"
                                        : "col-12 col-lg-4 row mx-0 pr-0 mt-3"
                                }
                            >
                                <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                    Update / Correction
                                </label>
                                <div className="col-12 col-xl-6 pl-0">
                                    <SelectBox
                                        dataSource={this.updateCorrectionDataSource}
                                        displayExpr="value"
                                        valueExpr="id"
                                        onValueChanged={this.handleChangeCorrectionUpdate}
                                        value={this.state.editViewDataItem.updateOrCorrection}
                                    />
                                </div>
                            </div>
                            {!hideButtonAddFinance && (
                                <div className="col-12 col-lg-2 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                        Activity Type
                                    </label>
                                    <div className="col-12 col-xl-6 pl-0">
                                        <SelectBox
                                            dataSource={this.activityTypeDataSource}
                                            displayExpr="value"
                                            valueExpr="id"
                                            onValueChanged={this.handleChangeActivityType}
                                            value={this.state.editViewDataItem.billableActivityType}
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <LoadIndicator
                                    id="load-indicator"
                                    className="load-indicator--centered"
                                    height={40}
                                    width={40}
                                    visible={this.state.loadIndicatorVisible}
                                />
                            </div>
                        </div>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 pr-0">
                                <div className="row">
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                            Faster Payment
                                        </label>
                                        <div className="col-12 col-xl-5 pl-2">
                                            <SelectBox
                                                dataSource={this.fasterPaymentDataSource}
                                                displayExpr="value"
                                                valueExpr="value"
                                                onValueChanged={this.handleChangeFasterPaymentTypeSelect}
                                                value={
                                                    this.state.editViewDataItem.fasterPayment != null &&
                                                    (this.state.editViewDataItem.fasterPayment == true ||
                                                        this.state.editViewDataItem.fasterPayment.toString() ==
                                                            "true" ||
                                                        this.state.editViewDataItem.fasterPayment.toString() == "Yes")
                                                        ? "Yes"
                                                        : "No"
                                                }
                                                disabled={
                                                    this.state.readOnlyView ||
                                                    this.editAllowed ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-7 text-left text-xl-right">
                                            Faster Payment Withdrawn
                                        </label>
                                        <div className="col-12 col-xl-5 pl-0">
                                            <SelectBox
                                                dataSource={this.fasterPaymentDataSource}
                                                displayExpr="value"
                                                valueExpr="value"
                                                onValueChanged={this.handleChangeFasterPaymentWithdrawnTypeSelect}
                                                value={
                                                    this.state.editViewDataItem.fasterPaymentWithdrawn != null &&
                                                    (this.state.editViewDataItem.fasterPaymentWithdrawn == true ||
                                                        this.state.editViewDataItem.fasterPaymentWithdrawn.toString() ==
                                                            "true" ||
                                                        this.state.editViewDataItem.fasterPaymentWithdrawn.toString() ==
                                                            "Yes")
                                                        ? "Yes"
                                                        : "No"
                                                }
                                                disabled={
                                                    this.state.readOnlyView ||
                                                    this.editAllowed ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Advanced Payment
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <SelectBox
                                        dataSource={this.advancedPaymentDataSource}
                                        displayExpr="value"
                                        valueExpr="value"
                                        onValueChanged={this.handleChangeAdvancedPaymentTypeSelect}
                                        value={
                                            this.state.editViewDataItem.advancedpayment != null &&
                                            (this.state.editViewDataItem.advancedpayment == true ||
                                                this.state.editViewDataItem.advancedpayment.toString() == "Yes")
                                                ? "Yes"
                                                : "No"
                                        }
                                        disabled={
                                            this.state.readOnlyView ||
                                            this.editAllowed ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                    />
                                </div>
                            </div>
                            <div
                                className="col-12 col-lg-2 row mx-0 pr-0 mt-3"
                            >
                                <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                    Early Pay
                                </label>
                                <div className="col-12 col-xl-6 pl-0">
                                    <SelectBox
                                        dataSource={this.earlyPayDataSource}
                                        displayExpr="value"
                                        valueExpr="value"
                                        onValueChanged={this.handleChangeEarlyPayTypeSelect}
                                        value={
                                            this.state.editViewDataItem.earlyPay != null &&
                                            (this.state.editViewDataItem.earlyPay == true ||
                                                this.state.editViewDataItem.earlyPay.toString() == "Yes")
                                                ? "Yes"
                                                : "No"
                                        }
                                        disabled={
                                            this.state.readOnlyView ||
                                            this.editAllowed ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust)
                                        }
                                    />
                                </div>
                            </div>
                                <div className="col-12 col-lg-2 row mx-0 pr-0 mt-3">
                                    <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                        Charging Type
                                    </label>
                                    <div className="col-12 col-xl-6 pl-0">
                                        {/* <SelectBox
                                            dataSource={this.activityTypeDataSource}
                                            displayExpr="value"
                                            valueExpr="id"
                                            onValueChanged={this.handleChangeChargingType}
                                            value={this.state.editViewDataItem.chargingTypeId}
                                        /> */}
                                        <DropDownFromLookupTableDynamic
                                            lookupTypeIndex={LookupTypeIndexes.BillableItemChargingType}
                                            isRoot={true}
                                            parentMappingId={"0"}
                                            onValueChanged={this.handleChangeChargingType}
                                            value={this.state.editViewDataItem.chargingTypeId}
                                        />
                                        {/* <input
                                            data-testid={LookupTypeIndexes.serviceType}
                                            type="hidden"
                                            name={LookupTypeIndexes.serviceType}
                                            value={
                                                this.state.editViewDataItem.serviceTypeId
                                                    ? this.state.editViewDataItem.serviceTypeId
                                                    : ""
                                            }
                                        ></input> */}
                                    </div>
                                </div>
                        </div>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 pr-0">
                                <div className="row">
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                            Hold Payment?
                                        </label>
                                        <div className="col-12 col-xl-5 pl-2">
                                            <SelectBox
                                                dataSource={this.decisionTypesDataSource}
                                                displayExpr="value"
                                                valueExpr="value"
                                                onValueChanged={this.handleChangeHoldPayment}
                                                value={this.state.editViewDataItem.holdPayment}
                                                disabled={
                                                    this.state.readOnlyView ||
                                                    this.editAllowed ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-7 text-left text-xl-right">
                                            Pay
                                        </label>
                                        <div className="col-12 col-xl-5 pl-0">
                                            <SelectBox
                                                dataSource={this.doNotPayDataSource}
                                                displayExpr="value"
                                                valueExpr="value"
                                                onValueChanged={this.handleChangeDoNotPayTypeSelect}
                                                value={this.state.editViewDataItem.pay === true ? "Yes" : "No"}
                                                disabled={
                                                    this.state.readOnlyView ||
                                                    this.editAllowed ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 pr-0">
                                <div className="row">
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-6 text-left text-xl-right">
                                            Group Pay
                                        </label>
                                        <div className="col-12 col-xl-5 pl-2">
                                            <SelectBox
                                                dataSource={this.doNotGroupPyDataSource}
                                                displayExpr="value"
                                                valueExpr="value"
                                                onValueChanged={this.handleChangeDoNotGroupPayTypeSelect}
                                                value={this.state.editViewDataItem.groupPayment === true ? "Yes" : "No"}
                                                disabled={
                                                    this.state.readOnlyView ||
                                                    this.editAllowed ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 row mx-0 mt-3">
                                        <label className="card-form__label col-12 col-xl-7 text-left text-xl-right">
                                            Hard Approval?
                                        </label>
                                        <div className="col-12 col-xl-5 pl-2">
                                            <SelectBox
                                                dataSource={this.decisionTypesDataSource}
                                                displayExpr="value"
                                                valueExpr="value"
                                                onValueChanged={this.handleChangeHardApproval}
                                                value={this.state.editViewDataItem.hardApproval}
                                                disabled={
                                                    this.state.readOnlyView ||
                                                    this.editAllowed ||
                                                    (this.props.location &&
                                                        this.props.location.state &&
                                                        this.props.location.state.isAdjust)
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Bill Period
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <TextBox disabled={true} value={this.state.editViewDataItem.billPeriod}></TextBox>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }
    };
    renderAccrualPanel = () => {
        var readOnlyView: boolean = false;
        if (this.props.location && this.props.location.state && this.props.location.state.isReadOnly) {
            readOnlyView = this.props.location.state.isReadOnly;
        }
        var disableViewBillingLink: boolean = false;
        if (!this.state.editViewDataItem.invoiceId) {
            disableViewBillingLink = true;
        }
        if (this.state.isLoadFinancialPanel) {
            return (
                <section className="card card-form my-5">
                    <div className="card-body">
                        <h3 className="card-form__section-heading">Accruals</h3>
                        <hr className="horizontal_border_style"></hr>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Status
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <DropDownFromLookupTable
                                        lookupTypeIndex={LookupTypeIndexes.accrualStatus}
                                        onValueChanged={this.handleChangeAccrualStatusTypeSelect}
                                        signal={this.state.createAdjustment}
                                        disableSignal={
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAmend) ||
                                            this.state.isDisableStatusDropDown ||
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust) ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isEdit)
                                        }
                                        value={
                                            this.state.editViewDataItem.accrual &&
                                            this.state.editViewDataItem.accrual.accrualStatusId
                                                ? this.state.editViewDataItem.accrual.accrualStatusId.toString()
                                                : ""
                                        }
                                    />
                                    <input
                                        data-testid={LookupTypeIndexes.accrualStatus}
                                        type="hidden"
                                        name={LookupTypeIndexes.accrualStatus}
                                        value={
                                            this.state.editViewDataItem.accrual
                                                ? this.state.editViewDataItem.accrual.accrualStatusId
                                                : 0
                                        }
                                    ></input>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Bill Date
                                </label>
                                <div className="col-12 col-xl-5 pl-0">
                                    <DateBox
                                        // onValueChanged={this.handleChangeBillDate}
                                        useMaskBehavior={true}
                                        displayFormat="dd/MM/yyyy"
                                        value={
                                            this.state.editViewDataItem.accrualBillableItemBillDate
                                                ? this.state.editViewDataItem.accrualBillableItemBillDate
                                                : undefined
                                        }
                                        disabled={
                                            readOnlyView ||
                                            !this.state.isClickedOnEdit ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust) ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isEdit)
                                        }
                                    />
                                </div>
                                <div className="col-12 col-xl-4 pl-0 mt-3 mt-xl-0">
                                    <Link
                                        to={{
                                            pathname: "/BillingPageV2",
                                            state: {
                                                id: this.state.editViewDataItem.invoiceId
                                                    ? this.state.editViewDataItem.invoiceId.toString()
                                                    : "",
                                            },
                                        }}
                                    >
                                        <button
                                            className="btn btn-primary btn--small"
                                            disabled={disableViewBillingLink}
                                        >
                                            View Bill
                                        </button>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Accrual Item ID
                                </label>
                                <div className="col-12 col-xl-5 pl-0">
                                    <TextBox
                                        value={
                                            this.state.editViewDataItem.accrual &&
                                            this.state.editViewDataItem.accrual.id
                                                ? this.state.editViewDataItem.accrual.id.toString()
                                                : ""
                                        }
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-12 col-xl-4 pl-0 mt-3 mt-xl-0">
                                    <Link
                                        onClick={() =>
                                            this.viewSimpleShiftsForService(this.state.editViewDataItem.serviceTypeId)
                                        }
                                        to={{
                                            pathname: "/simpleShifts",
                                            state: {
                                                id: this.state.editViewDataItem.billableItemId,
                                            },
                                        }}
                                    >
                                        <button className="btn btn-primary btn--small">View Item</button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Provider NET
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeProviderPayAccrualAmount}
                                        valueChangeEvent="keyup"
                                        value={
                                            this.state.editViewDataItem.accrual
                                                ? this.state.editViewDataItem.accrual.providerPayAmountAccrual
                                                : 0
                                        }
                                        disabled={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust) ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isEdit)
                                        }
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Event NET
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeFeeAccrualAmount}
                                        valueChangeEvent="keyup"
                                        value={
                                            this.state.editViewDataItem.accrual
                                                ? this.state.editViewDataItem.accrual.grossProfitAmountAccrual
                                                : 0
                                        }
                                        disabled={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust) ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isEdit)
                                        }
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Client NET
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        onValueChanged={this.handleChangeBillAccrualAmount}
                                        valueChangeEvent="keyup"
                                        value={
                                            this.state.editViewDataItem.accrual
                                                ? this.state.editViewDataItem.accrual.clientBillableAmountAccrual
                                                : 0
                                        }
                                        disabled={
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust) ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isEdit)
                                        }
                                        onContentReady={this.onContentReadyNumberBox}
                                        step={0}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Provider VAT
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={
                                            this.state.editViewDataItem.accrual
                                                ? this.state.editViewDataItem.accrual.providerPayAmountTaxAccrual
                                                : 0
                                        }
                                        disabled={
                                            !this.state.isProviderTaxFieldVisible ||
                                            this.editAllowed ||
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust) ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isEdit)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Event VAT
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={
                                            this.state.editViewDataItem.accrual
                                                ? this.state.editViewDataItem.accrual.grossProfitAmountTaxAccrual
                                                : 0
                                        }
                                        disabled={
                                            !this.state.isFeeTaxFieldVisible ||
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust) ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isEdit)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Client VAT
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={
                                            this.state.editViewDataItem.accrual
                                                ? this.state.editViewDataItem.accrual.clientBillableAmountTaxAccrual
                                                : 0
                                        }
                                        disabled={
                                            !this.state.isBillClientTaxFieldVisible ||
                                            this.state.readOnlyView ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isAdjust) ||
                                            (this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.isEdit)
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0">
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Provider GROSS
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={
                                            this.state.editViewDataItem.accrual
                                                ? this.state.editViewDataItem.accrual.providerPayAmountTotalAccrual
                                                : 0
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Event GROSS
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={
                                            this.state.editViewDataItem.accrual
                                                ? this.state.editViewDataItem.accrual.grossProfitAmountTotalAccrual
                                                : 0
                                        }
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                                <label className="card-form__label col-12 col-xl-3 text-left text-xl-right">
                                    Client GROSS
                                </label>
                                <div className="col-12 col-xl-9 pl-0">
                                    <NumberBox
                                        disabled={true}
                                        format={{
                                            type: "currency",
                                            precision: 2,
                                            currency: "GBP",
                                        }}
                                        value={
                                            this.state.editViewDataItem.accrual
                                                ? this.state.editViewDataItem.accrual.clientBillableAmountTotalAccrual
                                                : 0
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }
    };

    getCreatedAndUpdatedString = () => {
        let finalString = "";
        if (this.state.editViewDataItem.dateCreated) {
            let formattedDate = moment.utc(this.state.editViewDataItem.dateCreated).format("Do MMM YYYY HH:mm:ss");
            let createdBy = "";
            if (this.state.editViewDataItem.createdBy) {
                createdBy = this.state.editViewDataItem.createdBy;
            }
            finalString = `Created On ${formattedDate} ${createdBy ? `by ${createdBy}` : ""}`;
        }
        if (this.state.editViewDataItem?.clientAmendDateTime) {
            if (finalString) {
                finalString += " / ";
            }
            let formattedDate = moment(this.state.editViewDataItem.clientAmendDateTime).format("Do MMM YYYY HH:mm:ss");
            finalString += `Client Amend Date - ${formattedDate}`;
        }
        if (this.state.editViewDataItem.lastUpdatedOnTZ) {
            if (finalString) {
                finalString += " / ";
            }
            let formattedDate = moment(this.state.editViewDataItem.lastUpdatedOnTZ).format("Do MMM YYYY HH:mm:ss");
            let updatedBy = "";
            if (this.state.editViewDataItem.lastUpdatedBy) {
                updatedBy = this.state.editViewDataItem.lastUpdatedBy;
            }
            finalString += `Last Updated On ${formattedDate} ${updatedBy ? `by ${updatedBy}` : ""}`;
        }
        if (finalString) {
            finalString = ` (${finalString})`;
        }
        return finalString;
    };

    getDateCreatedSection = () => {
        let show = false;
        if (UserService.isUserInGroup(RoleGroupNames.EventUKSeniorManager)) {
            show = true;
        }
        if (show) {
            return (
                <div className="col-12 col-lg-4 row mx-0 pr-0 mt-3">
                    <div className="row">
                        <div className="mx-0 mt-3">
                            <label className="card-form__label text-left text-xl-right">Date Created</label>
                        </div>
                        <div className="col-12 col-xl mx-0 mt-3">
                            <DateBox
                                // type='datetime'
                                type="date"
                                useMaskBehavior={true}
                                displayFormat="dd/MM/yyyy"
                                onValueChanged={this.onHandleDateCreated}
                                value={
                                    this.state.editViewDataItem.dateCreated_UI
                                        ? this.state.editViewDataItem.dateCreated_UI
                                        : undefined
                                }
                                onContentReady={this.onContentReadyDateBox}
                            />
                        </div>
                        <div className="col-12 col-xl mx-0 mt-3">
                            <DateBox
                                type="time"
                                interval={15}
                                placeholder="00:00"
                                useMaskBehavior={true}
                                displayFormat={"HH:mm"}
                                onValueChanged={this.handleChangeDateCreatedTime}
                                value={
                                    this.state.editViewDataItem.dateCreatedTime
                                        ? this.state.editViewDataItem.dateCreatedTime
                                        : undefined
                                }
                                onContentReady={this.onContentReadyDateBox}
                            />
                        </div>
                    </div>
                </div>
            );
        }
        return;
    };

    onHandleDateCreated = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            //let dateValue = new Date(dxValueChange.value).toJSON();
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    dateCreated_UI: dxValueChange.value,
                },
            }));
        }
    };

    handleChangeDateCreatedTime = (dxValueChange: DateBoxOnValueChangedEvent) => {
        if (dxValueChange.event !== undefined) {
            //let dateValue = new Date(dxValueChange.value).toJSON();
            this.setState((prevState: any) => ({
                editViewDataItem: {
                    ...prevState.editViewDataItem,
                    dateCreatedTime: dxValueChange.value,
                },
            }));
        }
    };

    renderButtonSection = () => {
        return (
            <>
                <section>
                    {this.state.isDisableApplyButton ? (
                        <span className="unscheduled-shift">
                            {this.state.onlyViewMessage.length > 0 ? this.state.onlyViewMessage[0] : null}
                        </span>
                    ) : null}
                    {this.state.IsShowSuccess ? <span className="text-success">Data Saved Successfully!</span> : null}
                    {this.state.IsShowError && this.state.errorMessage != null ? (
                        <span className="unscheduled-shift">
                            <ul>
                                {this.state.errorMessage.map((item: any, uniqueKey: number) => {
                                    return (
                                        <li key={uniqueKey}>
                                            {item.columnName}: {item.errorMessage}
                                        </li>
                                    );
                                })}
                            </ul>
                        </span>
                    ) : null}
                    {this.state.validationMessage != "" ? (
                        <>
                            {" "}
                            <br />{" "}
                            <span className="text-danger font-weight-bold justify-content-center">
                                {this.state.validationMessage}
                            </span>{" "}
                        </>
                    ) : null}
                </section>
                <section className="card-form">
                    {this.state.editViewDataItem.billableItemId !== "" ? (
                        <>
                            <div className="row">
                                <div className="col-12 col-lg row mx-0 pr-0 mt-3">
                                    <b>
                                        {" "}
                                        <div className="mx-4 mt-3">
                                            ID : {this.state.editViewDataItem.billableItemId}{" "}
                                            {this.getCreatedAndUpdatedString()}
                                        </div>{" "}
                                    </b>
                                </div>
                                {this.getDateCreatedSection()}
                            </div>
                        </>
                    ) : null}
                </section>
                <section className="card-form__button-container">
                    {this.state.readOnlyView ? null : (
                        <div className="col-12 col-lg-4 col-xl-2">
                            <button
                                className="btn btn-primary btn--large mt-3"
                                disabled={this.state.isDisableApplyButton || this.state.disabledApplybutton}
                                type="submit"
                                onClick={(e: MouseEvent) => {
                                    e.preventDefault();
                                    this.checkAmounts();
                                }}
                            >
                                <span className="btn__icon">
                                    <FontAwesomeIcon icon={faCheck} />
                                </span>
                                {this.props.location && this.props.location.state && this.props.location.state.isAdjust
                                    ? "Create Adjustment"
                                    : "Apply"}
                            </button>
                        </div>
                    )}
                    <div className="col-12 col-lg-4 col-xl-2">
                        <button
                            className="btn btn--ghost btn--ghost--teal btn--large mt-3"
                            onClick={(e: MouseEvent) => {
                                e.preventDefault();
                                this.onCancel();
                            }}
                        >
                            Close
                        </button>
                    </div>
                    <div className="col-12 col-lg-4 col-xl-2">
                        <button
                            className="btn btn--ghost btn--ghost--teal btn--large mt-3"
                            onClick={(e: MouseEvent) => {
                                e.preventDefault();
                                this.onSubmitQuery();
                            }}
                        >
                            <span className="btn__icon">
                                <FontAwesomeIcon icon={faQuestion} />
                            </span>
                            Raise Query
                        </button>
                    </div>
                    <div className="col-12 col-lg-4 col-xl-2">
                        <button
                            disabled={this.state.editViewDataItem.billableItemId===""}
                            className="btn btn--ghost btn--ghost--teal btn--large mt-3"
                            onClick={(e: MouseEvent) => {
                                e.preventDefault();
                                this.setState({
                                    showReversalPopupTab1: true,
                                });
                            }}
                        >
                            Create Provider Reversal
                        </button>
                    </div>
                    {this.state.getGigPromotionByBillableItemId.length>0 && (<div className="col-12 col-lg-4 col-xl-2">
                        <button
                            disabled={this.state.editViewDataItem.billableItemId===""}
                            className="btn btn--ghost btn--ghost--teal btn--large mt-3"
                            onClick={(e: MouseEvent) => {
                                e.preventDefault();
                                this.setState({
                                    showPromotionPopUp: true,
                                });
                            }}
                        >
                            View Promotion
                        </button>
                    </div>)}
                </section>
            </>
        );
    };

    onClickEdit = () => {
        this.setState({
            readOnlyView: false,
        });
    };
    updateParentRelatedId = (id:string)=>{
        this.setState({
            parentRelatedId:id
        })
    }
    //#region render Component
    render() {
        let mockedLocation1 = {
            pathname: "/FinanceAdjustmentPopUp",
            state: {
                pointOfNavigation: "CREATE REVERSAL",
                headerId: "",
                adjustment: true,
                isEdit: false,
                isReadOnly: false,
                editViewDataItem: this.state.editViewDataItem,
            },
        };
        if (this.state.showReversalPopupTab1) {
            mockedLocation1 = {
                pathname: "/FinanceAdjustmentPopUp",
                state: {
                    pointOfNavigation: "CREATE REVERSAL",
                    headerId: "",
                    adjustment: true,
                    isEdit: false,
                    isReadOnly: false,
                    editViewDataItem: this.state.editViewDataItem,
                },
            };

            // use mockedLocation after ensuring the data is ready
        }

        var mockedHistory1: any = {
            push: () => {},
            goBack: () => this.setState({ showReversalPopupTab1: false }),
        };
        let mockedLocation2 = {
            pathname: "/FinanceAdjustmentPopUp",
            state: {
                pointOfNavigation: "CREATE REPLACEMENT",
                headerId: "",
                adjustment: true,
                isEdit: false,
                isReadOnly: false,
                editViewDataItem: this.state.editViewDataItem,
            },
        };
        if (this.state.showReversalPopupTab1) {
            mockedLocation2 = {
                pathname: "/FinanceAdjustmentPopUp",
                state: {
                    pointOfNavigation: "CREATE REPLACEMENT",
                    headerId: "",
                    adjustment: true,
                    isEdit: false,
                    isReadOnly: false,
                    editViewDataItem: this.state.editViewDataItem,
                },
            };

            // use mockedLocation after ensuring the data is ready
        }

        var mockedHistory2: any = {
            push: () => {},
            goBack: () => this.setState({ showReversalPopupTab1: false }),
        };
        var editAllowed: boolean = false;
        if (
            this.state.editViewDataItem.editAllowed == "True" &&
            this.state.readOnlyView &&
            (UserService.isUserInGroup(RoleGroupNames.EventUKSeniorManager) ||
                UserService.isUserInGroup(RoleGroupNames.EventUKRelationshipManager))
        ) {
            editAllowed = false;
        } else {
            editAllowed = true;
        }
        var pageTitle: string = "";
        if (this.props.location) {
            if (this.props.location.state && this.props.location.state.id == 0) {
                pageTitle = "Manage Shifts - Add";
            } else if (this.props.location.state && this.props.location.state.isAdjust) {
                pageTitle = "Manage Shifts - Adjustment";
            } else if (
                (this.props.location.state && this.props.location.state.isEdit) ||
                (!this.state.readOnlyView && this.props.location.state && !this.props.location.state.isMasterEdit)
            ) {
                pageTitle = "Manage Shifts - Edit";
            } else if (this.state.readOnlyView) {
                pageTitle = "Manage Shifts - View";
            } else if (this.props.location.state && this.props.location.state.isMasterEdit) {
                pageTitle = "Manage Shifts - Master Edit";
            }
        }
        return (
            <LightModePageTemplate>
                <div className="page-content">
                    <div className="col-12">
                        <h3 className="card-form__page-heading">{pageTitle}</h3>
                        <section className="card-form__button-container px-2" hidden={this.state.loadPopupVisible}>
                            <div className="col-12 col-lg-4 col-xl-6"></div>
                            <div className="col-12 col-lg-4">
                                <div className="row p-3 p-xl-0">
                                    <label className="card-form__label col-12 col-lg-4 text-left text-xl-right">
                                        Item Type
                                    </label>
                                    <div className="col-12 col-lg-8 pl-0">
                                        <SelectBox
                                            disabled={true}
                                            dataSource={this.state.itemTypeLookUp}
                                            displayExpr="value"
                                            valueExpr="id"
                                            value={
                                                this.props.location &&
                                                this.props.location.state &&
                                                this.props.location.state.id == 0 &&
                                                this.state.itemTypeLookUp.length > 0 &&
                                                this.state.isTypeChanged == false
                                                    ? this.state.itemTypeLookUp[0].id
                                                    : this.state.editViewDataItem.itemTypeId
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className="row" hidden={this.state.loadPopupVisible}>
                            <div className="w-50 mx-auto">
                                <LoadIndicator
                                    id="load-indicator"
                                    className="load-indicator--centered"
                                    height={50}
                                    width={50}
                                    visible={!this.state.isLoadFinancialPanel}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="w-50 mx-auto">
                                <LoadIndicator
                                    id="load-indicator"
                                    className="load-indicator--centered"
                                    height={50}
                                    width={50}
                                    visible={this.state.loadPopupVisible}
                                />
                            </div>
                        </div>
                        <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={this.state.loadPanelVisible} />
                        <section hidden={this.state.loadPopupVisible}>
                            {this.renderPersonnelShiftPanel()}
                            {this.renderEquipmentShiftPanel()}
                            {this.renderWeeklyCleaningShiftPanel()}
                            {this.renderAdditionalCleaningShiftPanel()}
                            {this.renderEntertainmentShiftPanel()}
                            {this.renderPersonnelAdjustmentPanel()}
                            {this.renderEquipmentAdjustmentPanel()}
                            {this.renderWeeklyCleaningAdjustmentPanel()}
                            {this.renderEntertainmentAdjustmentPanel()}
                            {this.renderFinancialPanel()}
                            {this.state.editViewDataItem?.isAccrual?.toString() == "Yes" ||
                            this.state.editViewDataItem.isAccrual == true ? (
                                this.renderAccrualPanel()
                            ) : (
                                <></>
                            )}
                            {this.renderButtonSection()}
                        </section>
                        <Popup
                            visible={this.state.showWarningPopup}
                            onHiding={this.hideWarningPopup}
                            dragEnabled={false}
                            hideOnOutsideClick={true}
                            showTitle={true}
                            showCloseButton={true}
                            title={"WARNING: ZERO AMOUNTS"}
                            resizeEnabled={true}
                            width={"30%"}
                            height={300}
                        >
                            <ScrollView width="100%" height="100%">
                                <div>
                                    <div className="text-center">
                                        Zero Amounts are present - please continue if expected otherwise please correct?
                                    </div>
                                    <div className="text-center pt-3">
                                        <b>Provider Net</b> is{" "}
                                        {this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy == 0 ? (
                                            <b className="color-red">
                                                £{this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy}
                                            </b>
                                        ) : (
                                            <b>£{this.state.editViewDataItem.provider_Pay_Amount_Local_Ccy}</b>
                                        )}
                                    </div>
                                    <div className="text-center pt-3">
                                        <b>Fee Net</b> is{" "}
                                        {this.state.editViewDataItem.fee_Amount_Local_Ccy == 0 ? (
                                            <b className="color-red">
                                                £{this.state.editViewDataItem.fee_Amount_Local_Ccy}
                                            </b>
                                        ) : (
                                            <b>£{this.state.editViewDataItem.fee_Amount_Local_Ccy}</b>
                                        )}
                                    </div>
                                    <div className="text-center pt-3">
                                        <b>Client Net</b> is{" "}
                                        {this.state.editViewDataItem.client_Billable_Amount_Local_Ccy == 0 ? (
                                            <b className="color-red">
                                                £{this.state.editViewDataItem.client_Billable_Amount_Local_Ccy}
                                            </b>
                                        ) : (
                                            <b>£{this.state.editViewDataItem.client_Billable_Amount_Local_Ccy}</b>
                                        )}
                                    </div>
                                </div>
                                <div className="row px-3">
                                    <div className="col-12 col-xl-6 pl-0">
                                        <button
                                            className="btn btn-primary btn--large mt-3"
                                            type="submit"
                                            onClick={(e: MouseEvent) => {
                                                e.preventDefault();
                                                this.onSubmitFromPopUp();
                                            }}
                                        >
                                            CONTINUE?
                                        </button>
                                    </div>
                                    <div className="col-12 col-xl-6 pl-0">
                                        <button
                                            className="btn btn--ghost btn--ghost--teal btn--large mt-3"
                                            onClick={(e: MouseEvent) => {
                                                e.preventDefault();
                                                this.hideWarningPopup();
                                            }}
                                        >
                                            CLOSE
                                        </button>
                                    </div>
                                </div>
                            </ScrollView>
                        </Popup>
                        <Popup
                            visible={this.state.createClientCreditPopUp}
                            onHiding={this.hideCreateClientCreditPopUp}
                            dragEnabled={false}
                            hideOnOutsideClick={true}
                            showTitle={true}
                            showCloseButton={true}
                            title={"CONFIRM: Would you like to create Client Credit"}
                            resizeEnabled={true}
                            width={"33%"}
                            height={350}
                        >
                            <ScrollView width="100%" height="100%">
                                <div>
                                    <div>
                                        Amounts have been calculated as below - edit any changes required and click
                                        CREATE
                                    </div>
                                    <div className="d-flex align-items-center pt-3">
                                        <label style={{ width: "20%" }}>
                                            <b>Provider Net</b>
                                        </label>
                                        <NumberBox
                                            format={{
                                                type: "currency",
                                                precision: 2,
                                                currency: "GBP",
                                            }}
                                            onValueChanged={this.handleChangeProviderLocalCurrancyAmount}
                                            valueChangeEvent="keyup"
                                            value={0}
                                            disabled={true}
                                            onContentReady={this.onContentReadyNumberBox}
                                            step={0}
                                            stylingMode="outlined"
                                            width="80%"
                                        />
                                    </div>

                                    {/* Single Row for Fee Net */}
                                    <div className="d-flex align-items-center pt-3">
                                        <label style={{ width: "20%" }}>
                                            <b>Event Net</b>
                                        </label>
                                        <NumberBox
                                            format={{
                                                type: "currency",
                                                precision: 2,
                                                currency: "GBP",
                                            }}
                                            onValueChanged={this.handleChangeFeeLocalCurrancyAmount}
                                            valueChangeEvent="keyup"
                                            value={0}
                                            disabled={true}
                                            onContentReady={this.onContentReadyNumberBox}
                                            step={0}
                                            stylingMode="outlined"
                                            width="80%"
                                        />
                                    </div>

                                    {/* Single Row for Client Net */}
                                    <div className="d-flex align-items-center pt-3">
                                        <label style={{ width: "20%" }}>
                                            <b>Client Net</b>
                                        </label>
                                        <NumberBox
                                            format={{
                                                type: "currency",
                                                precision: 2,
                                                currency: "GBP",
                                            }}
                                            onValueChanged={this.handleChangeBillLocalCurrancyAmountForFiancialAdj}
                                            valueChangeEvent="keyup"
                                            value={-this.state.clientOriginalAmountForFinancialAdj}
                                            disabled={
                                                this.state.readOnlyView ||
                                                (this.props.location &&
                                                    this.props.location.state &&
                                                    this.props.location.state.isAdjust)
                                            }
                                            onContentReady={this.onContentReadyNumberBox}
                                            step={0}
                                            stylingMode="outlined"
                                            width="80%"
                                        />
                                    </div>
                                </div>

                                <div className="row px-3">
                                    <div className="col-12 col-xl-6 pl-0">
                                        <button
                                            className="btn--link btn btn-primary btn--large mt-3"
                                            onClick={(e: React.MouseEvent) => {
                                                e.preventDefault();
                                                this.hideCreateClientCreditPopUp();
                                                this.onSubmit();
                                                this.props.history.push({
                                                    pathname: "/FinanceAdjustmentPopUp",
                                                    state: {
                                                        pointOfNavigation:
                                                            this.props.location.state?.pointOfNavigation ===
                                                            "ManageShifts"
                                                                ? "manageshifts"
                                                                : "simpleshifts",
                                                        id: "",
                                                        headerId: "",
                                                        adjustment: true,
                                                        isEdit: false,
                                                        editViewDataItem: {
                                                            ...this.state.editViewDataItem,
                                                            client_Billable_Amount_Local_Ccy: this.state
                                                                .clientOriginalAmountForFinancialAdj,
                                                        },
                                                        filterStartDate: this.props.location.state?.filterStartDate,
                                                        filterEndDate: this.props.location.state?.filterEndDate,
                                                    },
                                                });
                                            }}
                                        >
                                            CREATE
                                        </button>

                                        {/* </div> */}
                                        {/* <button
                    className="btn btn-primary btn--large mt-3"
                    type="submit"
                    onClick={(e: MouseEvent) => {
                        e.preventDefault();
                        this.hideCreateClientCreditPopUp();
                    }}
                >
                    CREATE
                </button> */}
                                    </div>
                                    <div className="col-12 col-xl-6 pl-0">
                                        <button
                                            className="btn btn--ghost btn--ghost--teal btn--large mt-3"
                                            onClick={(e: MouseEvent) => {
                                                e.preventDefault();
                                                this.hideCreateClientCreditPopUp();
                                                this.onSubmit();
                                                this.handleNotRequiredClick();
                                            }}
                                        >
                                            NOT REQUIRED
                                        </button>
                                    </div>
                                </div>
                            </ScrollView>
                        </Popup>
                        {this.state.showReversalPopupTab1 && (<Popup
                            visible={this.state.showReversalPopupTab1}
                            onHiding={this.closeAllPopUp}
                            dragEnabled={false}
                            hideOnOutsideClick={true}
                            showTitle={true}
                            showCloseButton={true}
                            title={"PROVIDER REVERSAL PROCESS - STEP 1 - CREATE REVERSAL"}
                            resizeEnabled={true}
                            width={"90%"}
                            height={"80%"}
                        >
                            <ScrollView width="100%" height="100%">
                                <div>
                                    <FinanceAdjustmentForm
                                        location={mockedLocation1}
                                        history={mockedHistory1}
                                        closeAllPopUp={this.closeAllPopUp}
                                        continueAndNext={this.hideProviderReversalPopup1}
                                        updateParentRelatedId={this.updateParentRelatedId}
                                    />
                                </div>
                            </ScrollView>
                        </Popup>)}
                        {this.state.showReversalPopupTab2 && (<Popup
                            visible={this.state.showReversalPopupTab2}
                            onHiding={this.hideProviderReversalPopup2}
                            dragEnabled={false}
                            hideOnOutsideClick={true}
                            showTitle={true}
                            showCloseButton={true}
                            title={"PROVIDER REVERSAL PROCESS - STEP 2 - CREATE REPLACEMENT"}
                            resizeEnabled={true}
                            width={"90%"}
                            height={"80%"}
                        >
                            <ScrollView width="100%" height="100%">
                                <div>
                                    <FinanceAdjustmentForm
                                        location={mockedLocation2}
                                        history={mockedHistory2}
                                        closeAllPopUp={this.closeAllPopUp2}
                                        continueAndFinish={this.handleFinishProviderReversal}
                                        parentRelatedId={this.state.parentRelatedId}
                                    />
                                </div>
                            </ScrollView>
                        </Popup>)}
                        {this.state.showPromotionPopUp && (<Popup
                            visible={this.state.showPromotionPopUp}
                            onHiding={this.hideShowPromotionPopUp}
                            dragEnabled={false}
                            hideOnOutsideClick={true}
                            showTitle={true}
                            showCloseButton={true}
                            title={"PROMOTION TEMPLATES"}
                            resizeEnabled={true}
                            width={"75%"}
                            height={"65%"}
                        >
                            <ScrollView width="100%" height="100%">
                                <div className="image-grid">
                                    {this.state.getGigPromotionByBillableItemId.map((item:any)=>
                                        <div className="image-card">
                                            <img
                                                src={item.promotionLink}
                                                alt="promotion"
                                            />
                                            <div className="mt-2">
                                                <span className="card-form__subheading">Id : </span>{item.id}
                                            </div>
                                            <div className="mt-2">
                                                <span className="card-form__subheading">Promotion Template Id : </span>{item.promotionTemplateId}
                                            </div>
                                            <div className="mt-2">
                                                <span className="card-form__subheading">Performer Name : </span>{item.performerName}
                                            </div>
                                            <div className="mt-2">
                                                <span className="card-form__subheading">Event Title : </span>{item.eventTitle}
                                            </div>
                                            <div className="mt-2">
                                                <span className="card-form__subheading">Venue : </span>{item.venue}
                                            </div>
                                            <div className="mt-2">
                                                <span className="card-form__subheading">Date : </span>{item.date}
                                            </div>
                                            <div className="mt-2">
                                                <span className="card-form__subheading">Time : </span>{item.time}
                                            </div>
                                            <div className="mt-2">
                                                <span className="card-form__subheading">Live Date : </span>{item.liveDateTo && 
                                                item.liveDateTo!=item.liveDateFrom
                                                ? `${item.liveDateFrom} - ${item.liveDateTo}`
                                                : item.liveDateFrom}
                                            </div>
                                            <div className="mt-2">
                                                <span className="card-form__subheading">Last Updated On : </span>{item.lastUpdatedOn}
                                            </div>
                                            <div className="mt-2">
                                                <span className="card-form__subheading">Last Updated By : </span>{item.lastUpdatedBy}
                                            </div>
                                            <div className="mt-2">
                                                <span className="card-form__subheading">Promotion Invoice Status : </span>{item.billableItemPromotionInvoiceStatus}
                                            </div>
                                            <div className="mt-2">
                                                <span className="card-form__subheading">Promotion Billable Item Id : </span>{item.promotionTemplateId}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </ScrollView>
                        </Popup>)}
                    </div>
                </div>
            </LightModePageTemplate>
        );
    }
}

//#endregion

export default withTranslation()(AddEditFormV2);
